/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface OAuth2Client {
  /** ID for the OAuth2 client */
  id?: string;
  /** Name of the OAuth2 client */
  name?: string;
  /** URL to the OAuth2 client's privacy policy */
  privacy_policy_url?: string;
  /** URL to the OAuth2 client's terms of service */
  terms_url?: string;
  /** URL to the OAuth2 client's icon */
  icon?: string;
  /** Whether the OAuth2 client is trusted */
  trusted?: boolean;
}

export interface GetOAuth2ClientResponse {
  oauth2_client?: OAuth2Client;
}

/**
 * Actor
 * describes a user or robot that created or updated a resource
 */
export interface Actor {
  /** @example "uDsu0j19" */
  user_id?: string;
  /**
   * @default "user"
   * @example "user"
   */
  type: "user" | "robot" | "system";
  /** describes the source of an actor */
  source?: ActorSource;
}

/**
 * ActorSource
 * describes the source of an actor
 */
export interface ActorSource {
  /** @example "oauth" */
  type?: "oauth" | "import" | "email" | "agent";
  /**
   * client ID if the resource was created via oauth2 app
   * @example "oczapier"
   */
  client_id?: string;
  /**
   * import ID if the resource was created by an import
   * @example "bf1b9f76-3f95-42fc-bd7f-050b2f5f4197"
   */
  import_id?: string;
  /**
   * agent ID if the resource was created by an agent
   * @example "bf1b9f76-3f95-42fc-bd7f-050b2f5f4197"
   */
  agent_id?: string;
  /**
   * email address if the resource was created via an email
   * @example "somebody@example.com"
   */
  email_addr?: string;
  /**
   * whether the email sender was verified
   * @example false
   */
  email_verified?: boolean;
}

/** RobotUser */
export interface RobotUser {
  /** @example "urgh0001" */
  id?: string;
  /** @example "GitHub" */
  display_name?: string;
  profile_image?: string;
}

/** User */
export interface User {
  /** @example "u-dsu0j19" */
  id?: string;
  /** @example "user@example.com" */
  email?: string;
  /** @example true */
  email_confirmed?: boolean;
  /** @example "John" */
  first_name?: string;
  /** @example "Smith" */
  last_name?: string;
  /** @example "pete" */
  display_name?: string;
  /** @example "https://s3..../avatar.png" */
  profile_image?: string;
  /** @example "https://s3..../avatar.png" */
  thumbnail_image?: string;
  /** @example "red" */
  color?: "red" | "darkred" | "green" | "darkgreen" | "blue" | "darkblue";
  status?: "active" | "suspended";
  teams: TeamWithRoleAndStatus[];
  /** unix timestamp in seconds */
  time_created?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  time_updated?: STime;
  current_project?: string;
  /**
   * user's timezone
   * @example "America/Los_Angeles"
   */
  timezone_id?: string;
  /**
   * whether the user's timezone is automatically set by the superthread app
   * @example true
   */
  autodetect_timezone_id?: boolean | null;
  /**
   * user's preferred locale
   * @example "en"
   */
  locale?: string;
  transcription_keywords?: string[];
  /** @example "software engineer" */
  job_description?: string;
}

export type TeamMember = User & {
  role?: TeamMemberRole;
  status?: TeamMemberStatus;
};

export interface SignupAnswers {
  /**
   * @maxLength 100
   * @example "product_manager"
   */
  role?: string | null;
  /**
   * @maxLength 100
   * @example "1-10"
   */
  team_size?: string | null;
  /** @example ["marketing","design"] */
  work_type?: string[] | null;
  /**
   * @maxLength 100
   * @example "1-10"
   */
  company_size?: string | null;
  /**
   * @maxLength 100
   * @example "startup"
   */
  company_type?: string | null;
  /** @example ["marketing","design"] */
  company_departments?: string[] | null;
}

export interface GetUserResponse {
  user?: User;
  token_outdated?: boolean;
  /** was the token used for this request privileged? privileged tokens are required for certain operations (update email) and are obtained from a fresh login (not a refresh). */
  token_privileged?: boolean;
}

export interface AddUserTeamResponse {
  accepted_invite?: TeamInviteForUser;
}

export interface GetFavouritesResponse {
  favourites?: Favourite[];
}

export interface AddFavouriteRequest {
  /**
   * id of parent folder to nest this resource under (skip for root)
   * @example "df3fcdf3-88ad-4c28-829a-dc9f94a20dfd"
   */
  parent_id?: string;
  /**
   * a position where the object should be placed in the folder. omitting will append at the end.
   * @example 3
   */
  position?: number | null;
  /** @example "My card" */
  title: string;
  /**
   * type of the resource that's added
   * @example "card"
   */
  resource_type: "board" | "card" | "page" | "view" | "sprint" | "member" | "folder" | "epic";
  /**
   * id of the resource that's added (does not apply if type is 'folder')
   * @example "7"
   */
  resource_id?: string;
}

export interface AddFavouriteResponse {
  favourites?: Favourite[];
}

export interface UpdateFavouriteRequest {
  /**
   * id of parent to nest this resource under. empty string implies root.
   * @example "2"
   */
  parent_id?: string | null;
  /**
   * position where the resource should be placed in its parent
   * @example 0
   */
  position?: number | null;
  /**
   * allows
   * @example "New folder title"
   */
  title?: string | null;
}

export interface UpdateUserRequest {
  /** @example "John" */
  first_name?: string | null;
  /** @example "Smith" */
  last_name?: string | null;
  /**
   * @minLength 1
   * @example "pete"
   */
  display_name?: string | null;
  /** @example "https://s3..../avatar.png" */
  profile_image?: string | null;
  /** @example "https://s3..../avatar.png" */
  thumbnail_image?: string | null;
  /** @example "#023020" */
  color?: string | null;
  signup_answers?: SignupAnswers | null;
  /** @example "America/Los_Angeles" */
  timezone_id?: TimezoneID | null;
  /** @example true */
  autodetect_timezone_id?: boolean | null;
  /** @example "en" */
  locale?: string | null;
  transcription_keywords?: string[] | null;
  /** @example "software engineer" */
  job_description?: string | null;
}

export interface UpdateUserResponse {
  user?: User;
}

export interface SendUpdateUserEmailCodeRequest {
  /**
   * new email address to send the code to
   * @example "user@domain.com"
   */
  email: string;
}

export interface UpdateUserEmailRequest {
  /**
   * this must match the address the code was sent to
   * @example "user@domain.com"
   */
  email: string;
  /**
   * code sent to new email inbox via /users/{user_id}/email/code endpoint
   * @example "123456"
   */
  code: string;
}

export interface SubmitUserSignupAnswersRequest {
  signup_answers?: SignupAnswers;
}

export interface CreateImportUsersRequest {
  import_users?: ImportUser[];
}

export interface CreateImportUsersResponse {
  /** ordered user ids */
  user_ids?: string[];
}

export interface ImportUser {
  email?: string;
  display_name?: string;
}

export interface Favourite {
  title?: string;
  project_id?: string;
  resource_type?: string;
  resource_id?: string;
  /** used for sprints */
  start_date?: STime;
  /** used for sprints */
  end_date?: STime;
  children?: Favourite[];
}

export interface GetPendingInvitesForTeamResponse {
  pending_invites?: TeamInviteForTeam[];
}

export interface GetPendingInvitesForUserResponse {
  pending_invites?: TeamInviteForUser[];
}

export interface Team {
  /** team archive status */
  archived?: Archived;
  /** @example "t-iwquhs1" */
  id?: string;
  /** @example "apple" */
  sub_domain?: string;
  /** @example "Apple Backend" */
  team_name?: string;
  /** @example "Apple Inc" */
  company_name?: string;
  /** @example "apple.com" */
  email_domain?: string;
  /** @example "u-dsu0j19" */
  creator_user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  trashed?: Trashed;
  logo?: Image;
  /** @example "free" */
  subscription_plan_id?: string;
  features?: TeamFeature[];
  limits?: TeamLimit[];
  /** @example "Technology company" */
  team_description?: string;
}

export type TeamWithRoleAndStatus = Team & {
  role?: TeamMemberRole;
  status?: TeamMemberStatus;
  /** list of feature flags enabled for the user in the team */
  flags?: string[];
};

export interface CreateTeamRequest {
  /** @example "Apple Backend" */
  team_name: string;
  /** @example "apple" */
  sub_domain?: string;
  /** @example "Apple Inc" */
  company_name?: string;
  /** @example "apple.com" */
  email_domain?: string;
}

export interface CreateTeamResponse {
  team?: Team;
}

export interface GetTeamResponse {
  team?: Team;
}

export interface UpdateTeamRequest {
  /**
   * Archive this team. Note that this is not reversible via the API
   * @example true
   */
  archived?: boolean | null;
  /** @example "apple" */
  sub_domain?: string | null;
  /** @example "Apple Backend" */
  team_name?: string | null;
  /** @example "Apple Inc" */
  company_name?: string | null;
  /** @example "apple.com" */
  email_domain?: string | null;
  team_logo?: Image | null;
  /** @example "Technology company" */
  team_description?: string | null;
}

export interface UpdateTeamResponse {
  team?: Team;
}

export interface GetTeamMembersResponse {
  members?: TeamMember[];
  invited?: TeamMember[];
  inactive?: TeamMember[];
  robots?: RobotUser[];
}

export interface UpdateTeamMemberRequest {
  role?: TeamMemberRole;
}

export interface UpdateTeamMemberResponse {
  member?: TeamMember;
}

export interface RemoveTeamMemberResponse {
  removed_member?: TeamMember;
}

export interface TeamInvite {
  /** @example "t921j9j1" */
  team_id?: string;
  /** @example "someuser@example.org" */
  invitee_email?: string;
  /** @example "ud93joids" */
  invitee_user_id?: string;
  invitee_role?: TeamMemberRole;
  invitee_status?: TeamMemberStatus;
  /** @example "ud91jdars" */
  sender_user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_accepted?: STime;
  /** @example "1" */
  redirect_project_id?: string;
}

export type TeamInviteForUser = TeamInvite & {
  /** @example "Human Resources" */
  team_name?: string;
};

export type TeamInviteForTeam = TeamInvite;

export interface CreateTeamInvitesRequest {
  /**
   * @maxItems 100
   * @minItems 1
   */
  invitees: CreateTeamInviteRequest[];
}

export interface CreateTeamInviteRequest {
  invitee_email?: string;
  /** Optional. Defaults to 'member'. */
  invitee_role?: TeamMemberRole;
  /**
   * Optional. List of project IDs to add the member to.
   * @maxItems 20
   * @uniqueItems true
   */
  project_ids?: string[];
  /**
   * Optional. Project ID to redirect the invitee to if they click the invite link. You must add the invitee to the project separately after making this request.
   * @example "1"
   */
  redirect_project_id?: string;
}

export interface CreateTeamInvitesResponse {
  team_invites?: TeamInvite[];
}

export interface DeleteTeamInvitesRequest {
  /**
   * deprecated
   * @example ["user1@example.org","user2@example.org"]
   */
  invitee_emails?: string[];
  /** @example ["u123abc","u789xyz"] */
  invitee_user_ids?: string[];
}

export interface DeleteTeamInvitesResponse {
  /** @example ["u123abc","u789xyz"] */
  deleted_invite_user_ids?: string[];
}

export interface TeamFeature {
  /** unique identifier for the feature */
  id?: string;
  /** @example true */
  enabled: boolean;
  /** unix timestamp in seconds */
  time_enabled?: STime;
  /** @example true */
  toggleable: boolean;
}

export interface GetTeamFeaturesResponse {
  features?: TeamFeature[];
  limits?: TeamLimit[];
  token_outdated?: boolean;
}

export interface SetTeamFeatureRequest {
  /** @example true */
  enabled: boolean;
}

export interface SetTeamFeatureResponse {
  feature?: TeamFeature;
}

export interface TeamLimit {
  /** unique identifier for the limit */
  id?: string;
  /** @example "2" */
  limit_value?: string;
}

export interface GetOAuthRedirectResponse {
  /** @example "https://auth.superthread.com/authorize?client_id=abc123" */
  url?: string;
}

export interface Project {
  /** @example "421" */
  id?: string;
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "My Project" */
  title?: string;
  description?: string;
  icon?: Image;
  overview_page_id?: string;
  /** @example "u-dsu0j19" */
  user_id?: string;
  /** @example "uDsu0j19" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  /** unix timestamp in seconds */
  time_expires?: STime;
  members?: Member[];
  /**
   * true if currently logged in user is a member of this project
   * @example true
   */
  is_member?: boolean;
  /** @example 7 */
  total_members: number;
  /** @example 2 */
  total_members_online: number;
  /**
   * Deprecated. Use is_private instead
   * @example true
   */
  is_public: boolean;
  /** @example true */
  is_private: boolean;
  page_order?: FlatNode[];
  pages: PageLink[];
  trashed?: Trashed;
  archive_page_order?: FlatNode[];
  archive_pages: PageLink[];
  /** string array representing an order of IDs */
  board_order?: Order;
  boards: BoardLink[];
  sprints: SprintLink[];
  estimate_system?: EstimateSystem;
}

export interface PageLink {
  id?: string;
  title?: string;
  icon?: Image;
}

export interface BoardLink {
  id?: string;
  title?: string;
}

export interface SprintLink {
  id?: string;
  title?: string;
  /** unix timestamp in seconds */
  start_date?: STime;
  /** unix timestamp in seconds */
  end_date?: STime;
}

export type GetProjectsResponse = ResponseMetadata & {
  /** string array representing an order of IDs */
  project_order?: Order;
  projects?: Project[];
  /** @example 100 */
  total_projects_count: number;
  /** @example 100 */
  total_boards_count: number;
};

export interface GetProjectResponse {
  project?: Project;
}

export interface CreateProjectRequest {
  /** @example "My Project Title" */
  title: string;
  /** @example "Project description" */
  description?: string;
  icon?: Image | null;
  /**
   * Deprecated. Use is_private instead.
   * @example false
   */
  is_public?: boolean | null;
  /** @example false */
  is_private?: boolean | null;
  /** @example "22" */
  overview_page_id?: string;
  /** @maxItems 20 */
  members?: AddMemberRequest[];
  estimate_system?: EstimateSystem;
}

export interface CreateProjectResponse {
  project?: Project;
}

export interface UpdateProjectRequest {
  /** @example "updated project title" */
  title?: string | null;
  /** @example "updated project description" */
  description?: string | null;
  icon?: Image | null;
  /** Toggle project privacy. */
  is_private?: boolean | null;
  /**
   * a position where the project should be placed in the sidebar
   * @example 3
   */
  position?: number | null;
  /** @example "22" */
  overview_page_id?: string | null;
  /**
   * pass an empty string to unset
   * @example "fibonacci"
   */
  estimate_system?: "" | "fibonacci" | "tshirt" | "exponential" | null;
}

export interface UpdateProjectResponse {
  project?: Project;
}

export interface SetProjectOwnerRequest {
  /** @example "udsu0j19" */
  user_id: string;
}

export interface Collaboration {
  /** Security token used to start a collaboration session */
  token?: string;
}

export enum CollaborationResourceType {
  Page = "page",
  Card = "card",
}

export interface Page {
  /** @example "43" */
  id?: string;
  /** @example "93738022-c193-494e-95a4-fc3e4346b5e1" */
  alias_id?: string;
  /** @example "Team Page" */
  title?: string;
  font?: Font;
  icon?: Image;
  /** @maxLength 102400 */
  content?: string;
  /** @example 1 */
  schema?: number;
  collaboration?: Collaboration;
  /** @example "1" */
  project_id?: string;
  cover_image?: CoverImage;
  /** @example "u-dsu0j19" */
  user_id?: string;
  /** @example "u-dsu0j19" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** @example "teu-dsu0j19" */
  team_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  members?: Member[];
  /** @example false */
  bookmarked: boolean;
  /** page archive status */
  archived?: ArchivedPage;
  /** @example false */
  is_public: boolean;
  public_settings?: PublicPageSettings;
  /** @example 3 */
  total_comments?: number;
  /**
   * whether current user is a watcher of this page
   * @example true
   */
  is_watching?: boolean;
  /**
   * whether current user has this page bookmarked
   * @example true
   */
  is_bookmarked?: boolean;
  /**
   * whether to show a table of contents on page
   * @example true
   */
  hide_table_of_contents?: boolean;
  /**
   * whether to show subpages section on page
   * @example true
   */
  hide_subpages?: boolean;
}

export interface PublicPageSettings {
  /** @example "https://pages.superthread.com/t/team/p/1" */
  url?: string;
  robots?: MetaRobotValue[];
}

export enum MetaRobotValue {
  All = "all",
  Index = "index",
  Follow = "follow",
  None = "none",
  Noindex = "noindex",
  Nofollow = "nofollow",
  Noimageindex = "noimageindex",
  Nosnippet = "nosnippet",
  Noarchive = "noarchive",
  Nocache = "nocache",
  Notranslate = "notranslate",
}

export interface CreatePageRequest {
  /** @example "Team Page" */
  title?: string;
  /** @maxLength 102400 */
  content?: string;
  /** @example 1 */
  schema?: number | null;
  font?: string;
  /** @example "3" */
  project_id: string;
  cover_image?: CoverImage | null;
  icon?: Image | null;
  /**
   * Parent page ID this page should be placed under. Send an empty string to place the page at the root of the project
   * @example "44"
   */
  parent_page_id?: string | null;
  /**
   * a position where the page should be placed in relation to its siblings
   * @example 3
   */
  position?: number | null;
  /** @example false */
  is_public?: boolean | null;
}

export interface CreatePageResponse {
  page?: Page;
}

export interface UpdatePageResponse {
  page?: Page;
}

export interface PageTemplate {
  /** @example "43" */
  id?: string;
  /** @example "Template title" */
  title?: string;
  icon?: Image;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "Page title" */
  page_title?: string;
  /**
   * @maxLength 102400
   * @example "Page content"
   */
  page_content?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
}

export interface GetPageTemplateResponse {
  page_template?: PageTemplate;
}

export type GetPageTemplatesResponse = ResponseMetadata & {
  page_templates?: PageTemplate[];
};

export interface CreatePageTemplateRequest {
  /** @example "Template title" */
  title: string;
  icon?: Image;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "Page title" */
  page_title: string;
  /**
   * @maxLength 102400
   * @example "Page content"
   */
  page_content: string;
}

export interface CreatePageTemplateResponse {
  page_template?: PageTemplate;
}

export interface UpdatePageTemplateRequest {
  /** @example "Template title" */
  title?: string | null;
  icon?: Image | null;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "Page title" */
  page_title?: string | null;
  /**
   * @maxLength 102400
   * @example "Page content"
   */
  page_content?: string | null;
}

export interface UpdatePageTemplateResponse {
  page_template?: PageTemplate;
}

export interface GetPageResponse {
  page?: Page;
}

export interface UpdatePageRequest {
  /** @example "Team Page" */
  title?: string | null;
  font?: string | null;
  /** @example "3" */
  project_id?: string | null;
  cover_image?: CoverImage | null;
  icon?: Image | null;
  /** @example false */
  is_public?: boolean | null;
  /**
   * Parent page ID this page should be placed under. Send an empty string to place the page at the root of the project
   * @example "44"
   */
  parent_page_id?: string | null;
  /**
   * a position where the page should be placed in relation to its siblings
   * @example 3
   */
  position?: number | null;
  public_settings?: PublicPageSettings | null;
  /**
   * make this page archived or unarchived
   * @example true
   */
  archived?: boolean | null;
  /**
   * whether to show a table of contents on page
   * @example true
   */
  hide_table_of_contents?: boolean | null;
  /**
   * whether to show subpages section on page
   * @example true
   */
  hide_subpages?: boolean | null;
}

export interface PageVersion {
  /** @example "8" */
  id?: string;
  page_id?: string;
  /** @example "Team Page" */
  title?: string;
  font?: Font;
  content?: string;
  icon?: Image;
  cover_image?: CoverImage;
  /** @example "u-dsu0j19" */
  user_id?: string;
  /** @example "u-dsu0j19" */
  user_id_updated?: string;
  /** @example "teu-dsu0j19" */
  team_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** @example false */
  is_public: boolean;
}

export interface CopyPageRequest {
  project_id: string;
  /** @example "Duplicate of ..." */
  title?: string | null;
  /**
   * Parent page ID this page should be placed under. Send an empty string to place the page at the root of the project
   * @example "44"
   */
  parent_page_id?: string | null;
  /**
   * a position where the page should be placed in relation to its siblings
   * @example 3
   */
  position?: number | null;
}

export interface CopyPageResponse {
  page?: Page;
}

export type GetPagesResponse = ResponseMetadata & {
  page_order?: FlatNode[];
  archive_page_order?: FlatNode[];
  pages?: Page[];
};

export type GetPageVersionsResponse = ResponseMetadata & {
  pageVersions?: PageVersion[];
};

export interface GetCollaborationResponse {
  collaboration?: Collaboration;
}

export interface NoteTemplate {
  /** @example "43" */
  id?: string;
  /** @example "Template title" */
  title?: string;
  /**
   * @maxLength 102400
   * @example "Template context"
   */
  context?: string;
  sections?: NoteTemplateSection[];
  /**
   * Whether to generate AI actions with this note template
   * @example true
   */
  ai_actions?: boolean;
  icon?: Image;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  is_shared?: boolean | null;
  is_favourited?: boolean | null;
}

export interface NoteTemplateSection {
  /** @example "Introduction" */
  title?: string;
  /** @example "A brief introduction to the note" */
  description?: string;
}

export interface GetNoteTemplateResponse {
  note_template?: NoteTemplate;
}

export type GetNoteTemplatesResponse = ResponseMetadata & {
  templates?: NoteTemplate[];
};

export interface CreateNoteTemplateRequest {
  /** @example "Template title" */
  title: string;
  icon?: Image | null;
  /**
   * @maxLength 102400
   * @example "Template context"
   */
  context?: string | null;
  sections?: NoteTemplateSection[];
  /**
   * Whether to generate AI actions with this note template
   * @example true
   */
  ai_actions?: boolean;
  /** @example true */
  is_shared?: boolean | null;
}

export interface CreateNoteTemplateResponse {
  note_template?: NoteTemplate;
}

export interface UpdateNoteTemplateRequest {
  title: string;
  /** @maxLength 102400 */
  context?: string | null;
  icon?: Image | null;
  sections?: NoteTemplateSection[] | null;
  /**
   * Whether to generate AI actions with this note template
   * @example true
   */
  ai_actions?: boolean | null;
  is_shared?: boolean | null;
}

export interface UpdateNoteTemplateResponse {
  note_template?: NoteTemplate;
}

export interface NoteTemplateFavourite {
  template_id?: string;
  /** @example "team123" */
  team_id?: string;
  /** @example ["user1","user2"] */
  users_favourited?: string[];
  /** @example ["user3","user4"] */
  users_unfavourited?: string[];
}

export interface ToggleNoteTemplateFavouriteResponse {
  /** Indicates whether the template is now favourited or not */
  is_favourited?: boolean;
}

export interface ApplyNoteTemplateRequest {
  /** @example "43" */
  note_template_id: string;
}

export interface ApplyNoteTemplateResponse {
  ai_note?: AIEnhancedNote;
}

export enum NoteTranscriptSource {
  Author = "author",
  Other = "other",
}

export interface NoteTranscriptBrief {
  /** @example "This is a transcript" */
  content?: string;
  source?: NoteTranscriptSource;
}

export type NoteTranscript = NoteTranscriptBrief & {
  /** @example "43" */
  id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
};

export interface MeetingMetadata {
  /** External ID for the event */
  id?: string;
  /** Meeting name or event title */
  name?: string;
  /** Meeting description, or event summary */
  description?: string;
  /** List of meeting links (with a provider) where users can join the event */
  links?: MeetingLink[];
  /** Location of the event */
  location?: string;
  /** Time when the event is scheduled to start */
  start_time?: STimePtr;
  /** Time when the event is expected to end */
  end_time?: STimePtr;
}

export interface MeetingLink {
  /** The provider for the meeting link (e.g., google, zoom, teams, other). */
  provider?: "google" | "zoom" | "teams" | "other";
  /** The meeting link. */
  link?: string;
}

export type MeetingParticipant = {
  /**
   * Internal User ID if the email of the meeting attendee belongs to a Superthread user in the workspace.
   * @example "uDsu0j19"
   */
  user_id: string | null;
  /**
   * Email address of the participant
   * @example "username@example.com"
   */
  email?: string;
  /**
   * The display name of the participant
   * @example "John Doe"
   */
  name?: string;
};

export interface Note {
  /** @example "" */
  id?: string;
  /** @example "Team Note" */
  title?: string;
  transcript?: string;
  transcripts?: NoteTranscript[];
  /** @maxLength 102400 */
  user_notes?: string;
  ai_notes?: AIEnhancedNote[];
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** @example "tdsu0j19" */
  team_id?: string;
  /** ID of the last note template used for this note */
  last_note_template_id?: string;
  /** @example false */
  is_public: boolean;
  public_settings?: PublicNoteSettings;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  meeting_metadata: MeetingMetadata | null;
  /** Date of when the meeting took place. */
  meeting_date: STimePtr;
  /** The time when the meeting started. */
  meeting_time: STimePtr;
  meeting_organizer: MeetingParticipant | null;
  meeting_attendees: MeetingParticipant[] | null;
}

export interface AIEnhancedNote {
  /** @example "866a3b86-4651-482c-bb69-61921ea4548c" */
  id?: string;
  /** @example "1da3b68c-3a82-495c-a6c9-e7a494281a36" */
  note_template_id?: string;
  /** @example "Team Note" */
  title?: string;
  /** @maxLength 102400 */
  content?: string;
  /** unix timestamp in seconds */
  time_updated?: STime;
  related_resources?: AINoteRelatedResource[];
}

export interface AINoteRelatedResource {
  /** @example "123" */
  id?: string;
  /** @example "card" */
  type?: "card";
  /**
   * cosine similarity score
   * @format float64
   * @example 0.8
   */
  cosine_similarity?: number;
}

export interface CreateNoteRequest {
  /** @example "Team Note" */
  title: string;
  transcript?: string | null;
  transcripts?: NoteTranscriptBrief[];
  /** @maxLength 102400 */
  user_notes?: string | null;
  google_calendar_event?: GoogleCalendarEvent | null;
}

export interface CreateNoteResponse {
  note?: Note;
}

export interface GetNoteResponse {
  note?: Note;
}

export type GetNotesResponse = ResponseMetadata & {
  notes?: Note[];
};

export interface UpdateNoteRequest {
  /** @example "Team Note" */
  title?: string | null;
  transcript?: string | null;
  transcripts?: NoteTranscriptBrief[];
  /** @maxLength 102400 */
  user_notes?: string | null;
  last_note_template_id?: string | null;
  is_public?: boolean | null;
  public_settings?: PublicNoteSettings | null;
  google_calendar_event?: GoogleCalendarEvent | null;
  /** unix timestamp in seconds */
  metadata_date?: STimePtr;
  /** unix timestamp in seconds */
  metadata_time?: STimePtr;
  metadata_organizer?: MeetingParticipant | null;
}

export interface UpdateNoteResponse {
  note?: Note;
}

export interface AddAttendeeRequest {
  attendee?: MeetingParticipant;
}

export interface AddAttendeeResponse {
  note?: Note;
}

export interface RemoveAttendeeResponse {
  note?: Note;
}

export interface UpdateEnhancedNoteRequest {
  /** @example "Team Note" */
  title?: string | null;
  /** @maxLength 102400 */
  content?: string | null;
}

export interface UpdateEnhancedNoteResponse {
  ai_note?: AIEnhancedNote;
}

export interface PublicNoteSettings {
  /** @example "https://notes.superthread.com/n/1" */
  url?: string;
}

export interface AddMembersRequest {
  members?: AddMemberRequest[];
}

export interface AddMemberRequest {
  /** @example "u-dsu0j19" */
  user_id?: string;
  role?: MemberRole;
}

export interface Member {
  /** @example "u-dsu0j19" */
  user_id?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  assigned_date?: STime;
  role?: MemberRole;
}

export enum MemberRole {
  Admin = "admin",
  Member = "member",
}

export enum TeamMemberRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
  Guest = "guest",
  GuestReader = "guestReader",
}

export enum TeamMemberStatus {
  Active = "active",
  Invited = "invited",
  Inactive = "inactive",
  Imported = "imported",
}

export interface AddWatcherRequest {
  /** @example "uDsu0j19" */
  user_id?: string;
}

export enum Font {
  Sans = "sans",
  Serif = "serif",
  Mono = "mono",
}

export interface Archived {
  /** @example "uDsu0j19" */
  user_id?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_archived?: STime;
}

export interface ArchivedPage {
  /** @example "uDsu0j19" */
  user_id?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_archived?: STime;
  parent_page_id?: string;
}

export interface Trashed {
  /** describes a user or robot that created or updated a resource */
  user_deleted?: Actor;
  /** unix timestamp in seconds */
  time_deleted?: STime;
}

export interface Activity {
  type?: ActivityType;
  activity_entry?: ActivityEntry;
  comment?: Comment;
}

export enum ActivityType {
  ActivityEntry = "activity_entry",
  Comment = "comment",
}

export enum ActivityEntryResourceType {
  Tag = "tag",
  File = "file",
  ParentCard = "parent_card",
  ChildCard = "child_card",
}

export interface ActivityEntry {
  /** @example "42" */
  id?: string;
  /** @example "tag-added" */
  entry_type?: string;
  resource_type?: "card" | "epic";
  /** additional data respresented before the activity */
  from?: ActivityEntryResource;
  /** additional data respresented after the activity */
  to?: ActivityEntryResource;
  /** @example "431" */
  page_id?: string;
  /** @example "433" */
  card_id?: string;
  /** @example "u-dsu0j19" */
  user_id?: string;
  /** @example "u-dsu0j19" */
  team_id?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
}

/** subject data of the activity */
export interface ActivityEntryResource {
  /** @example "tag" */
  resource_type?: string;
  /** id of the resource */
  resource_id?: string;
  /** string representation of the resource if applicable, e.g. due date value */
  resource_value?: string;
  tag?: Tag;
  parent_card?: ParentCard;
  child_card?: ChildCard;
  linked_card?: LinkedCard;
  checklist?: Checklist;
  file?: File;
  /** brief view of epic to be used in a card */
  epic?: EpicBrief;
  move_hints?: {
    project_id?: string;
    board_id?: string;
    board_title?: string;
    sprint_id?: string;
    list_id?: string;
    list_title?: string;
    list_behavior?: ListBehavior;
  };
}

export type GetActivitiesResponse = ResponseMetadata & {
  activities?: Activity[];
};

export interface GetActivityResponse {
  activity?: Activity;
}

export interface CreateActivityRequest {
  /** @example "Good point!" */
  content: string;
  /** @example "431" */
  card_id?: string;
  /** @example "5" */
  page_id?: string;
  /** @example "highlighted text" */
  context?: string;
}

export interface UpdateActivityRequest {
  /** @example "Sounds great!" */
  content?: string | null;
  /** @example "new highlighted text" */
  context?: string | null;
  status?: "resolved" | "open" | "orphaned" | null;
}

export interface WebhookNotification {
  /**
   * The type of destination for the notification. E.g.: slack_channel_webhook|email etc...
   * @example "slack_channel_webhook"
   */
  destination_type?: "slack_channel_webhook";
  /**
   * The Integration ID that holds the Webhook configuration for this notification type.
   * @example "42"
   */
  integration_id?: string;
}

/** Defines a webhook notification setting for the board. */
export interface BoardWebhookNotificationSettings {
  /** Defines a webhook destination target for these actions. */
  webhook?: WebhookNotification;
  options?: {
    /** Whether to send a notification when a card is added to the board. */
    card_created?: boolean;
    /** Whether to send a notification when a card is commented on (excluding replies). */
    card_commented?: boolean;
    /** Whether to send a notification when a card due date is soon/overdue. */
    card_due_date?: boolean;
  };
}

/** Defines a webhook notification setting for the list. */
export interface ListWebhookNotificationSettings {
  /** Defines a webhook destination target for these actions. */
  webhook?: WebhookNotification;
  options?: {
    /** Whether to send a notification when a card is added to the list. */
    card_created?: boolean;
  };
}

export type CreateWebhookNotificationRequest = WebhookNotification;

export interface CreateWebhookNotificationResponse {
  board?: Board;
}

export interface UpdateBoardWebhookNotificationRequest {
  /** Whether to send a notification when a card is added to the board. */
  card_created: boolean | null;
  /** Whether to send a notification when a card is commented on (excluding replies). */
  card_commented: boolean | null;
  /** Whether to send a notification when a card due date is soon/overdue. */
  card_due_date: boolean | null;
}

export interface UpdateBoardWebhookNotificationResponse {
  board?: Board;
}

export interface ToggleListWebhookNotificationRequest {
  /** A webhook configuration for this notification. Not changeable. */
  webhook: WebhookNotification;
  /**
   * The board ID that the list belongs to.
   * @example "42"
   */
  board_id: string;
  /** Whether to send a notification when a card is added to the list. */
  card_created: boolean | null;
}

export interface ToggleListWebhookNotificationResponse {
  list?: List;
}

export interface CommentCommon {
  /** @example "42" */
  id?: string;
  type?: "comment" | "child_comment";
  /**
   * @maxLength 16384
   * @example "Good point!"
   */
  content?: string;
  /** @example 1 */
  schema?: number;
  /** @example "431" */
  page_id?: string;
  /** @example "433" */
  card_id?: string;
  /** @example "u-dsu0j19" */
  user_id?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** @example "u-dsu0j19" */
  team_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  reactions?: Reaction[];
}

export type Comment = CommentCommon & {
  /** @example "attach context to a comment" */
  context?: string;
  status?: CommentStatus;
  participants?: string[];
  children?: ResponseMetadata & {
    child_comments?: ChildComment[];
  };
};

export type ChildComment = CommentCommon & {
  /** @example "1" */
  parent_id?: string;
};

export enum CommentStatus {
  Resolved = "resolved",
  Open = "open",
  Orphaned = "orphaned",
}

export interface Reaction {
  /** @example "sweat_smile" */
  id?: string;
  /** Reaction UTF-8 unicode value */
  unicode?: string;
  members?: ReactionMember[];
}

export interface ReactionMember {
  /** ID of user that reacted */
  user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** Variation of reaction */
  variation?: string;
}

export type GetCommentsResponse = ResponseMetadata & {
  comments?: Comment[];
};

export type GetChildCommentsResponse = ResponseMetadata & {
  child_comments?: ChildComment[];
};

export interface CreateCommentRequest {
  /**
   * @maxLength 16384
   * @example "Good point!"
   */
  content: string;
  /** @example 1 */
  schema?: number | null;
  /** @example "431" */
  card_id?: string;
  /** @example "5" */
  page_id?: string;
  /** @example "highlighted text" */
  context?: string;
}

export interface CreateChildCommentRequest {
  /**
   * @maxLength 16384
   * @example "Good point!"
   */
  content: string;
  /** @example 1 */
  schema?: number | null;
}

export interface CreateCommentReactionRequest {
  unicode?: string | null;
  /** @example "skin-tone-4" */
  variation?: string | null;
}

export interface UpdateCommentRequest {
  /**
   * @maxLength 16384
   * @example "Sounds great!"
   */
  content?: string | null;
  /** @example 1 */
  schema?: number | null;
  /** @example "new highlighted text" */
  context?: string | null;
  status?: CommentStatus;
}

export interface UpdateCommentStatusRequest {
  status: CommentStatus;
}

export interface UpdateChildCommentRequest {
  /**
   * @maxLength 16384
   * @example "Sounds great!"
   */
  content?: string | null;
  /** @example 1 */
  schema?: number | null;
}

export interface CommentResponse {
  comment?: Comment;
}

export interface ChildCommentResponse {
  child_comment?: ChildComment;
}

export interface CreateCommentReactionResponse {
  reaction?: Reaction;
}

export interface Board {
  /** @example "24" */
  id?: string;
  /** @example "3" */
  project_id?: string;
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "My Board" */
  title?: string;
  content?: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  image_urls?: string;
  /** @example "https://s3.....com/thumbnail.png" */
  thumbnail_url?: string;
  /** @example "u2erXoQq" */
  user_id?: string;
  /** @example "u2erXoQq" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  members?: Member[];
  /** lists belonging to this board (if ?include=lists provided) */
  lists?: List[];
  /** string array representing an order of IDs */
  list_order?: Order;
  tags?: Tag[];
  /** board archived status */
  archived?: Archived;
  /**
   * whether current user is a watcher of this board
   * @example true
   */
  is_watching?: boolean;
  /**
   * whether current user has this board bookmarked
   * @example true
   */
  is_bookmarked?: boolean;
  /** Generic mapping of version control software to automate state of cards in boards. Specifically which list they reside in */
  vcs_mapping?: VCSMapping;
  /** layout for the board */
  layout?: BoardLayout;
  /** email address to create cards via email */
  email?: InboundEmail;
  webhook_notifications?: BoardWebhookNotificationSettings[];
}

export type GetBoardsResponse = ResponseMetadata & {
  /** string array representing an order of IDs */
  board_order?: Order;
  boards?: Board[];
};

export interface GetBoardResponse {
  board?: Board;
}

export interface CreateBoardRequest {
  /** @example "32" */
  project_id: string;
  /** @example "My Board" */
  title?: string;
  /** @example "Some content" */
  content?: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  image_urls?: string;
  /** @example "https://s3.....com/thumbnail.png" */
  thumbnail_url?: string;
  lists?: CreateListInnerRequest[];
  members?: AddMemberRequest[];
  layout?: BoardLayout | null;
}

export interface CreateBoardResponse {
  board?: Board;
}

export interface UpdateBoardRequest {
  /** @example "44" */
  project_id?: string | null;
  /** @example "My Board" */
  title?: string | null;
  /** @example "Some content" */
  content?: string | null;
  /** @example "shield" */
  icon?: string | null;
  color?: string | null;
  image_urls?: string | null;
  /** @example "https://s3.....com/thumbnail.png" */
  thumbnail_url?: string | null;
  /**
   * make this board archived/unarchived
   * @example true
   */
  archived?: boolean | null;
  /**
   * a position where the board should be placed in the project
   * @example 3
   */
  position?: number | null;
  vcs_mapping?: VCSMappingUpdate | null;
  /** layout for the board */
  layout?: BoardLayout;
}

export interface UpdateBoardResponse {
  board?: Board;
}

export interface CopyBoardRequest {
  /** @example "Copy of ..." */
  title?: string | null;
  /** @example "5" */
  project_id: string;
}

export interface CopyBoardResponse {
  board?: Board;
}

export interface UpdateBoardEmailRequest {
  /** @example true */
  active?: boolean | null;
  /**
   * regenerate the email address
   * @example true
   */
  regenerate?: boolean | null;
}

export interface UpdateBoardEmailResponse {
  email?: InboundEmail;
}

/** Generic mapping of version control software to automate state of cards in which list they reside in. */
export interface VCSMappingItem {
  /**
   * Branch name to apply this VCS automation for.
   * @example "development"
   */
  name?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_draft?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_open?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_review_requested?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_merged?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_closed?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
}

/** Generic mapping of version control software to automate state of cards in boards. Specifically which list they reside in */
export interface VCSMapping {
  /**
   * List ID
   * @example "41"
   */
  pr_draft?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_open?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_review_requested?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_merged?: string;
  /**
   * List ID
   * @example "41"
   */
  pr_closed?: string;
  /** A list of VCSMappingItem that defines automation for branch specific workflows. */
  branches?: VCSMappingItem[];
}

export interface VCSMappingUpdate {
  /**
   * Target branch name
   * @example "develop"
   */
  branch?: string | null;
  /**
   * List ID
   * @example "41"
   */
  pr_draft?: string | null;
  /**
   * List ID
   * @example "41"
   */
  pr_open?: string | null;
  /**
   * List ID
   * @example "41"
   */
  pr_review_requested?: string | null;
  /**
   * List ID
   * @example "41"
   */
  pr_merged?: string | null;
  /**
   * List ID
   * @example "41"
   */
  pr_closed?: string | null;
}

export interface CreateBranchAutomationRequest {
  /**
   * Create a new automation for this branch name.
   * @minLength 1
   * @maxLength 250
   * @pattern ^[a-zA-Z0-9._\/-]+$
   * @example "staging"
   */
  name: string;
}

export interface UpdateVCSBranchNameRequest {
  /**
   * @minLength 1
   * @maxLength 250
   * @pattern ^[a-zA-Z0-9._\/-]+$
   * @example "new-branch-name"
   */
  branch: string;
}

export interface InboundEmail {
  /** @example "board+engineering-board-b2L2jKl@inbound.superthread.com" */
  email?: string;
  /** @example true */
  active?: boolean;
}

export interface CreateTagRequest {
  /** @example "Todo" */
  name: string;
  color: TagColor;
  /** used when a tag is scoped within a project */
  project_id?: string | null;
}

export interface CreateTagResponse {
  tag?: Tag;
}

export type CreateTagErrorResponse = Error & {
  type?: "ERR_TAG_PROJECT_CONFLICT" | "ERR_TAG_EXISTS";
  /**
   * when type=ERR_TAG_PROJECT_CONFLICT, returns project IDs that already have this tag
   * @example ["5","8"]
   */
  project_ids?: string[];
  /**
   * when type=ERR_TAG_EXISTS, returns existing tag ID
   * @example "3"
   */
  tag_id?: string;
};

export interface UpdateTagRequest {
  /** @example "Todo" */
  name?: string | null;
  color: TagColor;
}

export interface UpdateTagResponse {
  tag?: Tag;
}

export interface MergeTagRequest {
  /**
   * Name of the tag to merge
   * @example "Todo"
   */
  name: string;
  /** Color to be used for the newly created workspace tag */
  color: TagColor;
}

export interface MergeTagResponse {
  tag?: Tag;
}

export type GetTagsResponse = ResponseMetadata & {
  tags?: Tag[];
};

export interface AddTagRequest {
  /** Tag ID to attach to the card */
  id?: string;
  /** Array of tag IDs to attach to the card */
  ids?: string[];
}

export interface List {
  /** @example "41" */
  id?: string;
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "My list" */
  title?: string;
  content?: string;
  behavior?: ListBehavior;
  /** @example "43" */
  board_id?: string;
  /** @example "u981hdaT" */
  user_id?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** @example "5" */
  project_id?: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  /** string array representing an order of IDs */
  card_order?: Order;
  /** @example 5 */
  total_cards?: number;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  cards?: Card[];
  epics?: Epic[];
  /** list archived status */
  archived?: Archived;
  /**
   * whether current user is a watcher of this list
   * @example true
   */
  is_watching?: boolean;
  webhook_notifications?: ListWebhookNotificationSettings[];
}

export type GetListsResponse = ResponseMetadata & {
  lists?: List[];
};

export interface GetListResponse {
  list?: List;
}

export interface CreateListRequest {
  /** @example "My list" */
  title?: string;
  content?: string;
  /** @example "2" */
  board_id: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  behavior?: ListBehavior;
}

export interface CreateEpicsListRequest {
  /** @example "My list" */
  title?: string;
  content?: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  behavior?: ListBehavior;
}

export interface CreateListInnerRequest {
  /** @example "My list" */
  title?: string;
  content?: string;
  /** @example "shield" */
  icon?: string;
  color?: string;
  behavior?: ListBehavior;
}

export interface CreateListResponse {
  list?: List;
}

export interface UpdateListRequest {
  /** @example "My list" */
  title?: string | null;
  content?: string | null;
  /** @example "2" */
  board_id?: string | null;
  /** @example "shield" */
  icon?: string | null;
  color?: string;
  /**
   * a position where the list should be placed in the board
   * @example 0
   */
  position?: number | null;
  /**
   * make this list archived/unarchived
   * @example true
   */
  archived?: boolean | null;
  behavior?: ListBehavior | null;
}

export interface UpdateListResponse {
  list?: List;
}

export enum ListBehavior {
  Backlog = "backlog",
  Committed = "committed",
  Started = "started",
  Completed = "completed",
  Cancelled = "cancelled",
}

export interface Card {
  /** @example "2700" */
  id?: string;
  /**
   * Type of the object being returned
   * @example "card"
   */
  type?: string;
  icon?: Image;
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "My Card" */
  title?: string;
  /**
   * @maxLength 102400
   * @example "Some card content"
   */
  content?: string;
  /**
   * Content schema version
   * @example 1
   */
  schema?: number;
  collaboration?: Collaboration;
  status?: CardStatus;
  /** @example 1 */
  priority?: number;
  /** @example "12" */
  board_id?: string;
  /** cached field */
  board_title?: string;
  /** @example "41" */
  list_id?: string;
  /** cached field */
  list_color?: string;
  /** cached field */
  list_title?: string;
  /** @example "4s12" */
  sprint_id?: string;
  /** @example "uR2dws11" */
  owner_id?: string;
  /** @example "uR2dws11" */
  user_id?: string;
  /** @example "u2erXoQq" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  start_date?: STime;
  /** unix timestamp in seconds */
  due_date?: STime;
  /** unix timestamp in seconds */
  completed_date?: STime;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  members?: Member[];
  checklists?: Checklist[];
  /** string array representing an order of IDs */
  checklist_order?: Order;
  checklist_item_order: Record<string, Order>;
  parent_card?: ParentCard;
  child_cards?: ChildCard[];
  /** string array representing an order of IDs */
  child_card_order?: Order;
  linked_cards?: LinkedCard[];
  /** card archived status */
  archived?: Archived;
  /**
   * whether the card is in an archived list
   * @example false
   */
  archived_list?: boolean;
  /**
   * whether the card is in an archived board
   * @example false
   */
  archived_board?: boolean;
  tags?: Tag[];
  /** @example 3 */
  total_comments: number;
  /** @example 1 */
  total_files: number;
  /**
   * whether current user is a watcher of this card
   * @example true
   */
  is_watching?: boolean;
  /**
   * whether current user has this card bookmarked
   * @example true
   */
  is_bookmarked?: boolean;
  /** cached field */
  project_id?: string;
  external_links?: ExternalLink[];
  hints?: CardHint[];
  /**
   * effort estimation enum for the card. 0 is unset, 1 is least, 5 is greatest. will map to different values depending on project settings.
   * @min 0
   * @max 5
   */
  estimate?: number;
  /** brief view of epic to be used in a card */
  epic?: EpicBrief;
}

export interface Epic {
  /** @example "2700" */
  id?: string;
  /**
   * Type of the object being returned
   * @example "epic"
   */
  type?: string;
  /** @example "tDsu0j19" */
  team_id?: string;
  icon?: Image;
  /** @example "My Card" */
  title?: string;
  /**
   * Content schema version
   * @example 1
   */
  schema?: number;
  /**
   * @maxLength 102400
   * @example "Some card content"
   */
  content?: string;
  collaboration?: Collaboration;
  /** @example "41" */
  list_id?: string;
  /** cached field */
  list_color?: string;
  /** cached field */
  list_title?: string;
  status?: CardStatus;
  /** @example 1 */
  priority?: number;
  /** @example "uR2dws11" */
  owner_id?: string;
  /** @example "uR2dws11" */
  user_id?: string;
  /** @example "u2erXoQq" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  start_date?: STime;
  /** unix timestamp in seconds */
  due_date?: STime;
  /** unix timestamp in seconds */
  completed_date?: STime;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  members?: Member[];
  checklists?: Checklist[];
  /** string array representing an order of IDs */
  checklist_order?: Order;
  checklist_item_order: Record<string, Order>;
  child_cards?: ChildCard[];
  /** string array representing an order of IDs */
  child_card_order?: Order;
  linked_cards?: LinkedCard[];
  /** archive status */
  archived?: Archived;
  /**
   * whether the epic is in an archived list
   * @example false
   */
  archived_list?: boolean;
  tags?: Tag[];
  /** @example 3 */
  total_comments: number;
  /** @example 1 */
  total_files: number;
  /**
   * whether current user is a watcher of this epic
   * @example true
   */
  is_watching?: boolean;
  external_links?: ExternalLink[];
  hints?: CardHint[];
}

export type GetCardsResponse = ResponseMetadata & {
  cards?: Card[];
};

export interface GetCardResponse {
  card?: Card;
}

export interface CreateCardRequest {
  /** @example "My Card" */
  title: string;
  /**
   * @maxLength 102400
   * @example "Some card content"
   */
  content: string;
  /** @example 1 */
  schema?: number | null;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  start_date?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  due_date?: STime;
  /** @example "5" */
  board_id: string;
  /** @example "1" */
  project_id: string;
  /** @example "8" */
  sprint_id: string;
  /** @example "114" */
  list_id: string;
  owner_id?: string | null;
  members?: AddMemberRequest[];
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  priority?: number | null;
  /**
   * effort estimation enum for the card. 1 is least, 5 is greatest. will map to different values depending on project settings.
   * @min 1
   * @max 5
   * @example 3
   */
  estimate?: number | null;
  /** Optional card ID to set as parent */
  parent_card_id?: string | null;
  /** Optional epic ID to add card to */
  epic_id?: string | null;
  /**
   * Optional Board Email reference when creating a card from an email
   * @example "b291eKoaaLn5"
   */
  board_email_ref?: string | null;
  /** describes a user or robot that created or updated a resource */
  user?: Actor | null;
}

export interface CreateCardResponse {
  card?: Card;
}

export interface ConvertCardToEpicResponse {
  epic?: Epic;
}

export interface UpdateCardRequest {
  /** @example "My Card" */
  title?: string | null;
  /** @example "2" */
  board_id?: string | null;
  /** @example "114" */
  list_id?: string | null;
  /** @example "1" */
  project_id?: string | null;
  /**
   * sprint id
   * @example "8"
   */
  sprint_id?: string | null;
  owner_id?: string | null;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  start_date?: STimePtr;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  due_date?: STimePtr;
  /**
   * a position where the card should be placed in the list
   * @example 5
   */
  position?: number | null;
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  priority?: number | null;
  /**
   * effort estimation enum for the card. 0 is unset, 1 is least, 5 is greatest. will map to different values depending on project settings.
   * @min 0
   * @max 5
   * @example 3
   */
  estimate?: number | null;
  /**
   * make this card archived/unarchived
   * @example true
   */
  archived?: boolean | null;
}

export interface UpdateCardResponse {
  card?: Card;
}

export interface MoveCardSprint {
  /**
   * a new project ID where the card is being moved to (used together with a new sprint ID)
   * @example "1"
   */
  project_id?: string;
  /**
   * a new sprint ID where the card is being moved to
   * @example "8"
   */
  sprint_id?: string;
  /**
   * a new list ID where the card is being moved to
   * @example "507F1A70-39B1-4436-BACF-CD87E9FE5122"
   */
  list_id?: string;
  /**
   * a position where the card should be placed in the list. if unset, card will be placed at the end of the list
   * @example 5
   */
  position?: number | null;
}

export interface MoveCardBoard {
  /**
   * a new list ID where the card is being moved to in the same or different board
   * @example "24"
   */
  list_id?: string;
  /**
   * a position where the card should be placed in the list. if unset, card will be placed at the end of the list
   * @example 5
   */
  position?: number | null;
}

/** object describing where to move the card (sprint or regular board) */
export interface MoveCardRequest {
  sprint?: MoveCardSprint | null;
  board?: MoveCardBoard | null;
}

export interface MoveCardResponse {
  card?: Card;
}

export interface GetEpicsResponse {
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "u2erXoQq" */
  user_id_updated?: string;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_updated?: STime;
  lists?: List[];
  /** string array representing an order of IDs */
  list_order?: Order;
}

export interface GetEpicResponse {
  epic?: Epic;
}

export interface CreateEpicRequest {
  icon?: Image;
  title: string;
  /** @maxLength 102400 */
  content: string;
  /** @example 1 */
  schema?: number | null;
  /** @example "114" */
  list_id: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  start_date?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  due_date?: STime;
  members?: AddMemberRequest[];
  owner_id?: string | null;
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  priority?: number | null;
}

export interface CreateEpicResponse {
  epic?: Epic;
}

export interface UpdateEpicRequest {
  icon?: Image | null;
  /** @example "My Card" */
  title?: string | null;
  /** @example "114" */
  list_id?: string | null;
  owner_id?: string | null;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  start_date?: STimePtr;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  due_date?: STimePtr;
  /**
   * a position where the epic should be placed in the list
   * @example 5
   */
  position?: number | null;
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  priority?: number | null;
  /**
   * make this card archived/unarchived
   * @example true
   */
  archived?: boolean | null;
}

export interface UpdateEpicResponse {
  epic?: Epic;
}

export interface CardTemplate {
  /** @example "53" */
  id?: string;
  /** @example "Template title" */
  title?: string;
  icon?: Image;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "5" */
  card_board_id?: string;
  /** @example "114" */
  card_list_id?: string;
  /** @example "Card title" */
  card_title?: string;
  /** @example "Card content" */
  card_content?: string;
  card_checklists?: AddChecklistRequest[];
  /** @example "uR2dws11" */
  card_owner_id?: string;
  card_members?: AddMemberRequest[];
  card_tags?: AddTagRequest[];
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  card_priority?: number;
  card_child_cards?: AddChildCardTemplateRequest[];
}

export interface AddChildCardTemplateRequest {
  /** @example "Create illustration for upcoming holidays" */
  title: string;
  /**
   * @maxLength 102400
   * @example "Some card content"
   */
  content: string;
  /** @example "5" */
  board_id: string;
  /** @example "114" */
  list_id: string;
  members?: AddMemberRequest[];
  tags?: AddTagRequest[];
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  priority?: number | null;
}

export interface GetCardTemplateResponse {
  card_template?: CardTemplate;
}

export type GetCardTemplatesResponse = ResponseMetadata & {
  card_templates?: CardTemplate[];
};

export interface CreateCardTemplateRequest {
  /** @example "Template title" */
  title: string;
  icon?: Image;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "5" */
  card_board_id?: string;
  /** @example "114" */
  card_list_id?: string;
  /** @example "Card title" */
  card_title: string;
  /**
   * @maxLength 102400
   * @example "Card content"
   */
  card_content: string;
  card_checklists?: AddChecklistRequest[];
  /** @example "uR2dws11" */
  card_owner_id?: string;
  card_members?: AddMemberRequest[];
  card_tags?: AddTagRequest[];
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  card_priority?: number;
  card_child_cards?: AddChildCardTemplateRequest[];
}

export interface CreateCardTemplateResponse {
  card_template?: CardTemplate;
}

export interface UpdateCardTemplateRequest {
  /** @example "Template title" */
  title?: string | null;
  icon?: Image | null;
  /**
   * IDs of projects where this template is available
   * @example ["5","8"]
   */
  project_ids?: string[];
  /** @example "5" */
  card_board_id?: string | null;
  /** @example "114" */
  card_list_id?: string | null;
  /** @example "Card title" */
  card_title?: string | null;
  /**
   * @maxLength 102400
   * @example "Card content"
   */
  card_content?: string | null;
  card_checklists?: AddChecklistRequest[];
  /** @example "uR2dws11" */
  card_owner_id?: string | null;
  card_members?: AddMemberRequest[];
  card_tags?: AddTagRequest[];
  /**
   * @min 0
   * @max 4
   * @example 1
   */
  card_priority?: number | null;
  card_child_cards?: AddChildCardTemplateRequest[];
}

export interface UpdateCardTemplateResponse {
  card_template?: CardTemplate;
}

export interface UpdateChildCardRequest {
  /**
   * a position where the child card should be placed in the card
   * @example 0
   */
  position?: number | null;
}

export interface CreateCardCopyRequest {
  /** @example "My Card" */
  title: string;
  /** @example "114" */
  project_id: string;
  /** @example "5" */
  board_id: string;
  /** @example "114" */
  list_id: string;
  /** @example "8" */
  sprint_id: string;
}

/** @example "started" */
export enum CardStatus {
  Committed = "committed",
  Started = "started",
  Completed = "completed",
  Cancelled = "cancelled",
}

export interface ParentCard {
  /** @example "Implement service requirements" */
  title?: string;
  /** @example "42" */
  card_id?: string;
  list_color?: string;
  status?: CardStatus;
}

export interface ChildCard {
  /** @example "Create illustration for upcoming holidays" */
  title?: string;
  /** @example "42" */
  card_id?: string;
  /** @example "us4Fsfed" */
  user_id?: string;
  /** @example "3" */
  project_id?: string;
  /** @example "15" */
  board_id?: string;
  /** @example "Ideas" */
  board_title?: string;
  /** @example "55" */
  list_id?: string;
  /** @example "Done" */
  list_title?: string;
  list_color?: string;
  status?: CardStatus;
  archived?: Archived;
}

export interface LinkedCard {
  /** @example "Create illustration for upcoming holidays" */
  title?: string;
  /** @example "42" */
  card_id?: string;
  /** @example "42" */
  user_id?: string;
  /** @example "3" */
  project_id?: string;
  /** @example "15" */
  board_id?: string;
  /** @example "Ideas" */
  board_title?: string;
  /** @example "list 1" */
  list_id?: string;
  /** @example "list 1" */
  list_title?: string;
  status?: CardStatus;
  archived?: Archived;
  linked_card_type?: LinkedCardType;
}

export interface HintCard {
  /** @example "Create illustration for upcoming holidays" */
  title?: string;
  /** @example "42" */
  card_id?: string;
  /** @example "us4Fsfed" */
  user_id?: string;
  /** @example "3" */
  project_id?: string;
  /** @example "15" */
  board_id?: string;
  /** @example "Ideas" */
  board_title?: string;
  /** @example "55" */
  list_id?: string;
  /** @example "Done" */
  list_title?: string;
  list_color?: string;
  status?: CardStatus;
}

export interface CardBreadcrumb {
  project_id?: string;
  board_id?: string;
  board_title?: string;
  sprint_id?: string;
  list_id?: string;
  list_title?: string;
  list_behavior?: ListBehavior;
}

export interface AddChildCardRequest {
  /**
   * ID of the child card that needs to be linked
   * @example "41"
   */
  card_id?: string;
}

export interface AddChildCardResponse {
  child_card?: ChildCard;
}

export interface AddLinkedCardResponse {
  linked_card?: LinkedCard;
}

export interface AddLinkedCardRequest {
  /**
   * ID of the card which was linked with current card
   * @example "41"
   */
  card_id?: string;
  linked_card_type?: LinkedCardType;
}

export interface AddChecklistRequest {
  /** @example "My Checklist" */
  title?: string;
  items?: CreateChecklistItemRequest[];
}

export interface Checklist {
  /** @example "232" */
  id?: string;
  /** @example "My Checklist" */
  title?: string;
  /** @example "Some description" */
  content?: string;
  /** @example "32" */
  card_id?: string;
  /** @example "uG2sdaOn" */
  user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  items?: ChecklistItem[];
}

export interface GetChecklistResponse {
  checklist?: Checklist;
}

export interface CreateChecklistRequest {
  /** @example "My Checklist" */
  title?: string;
  /** @example "Some description" */
  content?: string;
}

export interface CreateChecklistResponse {
  checklist?: Checklist;
}

export interface UpdateChecklistRequest {
  /** @example "My Checklist" */
  title?: string | null;
  /** @example "Some description" */
  content?: string | null;
  /** @example "12" */
  card_id?: string | null;
  /**
   * a position where the checklist should be placed in the card
   * @example 2
   */
  position?: number | null;
}

export interface UpdateChecklistResponse {
  checklist?: Checklist;
}

export interface ChecklistItem {
  /** @example "4312" */
  id?: string;
  /** @example "Some title" */
  title?: string;
  /** @example "Some description" */
  content?: string;
  /** @example "432" */
  checklist_id?: string;
  /** @example "u-du9saoj1" */
  user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  /** @example true */
  checked: boolean;
}

export type GetChecklistItemsResponse = ResponseMetadata & {
  checklist_items?: ChecklistItem[];
};

export interface CreateChecklistItemRequest {
  /** @example "Some title" */
  title: string;
  /** @example "Some description" */
  content?: string;
  /**
   * checked state of the item. defaults to false.
   * @example false
   */
  checked?: boolean;
}

export interface CreateChecklistItemResponse {
  checklist_item?: ChecklistItem;
}

export interface UpdateChecklistItemRequest {
  /** @example "Some title" */
  title?: string | null;
  /** @example "Some description" */
  content?: string | null;
  /** @example "23" */
  checklist_id?: string | null;
  /**
   * checked state of the item.
   * @example false
   */
  checked?: boolean | null;
  /**
   * a position where the item should be placed in the checklist
   * @example 4
   */
  position?: number | null;
}

export interface UpdateChecklistItemResponse {
  checklist_item?: ChecklistItem;
}

export interface Sprint {
  /** @example "1" */
  id?: string;
  /** @example "tDsu0j19" */
  team_id?: string;
  /** @example "2" */
  project_id?: string;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** @example "Sprint 1" */
  title?: string;
  /** @example "This is the first sprint" */
  content?: string;
  state?: SprintState;
  /** lists/statuses for the sprint */
  lists?: List[];
  /** snapshots of unfinished cards in the sprint */
  unfinished_cards?: Card[];
  /** unix timestamp in seconds */
  start_date?: STime;
  /** unix timestamp in seconds */
  end_date?: STime;
  /** unix timestamp in seconds */
  override_end_date?: STime;
  layout?: BoardLayout;
  /** progress of the sprint */
  progress?: SprintDayProgress[][];
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
}

export enum SprintState {
  Planned = "planned",
  Active = "active",
  Completed = "completed",
  Canceled = "canceled",
}

export interface SprintCardStatus {
  /**
   * unique sprint status uuid
   * @example "688a7717-f1ea-4955-9f5f-6eca66e98f64"
   */
  id?: string;
  /** @example "To Do" */
  title: string;
  status: CardStatus;
}

export interface SprintDayProgress {
  status?: CardStatus;
  /**
   * number of cards in the status
   * @example 3
   */
  count?: number;
  /**
   * total estimate points of cards in the status
   * @example 5
   */
  pts?: number;
}

export interface GetSprintResponse {
  sprint?: Sprint;
}

export type GetSprintsResponse = ResponseMetadata & {
  sprints?: Sprint[];
};

export interface CreateSprintRequest {
  /** @example "Sprint 1" */
  title?: string;
  /** @example "This is the first sprint" */
  content?: string;
  /** @example "2" */
  project_id: string;
}

export interface CreateSprintResponse {
  sprint?: Sprint;
}

export interface UpdateSprintRequest {
  /** @example "Sprint 1" */
  title?: string | null;
  /** @example "This is the first sprint" */
  content?: string | null;
  /** @example "canceled" */
  state?: "canceled" | "completed" | null;
  /** unix timestamp in seconds */
  start_date?: STime | null;
  /** unix timestamp in seconds */
  end_date?: STime | null;
}

export interface UpdateSprintResponse {
  sprint?: Sprint;
}

export interface SprintSettings {
  statuses?: SprintCardStatus[];
  /**
   * length of the sprint in days
   * @example 14
   */
  length?: number;
  /**
   * length of the cooldown period in days
   * @example 7
   */
  cooldown?: number;
  /**
   * day of the week to start the sprint (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
   * @example 1
   */
  start_day?: number;
  /**
   * whether sprints are enabled for the project
   * @example true
   */
  enabled: boolean;
  /** Generic mapping of version control software to automate state of cards in boards. Specifically which list they reside in */
  vcs_mapping?: VCSMapping;
  layout?: BoardLayout;
  /** unix timestamp in seconds */
  time_updated?: STime;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
}

export interface GetSprintSettingsResponse {
  sprint_settings?: SprintSettings;
}

export interface SetSprintSettingsRequest {
  /** ordered list of statuses for the sprint */
  statuses: SprintCardStatus[];
  /**
   * length of the sprint in days
   * @example 14
   */
  length: 7 | 14 | 21 | 28 | 35 | 42 | 49 | 56;
  /**
   * length of the cooldown period in days
   * @example 7
   */
  cooldown: 0 | 7 | 14 | 21 | 28;
  /**
   * day of the week to start the sprint (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
   * @example 1
   */
  start_day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  /**
   * whether sprints are enabled for the project
   * @example true
   */
  enabled: boolean;
  vcs_mapping?: VCSMappingUpdate | null;
  layout?: BoardLayout;
}

export interface SetSprintSettingsResponse {
  sprint_settings?: SprintSettings;
}

export interface LoginEmailRequest {
  /** @example "user@example.com" */
  email: string;
  /** @example "p4ssw0rd123$" */
  password: string;
}

export interface SendLoginCodeEmailRequest {
  /** @example "user@example.com" */
  email: string;
}

export interface LoginWithCodeRequest {
  /** @example "user@example.com" */
  email: string;
  /** @example "123456" */
  code: string;
}

export interface LoginOAuthCodeRequest {
  /** @example "123456" */
  code: string;
  /**
   * redirect_uri param that was used to obtain the OAuth authorization code
   * @example "superthread://oauth2, https://app.superthread.com/oauth2"
   */
  redirect_uri: string;
}

export interface LoginWithInviteRequest {
  /**
   * deprecated
   * @example "iARGLH5d"
   */
  invite_id?: string;
  /** @example "HZW0HQBgq8i8A2hv" */
  link_code?: string;
}

export interface LoginWithInviteResponse {
  /**
   * the team you were invited to
   * @example "tARGLH5d"
   */
  team_id?: string;
  /**
   * the project you were invited to
   * @example "1"
   */
  project_id?: string;
}

export interface LogoutResponse {
  /** @example "https://app.superthread.com/login" */
  logout_redirect_url: string;
}

export interface ResendInviteLinkEmailRequestByUser {
  /** @example "123456" */
  link_code?: string;
  /**
   * deprecated
   * @example "iARGLH5d"
   */
  invite_id?: string;
}

export interface ResendInviteLinkEmailRequestByUserResponse {
  /** this is the email address that the new invite link was sent to */
  email?: string;
}

export interface ResendInviteLinkEmailRequestByTeam {
  /** @example "u123abc" */
  invitee_user_id?: string;
  /**
   * deprecated
   * @example "person@domain.com"
   */
  invitee_email?: string;
}

export interface BoardSearchResult {
  /** @example "4" */
  id?: string;
  /** @example "New <em>features</em>" */
  title?: string;
  /** @example "2" */
  project_id?: string;
  /** board archived status */
  archived?: Archived;
  /** board layout */
  layout?: BoardLayout;
}

export interface PageSearchResult {
  /** @example "24" */
  id?: string;
  icon?: Image;
  /** @example "Page <em>title</em>" */
  title?: string;
  /** @example "2" */
  project_id?: string;
  /** @example "this is a <em>sample</em> page content" */
  excerpt?: string;
  /** page archived status */
  archived?: ArchivedPage;
}

export interface CardSearchResult {
  /** @example "13" */
  id?: string;
  /** @example "Implement new <em>service</em>" */
  title?: string;
  /** @example "2" */
  project_id?: string;
  /** @example "14" */
  board_id?: string;
  /** @example "1" */
  sprint_id?: string;
  /** @example "Ideas" */
  board_title?: string;
  /** @example "3" */
  list_id?: string;
  /** @example "Backlog" */
  list_title?: string;
  list_color?: string;
  status?: CardStatus;
  /** @example "u123abcd" */
  owner_id?: string;
  members?: Member[];
  /** card archived status */
  archived?: Archived;
  /** brief view of epic to be used in a card */
  epic?: EpicBrief;
  parent_card?: ParentCard;
}

export interface EpicSearchResult {
  /** @example "13" */
  id?: string;
  /** @example "Implement new <em>service</em>" */
  title?: string;
  /** @example "3" */
  list_id?: string;
  /** @example "Backlog" */
  list_title?: string;
  list_color?: string;
  status?: CardStatus;
  /** @example "u123abcd" */
  owner_id?: string;
  members?: Member[];
  /** card archived status */
  archived?: Archived;
  icon?: Image;
  /** @example "epic" */
  type?: string;
}

export interface ProjectSearchResult {
  /** @example "2" */
  id?: string;
  icon?: Image;
  /** @example "Project <em>title</em>" */
  title?: string;
  /** @example 5 */
  total_members?: number;
  /** @example "u2DdoERz" */
  user_id?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
}

export interface NoteSearchResult {
  /** @example "21" */
  id?: string;
  /** @example "Page <em>title</em>" */
  title?: string;
  /** @example "this is a <em>sample</em> note content" */
  excerpt?: string;
  /** unix timestamp in seconds */
  time_created?: STime;
}

export type SearchResults = ResponseMetadata & {
  results?: SearchResult[];
  boards?: BoardSearchResult[];
  cards?: CardSearchResult[];
  pages?: PageSearchResult[];
  projects?: ProjectSearchResult[];
  epics?: EpicSearchResult[];
  notes?: NoteSearchResult[];
};

export interface SearchResult {
  board?: BoardSearchResult;
  page?: PageSearchResult;
  card?: CardSearchResult;
  project?: ProjectSearchResult;
  epic?: EpicSearchResult;
  note?: NoteSearchResult;
}

export type GetSearchBoardsResponse = ResponseMetadata & {
  boards?: BoardSearchResult[];
};

export type GetSearchListsResponse = ResponseMetadata & {
  lists?: List[];
};

export type GetSearchTagsResponse = ResponseMetadata & {
  tags?: Tag[];
};

export type View = ViewFilters & {
  /** @example "1" */
  id?: string;
  /** @example "tARGLH5d" */
  team_id?: string;
  /** @example "u2DdoERz" */
  owner_user_id?: string;
  /** @example "card" */
  type?: "board" | "card" | "page";
  /** @example "my view" */
  name?: string;
  /** @example false */
  shared?: boolean;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
};

export interface ViewFilters {
  board_filters?: {
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_created?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_updated?: DateRangeFilter;
    include?: BoardViewFilter;
    exclude?: BoardViewFilter;
    sort_by?: ViewBoardSortBy;
  } | null;
  card_filters?: {
    is_parent?: boolean | null;
    is_child?: boolean | null;
    /** Filter on cards that have an estimate */
    has_estimate?: boolean | null;
    /** Filter on either: no members or at least 1 member assigned */
    has_members?: boolean | null;
    /** Filter on cards that have a priority */
    has_priority?: boolean | null;
    /** Filter on cards that have a non empty status */
    has_status?: boolean | null;
    /** Filter on cards that have no tags or at least 1 tag */
    has_tags?: boolean | null;
    /** Filter on cards that have no links or at least 1 link */
    has_linked_card?: boolean | null;
    /** Filter on cards that have a non empty due date */
    has_due_date?: boolean | null;
    /** Filter on cards that have a non empty start date */
    has_start_date?: boolean | null;
    /** Filter on cards that have a non empty completed date */
    has_completed_date?: boolean | null;
    /** Filter on cards that have a parent card */
    has_parent_card?: boolean | null;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    start_date?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    completed_date?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    due_date?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_created?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_updated?: DateRangeFilter;
    include?: CardViewFilter;
    exclude?: CardViewFilter;
    sort_by?: ViewCardSortBy;
  };
  page_filters?: {
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_created?: DateRangeFilter;
    /** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
    time_updated?: DateRangeFilter;
    include?: PageViewFilter;
    exclude?: PageViewFilter;
    sort_by?: ViewPageSortBy;
  } | null;
}

/** Expects unix time in seconds for each property but also supports date math such as 'now-1d/d', which reads as current time minus yesterday rounded down to the start of the day. */
export interface DateRangeFilter {
  /**
   * before is inclusive, meaning that you can pass 0 to include empty dates
   * @example "now-1d"
   */
  before?: string;
  /**
   * after is exclusive, meaning that you can pass 0 to exclude empty dates
   * @example "1620997103||-2h"
   */
  after?: string;
}

export interface BoardViewFilter {
  /** List of board ids */
  ids?: string[];
  content?: string;
  /** List of project ids */
  projects?: string[];
  /** List of user ids */
  creators?: string[];
  /** List of user ids */
  members?: string[];
}

export interface CardViewFilter {
  /** List of card ids */
  ids?: string[];
  content?: string;
  title?: string;
  /** List of board ids */
  boards?: string[];
  /** List of integers representing effort estimation enum for the card. 0 is unset. 1 is least, 5 is greatest. will map to different values depending on project settings. */
  estimates?: number[];
  /** List of list ids */
  lists?: string[];
  /** List of integers representing priorities */
  priority?: number[];
  /** List of project ids */
  projects?: string[];
  /** List of user ids */
  creators?: string[];
  /** List of user ids */
  owners?: string[];
  /** List of user ids */
  members?: string[];
  /** List of card statuses */
  statuses?: CardStatus[];
  /** List of external link types */
  external_links?: ExternalLinkType[];
  /** List of link card types */
  linked_cards?: LinkedCardType[];
  /** List of tag ids */
  tags?: string[];
  /** List of parent card ids */
  parent_cards?: string[];
  /** List of epics ids */
  epics?: string[];
}

export interface PageViewFilter {
  /** List of page ids */
  ids?: string[];
  content?: string;
  /** List of project ids */
  projects?: string[];
  /** List of user ids */
  creators?: string[];
  /** List of user ids */
  members?: string[];
}

export type ViewResults = ResponseMetadata & {
  boards?: Board[];
  cards?: Card[];
  pages?: Page[];
};

/** @example {"field":"time_created","order_ascending":true} */
export interface ViewCardSortBy {
  field?: "time_created" | "time_updated" | "status" | "priority" | "due_date" | "estimate";
  order_ascending?: boolean;
}

/** @example {"field":"time_created","order_ascending":true} */
export interface ViewBoardSortBy {
  field?: "time_created" | "time_updated";
  order_ascending?: boolean;
}

/** @example {"field":"time_created","order_ascending":true} */
export interface ViewPageSortBy {
  field?: "time_created" | "time_updated";
  order_ascending?: boolean;
}

export type GetViewsResponse = ResponseMetadata & {
  views?: View[];
};

export type GetViewPreviewRequest = ViewFilters & {
  /** @example "card" */
  type?: "board" | "card" | "page";
};

export type CreateViewRequest = ViewFilters & {
  /** @example "my view" */
  name?: string;
  /** @example "card" */
  type?: "board" | "card" | "page";
  /** @example false */
  shared?: boolean;
};

export type UpdateViewRequest = ViewFilters & {
  /** @example "my view" */
  name?: string | null;
  /** @example "card" */
  type?: string | null;
  /** @example false */
  shared?: boolean | null;
};

export interface ResponseMetadata {
  /** @example "dmsjqh9d8w1hdjosjaasda" */
  cursor: string;
  /** @example 14 */
  count: number;
}

export interface Error {
  /** @example "err5f744ab" */
  id?: string;
  /**
   * @format int32
   * @example 403
   */
  code?: number;
  /**
   * Superthread Error Code (`SEC`): A structured error code.
   * Format: `SEC:{ServiceID}-{InternalErrorCode}`.
   *   - `SEC`: Prefix for all structured error codes.
   *   - `ServiceID`: First 3 characters identify the service, '000' is reserved for generic errors.
   *   - `InternalErrorCode`: the next (last) 5 characters define the specific error.
   * @pattern ^SEC:\d{8}$
   * @example "SEC:000-010011"
   */
  sec?: string;
  /**
   * A user-friendly error message
   * @example "You do not have access to this resource"
   */
  message?: string;
  /** unix timestamp in seconds */
  date?: STime;
}

/** string array representing an order of IDs */
export type Order = object | null;

/** @example "America/Los_Angeles" */
export type TimezoneID = string;

/**
 * unix timestamp in seconds
 * @format int64
 * @example 1608742037016
 */
export type STime = number;

/**
 * unix timestamp in seconds
 * @format int64
 * @example 1608742037016
 */
export type STimePtr = number | null;

export type IDNode = object | null;

export type FlatNode = object | null;

/** @example "board" */
export enum BoardLayout {
  Board = "board",
  List = "list",
  Timeline = "timeline",
  Calendar = "calendar",
}

/** @example "blue" */
export enum TagColor {
  Fog = "fog",
  Slate = "slate",
  Grey = "grey",
  Charcoal = "charcoal",
  Black = "black",
  Red = "red",
  Orange = "orange",
  Yellow = "yellow",
  Green = "green",
  Ocean = "ocean",
  Blue = "blue",
  Purple = "purple",
  Pink = "pink",
}

/** @example "blocks" */
export enum LinkedCardType {
  Blocks = "blocks",
  BlockedBy = "blocked_by",
  Related = "related",
  Duplicates = "duplicates",
}

export interface CardHintTag {
  name?: "bug" | "feature";
}

export interface CardHintRelation {
  card?: HintCard;
  /**
   * similarity score between 0 and 1
   * @format float64
   * @example 0.8
   */
  similarity?: number;
}

export interface CardHint {
  /**
   * defines the type of hint
   * @example "tag"
   */
  type?: "tag" | "relation";
  /** only present if type is tag */
  tag?: CardHintTag | null;
  /** only present if type is relation */
  relation?: CardHintRelation | null;
}

export interface CardHintAction {
  /**
   * defines the type of action
   * @example "ignore"
   */
  type?: "ignore";
  /** tag slug to ignore */
  tag_slug?: string | null;
  /** card id to ignore */
  related_card_id?: string | null;
}

export interface UpdateCardHintsRequest {
  /** @minItems 1 */
  actions?: CardHintAction[];
}

export interface File {
  /** @example "42" */
  id?: string;
  /** @example "t4Ads0rx" */
  team_id?: string;
  /** @example "image/png" */
  type?: string;
  /** @example "my_image.png" */
  name?: string;
  /** @example "https://example.com/path/to/file.png" */
  url?: string;
  /** @example "431" */
  page_id?: string;
  /** @example "433" */
  card_id?: string;
  /** @example "udsu0j19" */
  user_id?: string;
  /** describes a user or robot that created or updated a resource */
  user?: Actor;
  /** describes a user or robot that created or updated a resource */
  user_updated?: Actor;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** @example "LFE.@D9F01_2%L%MIVD*9Goe-;WB" */
  blurhash?: string;
  /** @example "https://example.com/path/to/thumb.png" */
  thumbnail?: string;
  /** @example "LFE.@D9F01_2%L%MIVD*9Goe-;WB" */
  thumbnail_blurhash?: string;
  /** true if the file is an attachment, false if it is referenced inline within text */
  is_attachment?: boolean;
}

export interface Tag {
  /** @example "u-dsu0j19" */
  id?: string;
  /** @example "u-dsu0j19" */
  team_id?: string;
  /** @example "5" */
  project_id?: string;
  /** @example "todo" */
  name?: string;
  /** @example "todo" */
  slug?: string;
  color?: TagColor;
  /**
   * number of cards that use this tag
   * @example 17
   */
  total_cards?: number;
}

export interface GetFileResponse {
  file?: File;
}

export type GetFilesResponse = ResponseMetadata & {
  files?: File[];
};

export type UploadFilesResponse = ResponseMetadata & {
  files?: File[];
};

export interface UpdateFileRequest {
  /** @example "my_file_name" */
  name?: string | null;
  /**
   * the page id to attach the file to
   * @example "41"
   */
  page_id?: string | null;
  /**
   * the card id to attach the file to
   * @example "12"
   */
  card_id?: string | null;
  /** associate this file with a resource, listing it as an attachment. Only relevant when uploading files to cards. Defaults to false */
  attachment?: boolean | null;
}

export interface UpdateFileResponse {
  file?: File;
}

export interface Image {
  type: "image" | "icon" | "emoji";
  /**
   * Depending on the type this can be a URL, base64 image data, emoji unicode or an icon name
   * @example "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="
   */
  src: string;
  /** @example "LEHV6nWB2yk8pyoJadR*.7kCMdnj" */
  blurhash?: string;
  /** @example "black" */
  color?: string;
  /**
   * Emoji string ID
   * @example "thumbsup"
   */
  emoji?: string;
}

export type CoverImage = Image & {
  positionY?: number;
};

export interface Notification {
  /** @example "44e4bc86-f3a8-11eb-9a03-0242ac130003" */
  id?: string;
  type?: NotificationType;
  /** unix timestamp in seconds */
  time_created?: STime;
  /** unix timestamp in seconds */
  time_updated?: STime;
  seen: boolean;
  read: boolean;
  interacted: boolean;
  /** type of the resource that is the subject of the action */
  resource_type?: "card" | "board" | "sprint" | "project" | "page" | "epic";
  /**
   * id of the resource that is the subject of the action
   * @example "7"
   */
  resource_id?: string;
  /**
   * name of the resource that is the subject of the action
   * @example "Backlog Board"
   */
  resource_name?: string;
  resource_icon?: Image;
  /**
   * id of the user who performed the action (moved the card, archived the page, etc.)
   * @example "usg094u4i"
   */
  actor_user_id?: string;
  /** describes a user or robot that created or updated a resource */
  actor_user?: Actor;
  /**
   * id of the comment related to the action (optional). if parent_comment_id is set this is a child comment
   * @example "1"
   */
  comment_id?: string;
  /**
   * parent id of the comment related to the action (optional)
   * @example "2"
   */
  parent_comment_id?: string;
  comment_status?: "resolved" | "open" | "orphaned";
  /**
   * some plaintext context or content for the action (optional)
   * @example "...blah blah blah. This is a snipped of a comment in which the @user is mentioned. Blah blah blah..."
   */
  excerpt?: string;
  resource_moved?: {
    from?: CardBreadcrumb;
    to?: CardBreadcrumb;
  };
  resource_deleted?: {
    from?: CardBreadcrumb;
  };
  resource_dates_changed?: {
    /** unix timestamp in seconds */
    from_start?: STime;
    /** unix timestamp in seconds */
    to_start?: STime;
    /** unix timestamp in seconds */
    from_end?: STime;
    /** unix timestamp in seconds */
    to_end?: STime;
  };
  /** type of the resource that the subject of a move is being moved to (optional) */
  destination_type?: "card" | "list" | "board" | "project";
  /**
   * id of the resource that the subject of a move is being moved to (optional)
   * @example "3"
   */
  destination_id?: string;
  /**
   * display name of the resource that the subject of a move is being moved to (optional)
   * @example "In Progress"
   */
  destination_name?: string;
  /** id of the project containing the resource */
  project_id?: string;
  /** id of the reaction */
  reaction_id?: string;
  /** unicode of the reaction */
  reaction_unicode?: string;
  /** variation of the reaction */
  reaction_variation?: string;
  /** due date of the resource */
  due_date?: STimePtr;
  /** days remaining until the due date */
  days_remaining?: number;
}

export enum NotificationType {
  MemberAdded = "member_added",
  MemberRemoved = "member_removed",
  UserMentioned = "user_mentioned",
  CommentAdded = "comment_added",
  CommentStatusUpdated = "comment_status_updated",
  ImportCompleted = "import_completed",
  ResourceCreated = "resource_created",
  ResourceAdded = "resource_added",
  ResourcePublished = "resource_published",
  ResourceMoved = "resource_moved",
  ResourceArchived = "resource_archived",
  ResourceDeleted = "resource_deleted",
  ResourceDueSoon = "resource_due_soon",
  ResourceOverdue = "resource_overdue",
  ResourceConverted = "resource_converted",
  ResourceCompleted = "resource_completed",
  ResourceCancelled = "resource_cancelled",
  ResourceDatesChanged = "resource_dates_changed",
  ReactionAdded = "reaction_added",
}

export type NotificationResults = ResponseMetadata & {
  notifications?: Notification[];
};

export interface UpdateNotificationsRequest {
  /** ID of the most recent notification the user has seen. The notification and all the notifications before it will be marked as seen. */
  seen_up_to_id?: string | null;
  /** ID of the most recent notification the user has read. The notification and all the notifications before it will be marked as read. */
  read_up_to_id?: string | null;
}

export interface UpdateNotificationRequest {
  read?: boolean | null;
  interacted?: boolean | null;
}

export interface GetNotificationCountResponse {
  count: number;
}

export interface NotificationDigest {
  /** @example "tARGLH5d" */
  team_id?: string;
  /** @example "u2DdoERz" */
  user_id?: string;
  /** enable/disable the digest */
  enabled: boolean;
  /**
   * frequency of the digest
   * @example "daily"
   */
  frequency?: "daily";
  /**
   * Time of day to send the digest in the form hh:mm (user's local time, not UTC)
   * @example "09:00"
   */
  daily_time?: string;
  /**
   * Days of the week to skip sending the digest. 0 indexed from Sunday. Sunday=0, Monday=1, etc.
   * @example [0,6]
   */
  skip_days: number[];
}

export interface GetNotificationDigestResponse {
  digest?: NotificationDigest;
}

export interface UpdateNotificationDigestRequest {
  /** enable/disable the digest */
  enabled?: boolean | null;
  /**
   * Time of day to send the digest in the form hh:mm (user's local time, not UTC)
   * @example "09:00"
   */
  daily_time?: string | null;
  /**
   * Days of the week to skip sending the digest. 0 indexed from Sunday. Sunday=0, Monday=1, etc.
   * @example [0,6]
   */
  skip_days?: number[];
}

export interface UpdateNotificationDigestResponse {
  digest?: NotificationDigest;
}

export type GetNotificationDigestSettingsResponse = NotificationForwardingSettings;

export type UpdateNotificationDigestSettingsRequest = NotificationForwardingSettings;

export type UpdateNotificationDigestSettingsResponse = NotificationForwardingSettings;

export type UpdateNotificationEmailsRequest = NotificationForwardingSettings & {
  /** enable/disable the email notifications */
  enabled?: boolean | null;
};

export type UpdateNotificationEmailsResponse = NotificationForwardingSettings & {
  /** are the email notifications enabled */
  enabled: boolean;
};

export type GetNotificationEmailsResponse = NotificationForwardingSettings & {
  /** are the email notifications enabled */
  enabled: boolean;
};

export interface IntegrationInstallation {
  /** @example "tARGLH5d" */
  team_id?: string;
  /** @example "github" */
  installation_type?:
    | "github"
    | "gitlab"
    | "google_calendar_user_notes"
    | "slack_user"
    | "slack_team_unfurl"
    | "slack_channel_webhook"
    | "zapier";
  /** @example "65432" */
  id?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_created?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_updated?: STime;
  /** @example "u2DdoERz" */
  user_id_updated?: string;
  github?: GithubInstallation;
  slack_user?: SlackUserInstallation;
  slack_channel_webhook?: SlackChannelWebhookInstallation;
  google_calendar_user_notes?: GoogleCalendarUserNotesInstallation;
}

export interface IntegrationSettings {
  calendar_user_notes?: CalendarUserNotesSettings;
  slack_user?: NotificationForwardingSettings;
}

export enum IntegrationSettingsType {
  CalendarUserNotes = "calendar_user_notes",
  SlackUser = "slack_user",
}

export interface ExternalLink {
  type?: ExternalLinkType;
  github_pull_request?: GithubPullRequest;
}

export enum ExternalLinkType {
  GithubPullRequest = "github_pull_request",
}

export interface GithubPullRequest {
  id?: number | null;
  number?: number | null;
  state?: string | null;
  title?: string | null;
  body?: string | null;
  html_url?: string | null;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_created?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_updated?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_closed?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_merged?: STime;
  head?: GithubPullRequestBranch | null;
  base?: GithubPullRequestBranch | null;
  draft?: boolean | null;
  merged?: boolean | null;
}

export interface GithubRepository {
  id?: number | null;
  name?: string | null;
  html_url?: string | null;
}

export interface GithubPullRequestBranch {
  label?: string | null;
  ref?: string | null;
}

export interface GithubInstallation {
  /** @example "superthread-com" */
  account_name?: string;
  repositories?: GithubRepository[];
}

export interface SlackUserInstallation {
  user_id?: string;
}

export interface SlackChannelWebhookInstallation {
  /**
   * The slack channel name to which the webhook will be posting messages.
   * @example "#general"
   */
  channel?: string;
  /** The slack channel type to which the webhook will be posting messages. */
  channel_type?: "public" | "private" | "dm" | "group";
  /**
   * The board ID to which the webhook is associated with.
   * @example "42"
   */
  board_id?: string;
  /**
   * The slack webhook URL that holds the token to post messages to the configured channel.
   * @example "https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX"
   */
  webhook_url?: string;
}

export interface GoogleCalendarUserNotesInstallation {
  /** describes a user or robot that created or updated a resource */
  actor_user?: Actor;
  /** The primary calendar ID of the user. */
  primary_calendar_id?: string;
  scopes?: string[];
}

export interface CalendarUserNotesSettings {
  /** The number of days to show calendar meetings ahead. */
  days_in_advance: number | null;
  filters?: {
    /** If true, it filters out events where there is no participants, or the only participant is the user. */
    participants: boolean | null;
    /** If true, it filters out events where there is no meeting link available. */
    event_link: boolean | null;
    /** If true, it filters out all-day events. */
    all_day: boolean | null;
  };
  notifications?: {
    /** Enable/disable the notifications about upcoming meetings. */
    enabled: boolean | null;
    /** If true, it includes the meeting name in the notification. */
    meeting_name: boolean | null;
    /** If true, it includes the meeting time in the notification. */
    meeting_time: boolean | null;
  };
}

export interface GoogleCalendarEventAttendee {
  /** The email of the attendee. */
  email: string | null;
  /** The name of the attendee. */
  name: string | null;
  /** Set to true when the attendee is the event organizer. */
  organizer: boolean | null;
}

export interface GoogleCalendarEvent {
  /** Unique identifier for the event. */
  id?: string;
  /** Identifier for the recurring event series. */
  recurring_event_id?: string;
  /** The event's title or name (Summary in Google Calendar). */
  title?: string;
  /** Detailed description of the event. */
  description?: string;
  /** A list of meeting links with their respective providers. */
  meeting_links?: MeetingLink[];
  /** List of event attendees. */
  attendees?: GoogleCalendarEventAttendee[];
  /** The event's start time. */
  start: STimePtr | null;
  /** The event's end time. */
  end: STimePtr | null;
  /** The last time the event was updated. */
  updated: STimePtr | null;
  /** Free-form text for the event location. */
  location?: string;
}

export interface GetGoogleCalendarUserNotesEventsResponse {
  events?: GoogleCalendarEvent[];
}

export interface NotificationForwardingSettings {
  notify_added_to_card: boolean | null;
  notify_card_moved: boolean | null;
  notify_card_archived: boolean | null;
  notify_card_deleted: boolean | null;
  notify_card_added: boolean | null;
  notify_card_due_soon: boolean | null;
  notify_card_overdue: boolean | null;
  notify_added_to_page: boolean | null;
  notify_page_published: boolean | null;
  notify_page_moved: boolean | null;
  notify_page_archived: boolean | null;
  notify_page_deleted: boolean | null;
  notify_added_to_board: boolean | null;
  notify_board_archived: boolean | null;
  notify_board_moved: boolean | null;
  notify_board_deleted: boolean | null;
  notify_added_to_project: boolean | null;
  notify_project_archived: boolean | null;
  notify_project_deleted: boolean | null;
  notify_card_comment: boolean | null;
  notify_card_comment_status_updated: boolean | null;
  notify_page_comment: boolean | null;
  notify_page_comment_status_updated: boolean | null;
  notify_mentioned: boolean | null;
  notify_reaction: boolean | null;
  notify_import_complete: boolean | null;
}

export type GetIntegrationInstallationsResponse = ResponseMetadata & {
  installations?: IntegrationInstallation[];
};

export type GetIntegrationInstallationResponse = IntegrationInstallation;

export interface CreateIntegrationInstallationRequest {
  github?: {
    id?: string;
  };
  slack_user?: {
    code?: string;
    /** the redirect URI used to obtain the slack code. this is needed by the backend to exchange the code for an access token. */
    redirect_uri?: string;
  };
  slack_team_unfurl?: {
    code?: string;
    /** the redirect URI used to obtain the slack code. this is needed by the backend to exchange the code for an access token. */
    redirect_uri?: string;
  };
  slack_channel_webhook?: {
    code?: string;
    /** the redirect URI used to obtain the slack code. this is needed by the backend to exchange the code for an access token. */
    redirect_uri?: string;
    /** The slack channel name to which the webhook will be posting messages */
    channel?: string;
    /** The board ID to which the webhook is associated with. */
    board_id?: string;
  };
  zapier?: {
    /** zapier's rest hook url to submit events to */
    hook_url?: string;
    /** project ID to which this event relates */
    project_id?: string;
    /** zapier's trigger type (e.g. card.created) */
    type?: string;
  };
  google_calendar_user_notes?: {
    code?: string;
    /** the redirect URI used to obtain the google code. this is needed by the backend to exchange the code for an access token. */
    redirect_uri?: string;
  };
}

export type CreateIntegrationInstallationResponse = IntegrationInstallation;

export type GetIntegrationSettingsResponse = IntegrationSettings;

export type UpdateIntegrationSettingsRequest = IntegrationSettings;

export type UpdateIntegrationSettingsResponse = IntegrationSettings;

export interface Import {
  id?: string;
  source?: ImportSource;
  /** @example "u123f01z" */
  user_id?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_created?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_updated?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_started?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_completed?: STime;
  status?: "unstarted" | "in_progress" | "success" | "error";
  /** depending on the status, could be either an error message or other details relating to the import */
  additional_notes?: string;
  board_mapping?: ImportBoardMapping[];
  user_mapping?: ImportUserMapping[];
  overview?: ImportOverview;
}

export type GetImportsResponse = ResponseMetadata & {
  imports?: Import[];
};

export interface CreateImportRequest {
  source?: ImportSource;
  jira_credentials?: ImportJiraCredentials;
  trello_credentials?: ImportTrelloCredentials;
  shortcut_credentials?: ImportShortcutCredentials;
}

export interface CreateImportResponse {
  import?: Import;
}

export interface UpdateImportRequest {
  board_mapping?: ImportBoardMapping[] | null;
  user_mapping?: ImportUserMapping[] | null;
  import_stale?: boolean | null;
  import_attachments?: boolean | null;
  import_card_covers?: boolean | null;
}

export interface UpdateImportResponse {
  import?: Import;
}

export interface QueueImportResponse {
  import?: Import;
}

export enum ImportSource {
  Trello = "trello",
  Jira = "jira",
  Shortcut = "shortcut",
}

export interface ImportBoardMapping {
  source_board_id?: string;
  source_board_title?: string;
  target_project_id?: string;
  /** appears once import has finished */
  target_board_id?: string;
}

export interface ImportUserMapping {
  source_user_id?: string;
  source_user_display_name?: string;
  target_user_id?: string | null;
  email_invite?: string | null;
  /** (optional) team role. defaults to 'admin' */
  role?: "admin" | "member" | null;
}

export interface ImportOverview {
  issues?: number;
  issues_skip?: number;
  users?: number;
  users_skip?: number;
}

export interface ImportJiraCredentials {
  pac?: string;
  email?: string;
  hostname?: string;
}

export interface ImportTrelloCredentials {
  api_key?: string;
  token?: string;
}

export interface ImportShortcutCredentials {
  api_token?: string;
}

export interface GetTimeReportResponse {
  report?: {
    type?: string;
    /** unix timestamp in seconds */
    time_from?: STime;
    /** unix timestamp in seconds */
    time_to?: STime;
    stats?: CardTotal[];
    data?: TimeReportEntries[];
  };
}

export interface CardTotal {
  type?: "added" | "finished";
  value: number;
}

export interface TimeReportEntries {
  label?: string;
  entries?: TimeReportEntry[];
}

export interface TimeReportEntry {
  /** unix timestamp in seconds */
  time?: STime;
  value: number;
}

export enum EstimateSystem {
  Value = "",
  Fibonacci = "fibonacci",
  Exponential = "exponential",
  Tshirt = "tshirt",
}

/** LLM task definition for simplifying text */
export interface LLMTaskSimplify {
  /** text to simplify */
  input: string;
}

/** LLM task definition for rephrasing text */
export interface LLMTaskRephrase {
  /** tone of the rephrase */
  tone: "academic" | "casual" | "confident" | "friendly" | "neutral" | "professional";
  /** text to rephrase */
  input: string;
}

/** LLM task definition for summarizing text */
export interface LLMTaskSummarize {
  /**
   * approximate length of the summary
   * @max 200
   */
  approx_len?: number;
  /** text to summarize */
  input: string;
}

/** LLM task definition for translating text */
export interface LLMTaskTranslate {
  /** language code of the target language */
  lang: "en" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt" | "zh";
  /** text to translate */
  input: string;
}

/** LLM task definition for generating text */
export interface LLMTaskGenerate {
  /**
   * description of text to generate
   * @max 200
   */
  instructions: string;
}

/** instructions describing expected output from a LLM model */
export interface CreateLLMTaskRequest {
  /** LLM task definition for rephrasing text */
  rephrase?: LLMTaskRephrase;
  /** LLM task definition for simplifying text */
  simplify?: LLMTaskSimplify;
  /** LLM task definition for summarizing text */
  summarize?: LLMTaskSummarize;
  /** LLM task definition for translating text */
  translate?: LLMTaskTranslate;
  /** LLM task definition for generating text */
  generate?: LLMTaskGenerate;
}

/** result text of an LLM model output */
export interface CreateLLMTaskResponse {
  /** text from the LLM model */
  output?: string;
}

/** LLM output stream chunk */
export interface CreateLLMTaskStreamChunk {
  /** type (output, error, end of stream) */
  t?: "out" | "err" | "end";
  /** value */
  v?: string;
}

/** request for an AI model to answer a question */
export interface AskAIRequest {
  /**
   * question to ask
   * @minLength 10
   */
  question?: string;
  /** type of resources to pull data from */
  resource_types?: ("card" | "page" | "comment" | "file" | "note")[] | null;
}

/** result text of an LLM model output */
export interface AskAIResponse {
  /** text from the LLM model */
  output?: string;
}

/** LLM output stream chunk */
export interface AskAIStreamChunk {
  /** type (source, output, error, end of stream) */
  t?: "src" | "out" | "err" | "end";
  /** value */
  v?: string;
}

export interface AgentRunIteration {
  /** Unique Agent Run Iteration identifier. */
  id?: string;
  /** Team ID of the agent run iteration */
  team_id?: string;
  /** Agent Run ID of the agent run iteration */
  agent_run_id?: string;
  /** Input text for the agent run iteration */
  input?: string;
  /** Output text for the agent run iteration */
  output?: string;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  time_created?: STime;
  /**
   * unix timestamp in seconds
   * @example 1608742037016
   */
  time_updated?: STime;
  /** Reason for the agent run iteration */
  reason?: string;
  /** Time taken for the agent run iteration to complete in milliseconds */
  time_elapsed?: number;
  /** Number of input tokens used */
  input_tokens?: number;
  /** Number of output tokens used */
  output_tokens?: number;
}

export interface Agent {
  /** Team ID is the workspace identifier. */
  team_id?: string;
  /** Unique Agent identifier (uuid). */
  id?: string;
  /** Display name of the agent */
  name?: string;
  /** URL of the agent's avatar */
  icon?: Image;
  /** A string that is used as the prompt when sendig request to the AI service. */
  prompt?: string;
  /** Defines whether the Agent is active (if true) or inactive (if false). */
  active?: boolean;
  /** List of resources the agent is attached to. */
  attached_resources?: AgentAttachment[];
  /**
   * Unix timestamp in seconds when the Agent was created.
   * @example 1608742037016
   */
  time_created?: STime;
  /**
   * Unix timestamp in seconds when the Agent was last updated.
   * @example 1608742037016
   */
  time_updated?: STime;
  /** User ID of the creator of the agent */
  user_id?: string;
  /** List of runs for the agent */
  runs?: AgentRun[];
}

export interface AgentPrompt {
  /** Team ID is the workspace identifier. */
  team_id?: string;
  /** Team ID is the workspace identifier. */
  agent_id?: string;
  /** List of iterations for the agent prompt */
  iterations?: AgentPromptIteration[];
}

export interface AgentPromptIteration {
  /** Incremental ID which identifies the iteration. */
  id?: string;
  /** The message that was sent by the user to the AI Assistant. */
  request?: string;
  /** The response by the AI Assistant to the user message. */
  response?: string;
  /** The proposed Agent Prompt by the Assistant for the given iteration. */
  prompt?: string;
  /** Indicates if the prompt is incomplete, achievable, or unachievable based on the given context. Can also be error in case there was an issue talking to the AI Assistant. */
  status?: "in-progress" | "draft" | "ready" | "unattainable" | "error";
  /** User who sent the request/message to the Assistant. */
  actor_user?: Actor;
  /** Reasoning or notes from the AI Assistant. */
  reasoning?: string;
  /** List of API functions or endpoints considered/recommended to achive the goal. */
  functions?: string[];
  /** List of events suggested by the AI in this iteration. */
  triggers?: string[];
  /**
   * Unix timestamp in seconds when the requeset was created.
   * @example 1608742037016
   */
  time_created?: STime;
  /**
   * Unix timestamp in seconds when the requeset was updated.
   * @example 1608742037016
   */
  time_updated?: STime;
}

export interface AgentAttachment {
  /** Agent attachment ID */
  attachment_id?: string;
  /** User who created the attachment */
  user?: Actor;
  /** Defines the type of a resource an Agent can act on or can be attached to. */
  resource_type?: "epic" | "note" | "project" | "page" | "board" | "sprint" | "card";
  /**
   * The unique Resource ID which the agent is attached to.
   * '*' means it applies to all resouces of the given type
   */
  resource_id?: string;
  /**
   * Unix timestamp in seconds when the attachment was created.
   * @example 1608742037016
   */
  time_created?: STime;
}

export interface AgentRun {
  /** Unique identifier for an Agent invocation */
  id?: string;
  /** Team ID (workspace identifier) where the Agent runs */
  team_id?: string;
  /** The Agent ID of the agent run */
  agent_id?: string;
  /** Defines the type of a resource an Agent can act on or can be attached to. */
  resource_type?: "epic" | "note" | "project" | "page" | "board" | "sprint" | "card";
  /** Resource ID on which the Agent is running */
  resource_id?: string;
  /** Status of the agent run */
  status?: "running" | "completed" | "failed";
  /** Time taken for the agent run to complete in milliseconds */
  time_elapsed?: number;
  /** Number of input tokens used */
  input_tokens?: number;
  /** Number of output tokens used */
  output_tokens?: number;
  /** Total cost of the agent run */
  total_cost?: number;
  iterations?: AgentRunIteration[];
  /**
   * Unix timestamp in seconds when the run was created.
   * @example 1608742037016
   */
  time_created?: STime;
  /**
   * Unix timestamp in seconds when the run was last updated.
   * @example 1608742037016
   */
  time_updated?: STime;
  /** User ID of the creator of the agent run */
  user_id?: string;
}

export interface AIGeneratedAction {
  /**
   * Unique identifier for the AI generated action
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id?: string;
  /** @example "t921j9j1" */
  team_id?: string;
  /**
   * Note ID associated with the action
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  note_id?: string;
  /**
   * AI Enhanced Note ID associated with the action
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  ai_note_id?: string;
  /** Type of the AI generated action */
  type?: "create_card" | "update_card" | "move_card" | "create_comment" | "assign_members" | "remove_members";
  /** Status of the AI generated action */
  status?: ActionStatus;
  /**
   * Unix timestamp in seconds when the action was created.
   * @example 1608742037016
   */
  time_created?: STime;
  /**
   * Unix timestamp in seconds when the action was last updated.
   * @example 1608742037016
   */
  time_updated?: STime;
  /**
   * Unix timestamp in seconds when the action was executed.
   * @example 1608742037016
   */
  time_executed?: STime;
  /** Create a card */
  create_card?: AIGeneratedActionCreateCard | null;
  /** Update a card */
  update_card?: AIGeneratedActionUpdateCard | null;
  /** Move a card */
  move_card?: AIGeneratedActionMoveCard | null;
  /** Create a comment */
  create_comment?: AIGeneratedActionCreateComment | null;
  /** Assign members to a card */
  assign_members?: AIGeneratedActionAssignMembers | null;
  /** Remove members from a card */
  remove_members?: AIGeneratedActionRemoveMembers | null;
}

export interface AIGeneratedActionCreateCard {
  /** Title of the card */
  title: string;
  /** Description of the card */
  content: string;
  /** List of assignees of the card */
  assignees?: string[];
  /** Due date of the card */
  due_date?: STime;
}

export interface AIGeneratedActionUpdateCard {
  /** Card ID to update */
  card_id: string;
  /** New title of the card */
  title?: string;
  /** Due date of the card */
  due_date?: STime;
}

export interface AIGeneratedActionMoveCard {
  /** Card ID to move */
  card_id: string;
  status: ListBehavior;
}

export interface AIGeneratedActionCreateComment {
  /** Card ID to add comment to */
  card_id: string;
  /** Content of the comment */
  content: string;
}

export interface AIGeneratedActionAssignMembers {
  /** Card ID to update */
  card_id: string;
  /** User IDs to assign to the card */
  user_ids: string[];
}

export interface AIGeneratedActionRemoveMembers {
  /** Card ID to update */
  card_id: string;
  /** User IDs to remove from the card */
  user_ids: string[];
}

export interface CreateAIAgentRequest {
  /** Display name of the agent */
  name: string;
  /** Agent Icon */
  icon: Image;
  /** Defines whether the Agent is active (if true) or inactive (if false). */
  active: boolean;
}

export interface CreateAIAgentResponse {
  agent?: Agent;
}

export interface UpdateAIAgentRequest {
  /** Display name of the agent */
  name?: string | null;
  /** Agent Icon */
  icon?: Image | null;
  /** Update the Prompt by sending the Prompt Iteration ID from the conversational prompt builder. */
  prompt_iteration_id?: string | null;
  /** Defines whether the Agent is active (if true) or inactive (if false). */
  active: boolean | null;
}

export interface UpdateAIAgentResponse {
  agent?: Agent;
}

export interface AttachAIAgentRequest {
  /** Defines the type of a resource an Agent can act on or can be attached to. */
  resource_type: "epic" | "note" | "project" | "page" | "board" | "sprint" | "card";
  /** Resource ID to attach the Agent to. */
  resource_id: string;
}

export interface AttachAIAgentResponse {
  agent?: Agent;
}

export interface DetachAIAgentResponse {
  agent?: Agent;
}

export interface GetAIAgentResponse {
  agent?: Agent;
}

export type GetAIAgentsResponse = ResponseMetadata & {
  agents?: Agent[];
};

export type GetAIAgentRunsResponse = ResponseMetadata & {
  runs?: AgentRun[];
};

export interface GetAIAgentPromptIterationsResponse {
  agent_prompt?: AgentPrompt;
}

export interface AddAIAgentPromptIterationRequest {
  /** User's message to the AI Agent's Assistant. */
  message: string;
}

export interface AddAIAgentPromptIterationResponse {
  prompt_iteration?: AgentPromptIteration;
}

export interface VectorSearchResult {
  /** The team ID of the object that was found. */
  team_id?: string;
  /** The type of the object that was found. */
  resource_type?: "card" | "page" | "note" | "comment";
  /** The ID of the object that was searched for. */
  resource_id?: string;
  /** The chunk of text that matched the query. */
  extract?: string;
  /**
   * The cosine similarity score of the object to the query (-1 to 1).
   * @min -1
   * @max 1
   */
  cosine_similarity?: number;
}

export interface VectorSearchRequest {
  /**
   * The query string to search for. Will be converted to a vector and used to search for similar vectors.
   * @maxLength 1000
   */
  query?: string;
  /**
   * The maximum number of results to return.
   * @min 1
   * @max 20
   * @default 10
   */
  limit?: number;
  /**
   * The number of results to skip.
   * @min 0
   * @max 200
   * @default 0
   */
  offset?: number;
  /** The types of resources to search for. */
  types?: ("card" | "page" | "note" | "comment")[];
}

export interface VectorSearchResponse {
  results?: VectorSearchResult[];
}

/** Status of the AI action generation */
export enum AIActionGenerationStatus {
  Unstarted = "unstarted",
  InProgress = "in_progress",
  Completed = "completed",
}

export type GetAIActionsResponse = ResponseMetadata & {
  /** Status of the AI action generation */
  status?: AIActionGenerationStatus;
  actions?: AIGeneratedAction[];
};

export interface CreateAIActionsRequest {
  /** Note to generate actions for */
  note_id: string;
}

export interface CreateAIActionsResponse {
  actions?: AIGeneratedAction[];
}

export interface UpdateAIActionRequest {
  /** Type of the AI generated action */
  card_id?: string | null;
  /** Status of the AI generated action */
  status?: ActionStatus | null;
}

export interface UpdateAIActionResponse {
  action?: AIGeneratedAction;
}

/** Status of the AI generated action */
export enum ActionStatus {
  Pending = "pending",
  Completed = "completed",
  Dismissed = "dismissed",
}

/** onboarding action */
export interface OnboardingAction {
  /**
   * type of onboarding action
   * @example "create_space"
   */
  type?: string;
  /**
   * status of onboarding action
   * @example "completed"
   */
  status?: "completed" | "not_completed" | "dismissed";
}

/** onboarding action */
export type OnboardingActionsResponse = OnboardingAction & {
  /**
   * unix timestamp in seconds
   * @example 1608742037
   */
  time_updated?: STime;
};

/** list of onboarding actions */
export interface GetOnboardingActionsResponse {
  onboarding_actions?: OnboardingActionsResponse[];
}

/** list of onboarding actions to update */
export interface UpdateOnboardingActionsRequest {
  onboarding_actions?: OnboardingAction[];
}

/** list of onboarding actions */
export interface UpdateOnboardingActionsResponse {
  onboarding_actions?: OnboardingActionsResponse[];
}

/** subscription plan details */
export interface Plan {
  /**
   * plan id
   * @example "standard-yearly-2024.03"
   */
  id?: string;
  /**
   * stripe price id used to generate checkout session
   * @example "price_123"
   */
  stripe_price_id?: string;
  /**
   * is plan currently available
   * @example true
   */
  is_available?: boolean;
  /**
   * plan display name
   * @example "Standard"
   */
  name?: string;
  /**
   * plan price, expressed in cents (i.e. 1000 = $10.00)
   * @example 1000
   */
  price?: number;
  /**
   * plan period
   * @example "monthly"
   */
  period?: "monthly" | "yearly";
}

/** team's subscription */
export interface Subscription {
  /** Team ID is the workspace identifier. */
  team_id?: string;
  /**
   * stripe customer id
   * @example "cus_123"
   */
  stripe_customer_id?: string;
  /**
   * stripe subscription id
   * @example "sub_123"
   */
  stripe_subscription_id?: string;
  /**
   * plan id
   * @example "standard-2202.05"
   */
  plan_id?: string;
  /**
   * subscription status
   * @example "active"
   */
  status?: "active" | "canceled" | "past_due" | "trialing";
  /** data used to display subscription payment, status etc. */
  display_data?: object;
  /** date when subscription will change its status to canceled */
  cancel_at?: STime;
  /** date when the current billing period ends */
  current_period_end?: STime;
  /** number of Stripe seats in the subscription */
  seat_count?: number;
}

/** team's subscription plan */
export interface GetSubscriptionResponse {
  /** team's subscription */
  subscription?: Subscription;
}

/** list of available subscription plans */
export interface GetAvailablePlansResponse {
  plans?: Plan[];
}

/** billing session request body */
export interface CreateBillingSessionRequest {
  /**
   * url to redirect to after successful billing session
   * @example "https://example.com/"
   */
  success_url: string;
  /**
   * url to redirect to after canceling billing session
   * @example "https://example.com/"
   */
  cancel_url: string;
  /**
   * team name to create customer with
   * @example "My Team"
   */
  team_name?: string;
  /**
   * plan id to create billing session for
   * @example "standard-yearly-2024.03"
   */
  plan_id: string;
}

/** billing session response */
export interface CreateBillingSessionResponse {
  /**
   * billing portal url
   * @example "https://example.com/"
   */
  portal_url?: string;
}

/** billing management session request body */
export interface CreateBillingManagementSessionRequest {
  /**
   * url to redirect to after successfully changing billing information
   * @example "https://example.com/"
   */
  return_url: string;
  /**
   * customer id to create billing management session for
   * @example "cus_123456789"
   */
  stripe_customer_id: string;
}

/** billing management session response */
export interface CreateBillingManagementSessionResponse {
  /**
   * billing management session portal url
   * @example "https://example.com/"
   */
  portal_url?: string;
}

/** list of cards for an epic */
export interface GetAllCardsForEpicResponse {
  cards?: Card[];
}

/** brief view of epic to be used in a card */
export interface EpicBrief {
  /**
   * epic id
   * @example "e-123"
   */
  id?: string;
  /**
   * epic title
   * @example "Epic Title"
   */
  title?: string;
  /** epics icon */
  icon?: Image;
}

/** response for adding a card to an epic */
export interface AddCardToEpicResponse {
  /** brief view of epic to be used in a card */
  epic?: EpicBrief;
}

/**
 * user's transcription language
 * @example "en"
 */
export enum TranscriptionLanguage {
  Multi = "multi",
  Bg = "bg",
  Ca = "ca",
  Zh = "zh",
  ZhCN = "zh-CN",
  ZhHans = "zh-Hans",
  ZhTW = "zh-TW",
  ZhHant = "zh-Hant",
  ZhHK = "zh-HK",
  Cs = "cs",
  Da = "da",
  DaDK = "da-DK",
  Nl = "nl",
  En = "en",
  EnUS = "en-US",
  EnAU = "en-AU",
  EnGB = "en-GB",
  EnNZ = "en-NZ",
  EnIN = "en-IN",
  Et = "et",
  Fi = "fi",
  NlBE = "nl-BE",
  Fr = "fr",
  FrCA = "fr-CA",
  De = "de",
  DeCH = "de-CH",
  El = "el",
  Hi = "hi",
  Hu = "hu",
  Id = "id",
  It = "it",
  Ja = "ja",
  Ko = "ko",
  KoKR = "ko-KR",
  Lv = "lv",
  Lt = "lt",
  Ms = "ms",
  No = "no",
  Pl = "pl",
  Pt = "pt",
  PtBR = "pt-BR",
  PtPT = "pt-PT",
  Ro = "ro",
  Ru = "ru",
  Sk = "sk",
  Es = "es",
  Es419 = "es-419",
  Sv = "sv",
  SvSE = "sv-SE",
  Th = "th",
  ThTH = "th-TH",
  Tr = "tr",
  Uk = "uk",
  Vi = "vi",
}

/** users settings */
export interface UserSettings {
  /** whether to open links from browser in electron app */
  open_links_in_app: boolean;
  /** jargon for transcription */
  transcription_keywords?: string[];
  /** whether to detect meetings */
  meeting_detection_enabled: boolean;
  /** apps to exclude from meeting detection */
  meeting_detection_excluded_apps?: string[];
  /** user's transcription language */
  transcription_language?: TranscriptionLanguage;
  /** whether to show upcoming meeting notifications */
  upcoming_meeting_notifications_enabled: boolean;
  /** whether to show upcoming meeting time next to menu bar icon */
  upcoming_meeting_menu_bar_time_enabled: boolean;
  /** whether to show upcoming meeting name next to menu bar icon */
  upcoming_meeting_menu_bar_name_enabled: boolean;
  /** whether to enable auto start transcription */
  auto_start_transcription: boolean;
  /** determines whether to start transcription for all notes or only for meetings, if auto start transcription is enabled */
  auto_start_transcription_mode: "always" | "meeting_only";
}

/** response for getting users settings */
export interface GetUserSettingsResponse {
  /** users settings */
  settings?: UserSettings;
}

/** request for updating user settings */
export interface UpdateUserSettingsRequest {
  /** whether to open links from browser in electron app */
  open_links_in_app?: boolean | null;
  /** jargon for transcription */
  transcription_keywords?: string[] | null;
  /** whether to detect meetings */
  meeting_detection_enabled?: boolean | null;
  /** apps to exclude from meeting detection */
  meeting_detection_excluded_apps?: string[] | null;
  /** user's transcription language */
  transcription_language?: TranscriptionLanguage | null;
  /** whether to show upcoming meeting notifications */
  upcoming_meeting_notifications_enabled?: boolean | null;
  /** whether to show upcoming meeting time next to menu bar icon */
  upcoming_meeting_menu_bar_time_enabled?: boolean | null;
  /** whether to show upcoming meeting name next to menu bar icon */
  upcoming_meeting_menu_bar_name_enabled?: boolean | null;
  /** whether to enable auto start transcription */
  auto_start_transcription?: boolean | null;
  /** determines whether to start transcription for all notes or only for meetings, if auto start transcription is enabled */
  auto_start_transcription_mode?: "always" | "meeting_only" | null;
}

/** response for updating user settings */
export interface UpdateUserSettingsResponse {
  /** users settings */
  settings?: UserSettings;
}

export interface ReportsSettings {
  /**
   * The unique identifier of the reports settings (UUID).
   * @example "cb8a43e4-07d2-45b6-95c7-b55f9576d681"
   */
  id?: string;
  /** @example "tARGLH5d" */
  team_id?: string;
  /**
   * Whether the reports are enabled or not.
   * @example true
   */
  enabled?: boolean;
  /**
   * The name of the report settings. Used in differentiating between multiple report settings.
   * @example "Daily IT Report"
   */
  name?: string;
  schedule?: {
    /**
     * The team's timezone. The scheduling will be based on this timezone.
     * @example "America/Los_Angeles"
     */
    timezone_id?: string;
    /**
     * The hour of the day when the report process should be initiated for the selected users (based on the selected timezone).
     * @example 9
     */
    start_hour?: number;
    /**
     * The minute of the hour when the report process should be initiated for the selected users (based on the selected timezone).
     * @example 0
     */
    start_minute?: number;
    /**
     * The duration in minutes to wait for after the report process started until the reports are generated. (90 = 1.5 hours)
     * @example 90
     */
    reporting_duration?: number;
    /**
     * The days of the week when the reports should be generated.
     * @uniqueItems true
     */
    frequency?: ("Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday")[];
  };
  /** The list of user IDs whose will be included in the generated report. */
  users?: string[];
  /**
   * The user's ID who last updated the settings.
   * @example "u2DdoERz"
   */
  user_id_updated?: string;
  /**
   * The time when the report settings were created.
   * @example 1608742037
   */
  time_created?: STime;
  /**
   * The time when the report settings was last updated.
   * @example 1608742037
   */
  time_updated?: STime;
  /**
   * The time when the reporting last ran.
   * @example 1608742037
   */
  time_last_run?: STime;
  /**
   * The time when the team report was created.
   * @example 1608742037
   */
  time_last_report?: STime;
  /**
   * The time when the next report process will be started.
   * @example 1608742037
   */
  time_next_run?: STime;
  /**
   * The time when the next report will be started to generate.
   * @example 1608742037
   */
  time_next_report?: STime;
}

export interface GetAllReportsSettingsResponse {
  settings?: ReportsSettings[];
}

export interface CreateReportsSettingsRequest {
  /** The name of the report settings. */
  name?: string;
}

export interface CreateReportsSettingsResponse {
  settings?: ReportsSettings;
}

export interface GetReportsSettingsResponse {
  settings?: ReportsSettings;
}

export interface UpdateReportsSettingsRequest {
  /** Whether the reports are enabled or not for the given team. */
  enabled: boolean | null;
  /** The name of the report settings. */
  name: string | null;
  /** The timezone of the team. The scheduling will be based on this timezone. */
  timezone_id?: string | null;
  /** The hour of the day when the report process should be initiated for the selected users (based on the selected timezone). */
  start_hour: number | null;
  /** The minute of the hour when the report process should be initiated for the selected users (based on the selected timezone). */
  start_minute: number | null;
  /** The duration in minutes to wait for after the report process started until the reports are generated (eg: 90 = 1.5 hours). */
  reporting_duration: number | null;
  /**
   * The days of the week when the reports should be scheduled to run.
   * @uniqueItems true
   */
  frequency: ("Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday")[] | null;
  /** @uniqueItems true */
  users: string[] | null;
}

export interface UpdateReportsSettingsResponse {
  settings?: ReportsSettings;
}

/** Daily report question and answer */
export interface DailyReportQA {
  /** Question */
  question?: string;
  /** Answer */
  answer?: string;
}

/** Daily report summary */
export interface DailyReportSummary {
  /** The summarized report based on the work context. Generated by AI. */
  proposed?: string;
  /** The corrected summary, or any additional notes added by the user. */
  user?: string;
  /** The final summary, takes into account the all the responses, as well as any additional notes from the user. */
  final?: string;
}

/** Specifies the user’s work context that the AI leverages to generate the daily report. */
export interface DailyReportWorkContext {
  /** List of cards that are assigned to the user but have not been started yet. */
  committed?: Card[];
  /** List of cards that are assigned to the user and is currently being worked on. */
  started?: Card[];
  /** List of cards that are assigned to the user and have been completed recently. */
  completed?: Card[];
}

/** Daily report context */
export interface DailyReportContext {
  /** Specifies the user’s work context that the AI leverages to generate the daily report. */
  work?: DailyReportWorkContext;
}

/** Daily report for a user */
export interface DailyReport {
  /**
   * Team ID/workspace identifier.
   * @example "tdc4e1b3"
   */
  team_id?: string;
  /**
   * User ID
   * @example "u1su0j19"
   */
  user_id?: string;
  /**
   * Daily report identifier. It follows the format: YYYY-MM-DD.
   * @example "2025-05-13T13:09:52.024Z"
   */
  id?: string;
  /** Daily report context */
  context?: DailyReportContext;
  /** Daily report summary */
  summary?: DailyReportSummary;
  /** List of questions and answers for the daily report. */
  questions?: DailyReportQA[];
  /** Whether the user has seen the report. Can indicate if the user is absent or not for the given day. */
  seen?: boolean;
  /** Date when the report was created. */
  time_created?: STime;
  /** Date when the report was last updated. */
  time_updated?: STime;
}

export interface GetDailyReportResponse {
  /** Daily report for a user */
  report?: DailyReport;
}

export interface GetDailyReportByIDResponse {
  /** Daily report for a user */
  report?: DailyReport;
}

export interface CreateDailyReportRequest {
  /**
   * The ID of the report settings to be used for generating the report.
   * @example "cb8a43e4-07d2-45b6-95c7-b55f9576d681"
   */
  settings_id?: string;
}

export interface CreateDailyReportResponse {
  /** Daily report for a user */
  report?: DailyReport;
}

export interface UpdateDailyReportByIDRequest {
  /** The clarification/notes to the suggested summary. */
  user_summary: string | null;
  /** Daily report question and answer */
  qa: DailyReportQA | null;
}

export interface UpdateDailyReportByIDResponse {
  /** Daily report for a user */
  report?: DailyReport;
}

export interface GetTeamBoardsCountResponse {
  /**
   * The total number of boards for the specified workspace.
   * @example 10
   */
  count?: number;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://api.superthread.com/v1" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Public API
 * @version 0.1
 * @baseUrl https://api.superthread.com/v1
 * @contact <engineering@superthread.com>
 *
 * Superthread Public API Specification
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  integrations = {
    /**
     * @description Fetches details about a specific OAuth2 client, including its name, icon URL, privacy policy URL, terms of service URL, and whether it is marked as trusted. Useful for displaying or managing OAuth2 integrations within your system.
     *
     * @tags Integrations, OAuth2
     * @name GetOAuth2Client
     * @summary display OAuth2 client information
     * @request GET:/oauth2/clients/{client_id}
     */
    getOAuth2Client: (clientId: string, params: RequestParams = {}) =>
      this.http.request<
        GetOAuth2ClientResponse,
        {
          error?: Error;
        }
      >({
        path: `/oauth2/clients/${clientId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Configure a new installation for an integration within a workspace. This endpoint supports creating installations for integrations like GitHub, Slack (user, team unfurl, or channel webhook), Zapier and Google Calendar. Provide the required configuration details specific to the integration type, such as Slack channel webhooks, GitHub repository access, or Zapier event triggers. This endpoint helps establish connections between external tools and the workspace for enhanced collaboration and automation. Note: Only one integration type can be created per request due to the structure of the request body.
     *
     * @tags Integrations
     * @name CreateIntegrationInstallation
     * @summary Create installation for an integration
     * @request POST:/{team_id}/integrations/{integration}/installations
     */
    createIntegrationInstallation: (
      teamId: string,
      integration:
        | "github"
        | "google_calendar_user_notes"
        | "slack_user"
        | "slack_team_unfurl"
        | "slack_channel_webhook"
        | "zapier",
      body: CreateIntegrationInstallationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        CreateIntegrationInstallationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/installations`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of installations for a specific integration within a workspace. This endpoint returns a list of installations for integrations like GitHub, Slack (user, team unfurl, or channel webhook), and Zapier. Use this endpoint to view the details of existing installations and their configuration settings.
     *
     * @tags Integrations
     * @name GetIntegrationInstallations
     * @summary Get installations for an integration
     * @request GET:/{team_id}/integrations/{integration}/installations
     */
    getIntegrationInstallations: (
      teamId: string,
      integration:
        | "github"
        | "google_calendar_user_notes"
        | "slack_user"
        | "slack_team_unfurl"
        | "slack_channel_webhook"
        | "zapier",
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetIntegrationInstallationsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/installations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the details of a specific installation within a workspace. This endpoint returns the configuration settings for the requested integration.
     *
     * @tags Integrations
     * @name GetInstallation
     * @summary Get installation
     * @request GET:/{team_id}/integrations/{integration}/installations/{installation_id}
     */
    getInstallation: (
      teamId: string,
      integration:
        | "github"
        | "google_calendar_user_notes"
        | "slack_user"
        | "slack_team_unfurl"
        | "slack_channel_webhook"
        | "zapier",
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetIntegrationInstallationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/installations/${installationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Remove an installation for an integration within a workspace.
     *
     * @tags Integrations
     * @name DeleteInstallation
     * @summary Delete installation
     * @request DELETE:/{team_id}/integrations/{integration}/installations/{installation_id}
     */
    deleteInstallation: (
      teamId: string,
      integration:
        | "github"
        | "google_calendar_user_notes"
        | "slack_user"
        | "slack_team_unfurl"
        | "slack_channel_webhook"
        | "zapier",
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/installations/${installationId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve the settings for a specific integration within a workspace. This endpoint returns the configuration settings for integrations like Slack (user, team unfurl, or channel webhook) and Zapier. Use this endpoint to view the current settings for each integration.
     *
     * @tags Integrations
     * @name GetIntegrationSettings
     * @summary Get integration settings
     * @request GET:/{team_id}/integrations/{integration}/settings
     */
    getIntegrationSettings: (
      teamId: string,
      integration: "calendar_user_notes" | "slack_user",
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetIntegrationSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the settings for a specific integration within a workspace. This endpoint allows you to modify the configuration settings for integrations like Slack (user or channel webhook) and Zapier. Use this endpoint to update the settings for each integration. Note: Only one integration can be updated per request due to the structure of the request body.
     *
     * @tags Integrations
     * @name UpdateIntegrationSettings
     * @summary Update integration settings
     * @request PATCH:/{team_id}/integrations/{integration}/settings
     */
    updateIntegrationSettings: (
      teamId: string,
      integration: "calendar_user_notes" | "slack_user",
      body: UpdateIntegrationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateIntegrationSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/${integration}/settings`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve upcoming events from the user's Google Calendar based on the user's settings defined by the installation ID.
     *
     * @tags Integrations, Notes
     * @name GetGcalEvents
     * @summary Get Google Calendar events
     * @request GET:/{team_id}/integrations/google_calendar_user_notes/{installation_id}/events
     */
    getGcalEvents: (teamId: string, installationId: string, params: RequestParams = {}) =>
      this.http.request<
        GetGoogleCalendarUserNotesEventsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/integrations/google_calendar_user_notes/${installationId}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * @description Fetches detailed information about a user, including profile details, teams, locale, and other metadata. Indicates if the token used in the request is privileged or outdated. Privileged tokens are necessary for specific sensitive operations like email updates.
     *
     * @tags Auth
     * @name GetUser
     * @summary Retrieve user details
     * @request GET:/users/{user_id}
     */
    getUser: (userId: string, params: RequestParams = {}) =>
      this.http.request<
        GetUserResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates user profile fields such as name, profile image, timezone, and company information. Allows selective updates, leaving unspecified fields unmodified. A successful request returns the updated user details.
     *
     * @tags Auth
     * @name UpdateUser
     * @summary Update user details
     * @request PATCH:/users/{user_id}
     */
    updateUser: (userId: string, body: UpdateUserRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateUserResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows a user to accept an invitation to join a specific team. Requires both the user and team IDs. Successful acceptance updates the team membership and invites metadata. In case the invitation doesn't exists, the request will fail.
     *
     * @tags Auth
     * @name AddUserTeam
     * @summary Accept Team Invite
     * @request PUT:/users/{user_id}/teams/{team_id}
     */
    addUserTeam: (userId: string, teamId: string, params: RequestParams = {}) =>
      this.http.request<
        AddUserTeamResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/teams/${teamId}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * @description Lists all pending team invitations for a user, including invite metadata such as sender details, team information, and invite status. Helps users manage pending invites and track actions required.
     *
     * @tags Auth
     * @name GetPendingInvites
     * @summary Retrieve pending team invites for a user
     * @request GET:/users/{user_id}/pending_invites
     */
    getPendingInvites: (userId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPendingInvitesForUserResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/pending_invites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Accepts and records user responses to the signup questionnaire. The answers include details such as company size, role, and work type. These responses help in tailoring the platform experience based on user preferences and requirements. A 204 No Content response indicates successful submission, while errors return detailed failure information.
     *
     * @tags Auth
     * @name SubmitSignupAnswers
     * @summary Submit user sign-up answers
     * @request POST:/users/{user_id}/signup_answers
     */
    submitSignupAnswers: (userId: string, body: SubmitUserSignupAnswersRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/signup_answers`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the user's email address, requiring a previously sent verification code for security. The new email must match the address where the code was sent. Returns the updated user details upon successful email change.
     *
     * @tags Auth
     * @name UpdateUserEmail
     * @summary Update a user's email
     * @request POST:/users/{user_id}/email
     */
    updateUserEmail: (userId: string, body: UpdateUserEmailRequest, params: RequestParams = {}) =>
      this.http.request<
        GetUserResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/email`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches the user's settings
     *
     * @tags Auth
     * @name GetUserSettings
     * @summary Get settings for user
     * @request GET:/users/{user_id}/settings
     */
    getUserSettings: (userId: string, params: RequestParams = {}) =>
      this.http.request<
        GetUserSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the user's settings fields. Allows selective updates, leaving unspecified fields unmodified. A successful request returns the updated user details.
     *
     * @tags Auth
     * @name UpdateUserSettings
     * @summary Updates user's settings
     * @request PATCH:/users/{user_id}/settings
     */
    updateUserSettings: (userId: string, body: UpdateUserSettingsRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateUserSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/settings`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends a verification code to the specified new email address, required for updating the user's email. Supports optional resend functionality to resend the code to the same address without requiring additional tokens. Privileged tokens are needed unless using the resend feature. (see /users/me for more details)
     *
     * @tags Auth
     * @name SendUpdateUserEmailCode
     * @summary Send an 'update user email' code
     * @request POST:/users/{user_id}/email/code
     */
    sendUpdateUserEmailCode: (
      userId: string,
      body: SendUpdateUserEmailCodeRequest,
      query?: {
        /** if true, will resend a new code to the same email address without requiring a privileged token */
        resend?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/email/code`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Provides a list of onboarding actions assigned to the user. Each action includes its type, status (e.g., completed, not_completed), and update timestamps. Helps track the user's onboarding progress.
     *
     * @tags Auth
     * @name GetOnboardingActions
     * @summary Get all onboarding actions for a user
     * @request GET:/users/{user_id}/onboarding_actions
     */
    getOnboardingActions: (userId: string, params: RequestParams = {}) =>
      this.http.request<
        GetOnboardingActionsResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/onboarding_actions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the statuses of onboarding actions for a user. Accepts a list of actions and their new statuses to reflect progress or dismissals. A successful update returns the modified actions.
     *
     * @tags Auth
     * @name UpdateOnboardingActions
     * @summary Update list of onboarding actions for a user
     * @request POST:/users/{user_id}/onboarding_actions
     */
    updateOnboardingActions: (userId: string, body: UpdateOnboardingActionsRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateOnboardingActionsResponse,
        {
          error?: Error;
        }
      >({
        path: `/users/${userId}/onboarding_actions`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new team (new workspace) and assigns the creator the "Owner" role. Additional properties like company name, email domain, and subdomain can be specified for better customization.
     *
     * @tags Auth
     * @name CreateTeam
     * @summary Create a team
     * @request POST:/teams
     */
    createTeam: (body: CreateTeamRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateTeamResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches a list of all available subscription plans that can be applied to a team (workspace).
     *
     * @tags Auth
     * @name GetAvailablePlans
     * @summary Get all available plans
     * @request GET:/teams/plans
     */
    getAvailablePlans: (params: RequestParams = {}) =>
      this.http.request<
        GetAvailablePlansResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/plans`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a specified team (workspace), including its properties and settings.
     *
     * @tags Auth
     * @name GetTeam
     * @summary Get a team
     * @request GET:/teams/{team_id}
     */
    getTeam: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetTeamResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates properties of a team (workspace), including its name, logo, domain, and company details. Omitted fields remain unchanged. Note that archiving a team is irreversible via the API.
     *
     * @tags Auth
     * @name UpdateTeam
     * @summary Update a team
     * @request PATCH:/teams/{team_id}
     */
    updateTeam: (teamId: string, body: UpdateTeamRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateTeamResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified team (workspace) and all associated data. This action is irreversible.
     *
     * @tags Auth
     * @name DeleteTeam
     * @summary Delete a team. This will also delete data. This is non reversible.
     * @request DELETE:/teams/{team_id}
     */
    deleteTeam: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        LogoutResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all members belonging to a specified team (workspace), along with their roles and other relevant details.
     *
     * @tags Auth
     * @name GetTeamMembers
     * @summary Get all team members
     * @request GET:/teams/{team_id}/members
     */
    getTeamMembers: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetTeamMembersResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/members`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the role of a specific member (`user_id`) within a workspace (`team_id`). Roles can include owner, admin, member, or guest.
     *
     * @tags Auth
     * @name UpdateMember
     * @summary Update a team member
     * @request PATCH:/teams/{team_id}/members/{user_id}
     */
    updateMember: (teamId: string, userId: string, body: UpdateTeamMemberRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateTeamMemberResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/members/${userId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a specific member (`user_id`) from a workspace (`team_id`). The member is not deleted but is marked as `inactive` and removed from the team.
     *
     * @tags Auth
     * @name RemoveMember
     * @summary Remove a team member
     * @request DELETE:/teams/{team_id}/members/{user_id}
     */
    removeMember: (teamId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        RemoveTeamMemberResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/members/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all pending invites for a specified team (workspace). The response includes details about the invitee, the invite status, and the invite expiration date and their requested roles.
     *
     * @tags Auth
     * @name GetTeamInvites
     * @summary Get all pending team invites for a team
     * @request GET:/teams/{team_id}/invites
     */
    getTeamInvites: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPendingInvitesForTeamResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/invites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Sends invitations to users to join a team (workspace). Invitees can be assigned roles and optionally linked to specific spaces (projects). Up to 100 invitees can be included in a single request.
     *
     * @tags Auth
     * @name CreateTeamInvite
     * @summary Create team invites
     * @request POST:/teams/{team_id}/invites
     */
    createTeamInvite: (teamId: string, body: CreateTeamInvitesRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateTeamInvitesResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/invites`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes pending invites for specified users. Useful for retracting unaccepted invitations by email or user ID.
     *
     * @tags Auth
     * @name DeleteTeamInvite
     * @summary Delete team invites
     * @request DELETE:/teams/{team_id}/invites
     */
    deleteTeamInvite: (teamId: string, body: DeleteTeamInvitesRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/invites`,
        method: "DELETE",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Resends an invitation email to a user to join the team. Useful for expired or lost invites. The invitee can be specified by their email or user ID.
     *
     * @tags Auth
     * @name ResendInviteLinkCodeEmailByTeam
     * @summary Resend a team invite (sender)
     * @request POST:/teams/{team_id}/invites/resend
     */
    resendInviteLinkCodeEmailByTeam: (
      teamId: string,
      body: ResendInviteLinkEmailRequestByTeam,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/invites/resend`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches a detailed list of all features and associated limits available to a workspace (`team_id`). This endpoint provides insights into the capabilities, quotas, and restrictions configured for the specified workspace, allowing teams to understand their available resources.
     *
     * @tags Auth
     * @name GetTeamFeatures
     * @summary Get all team features and limits
     * @request GET:/teams/{team_id}/features
     */
    getTeamFeatures: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetTeamFeaturesResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/features`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the status of a specific feature for a team (workspace). The `feature_id` is the feature to toggle and can be found in the team features response.
     *
     * @tags Auth
     * @name SetTeamFeature
     * @summary Toggle a team feature
     * @request PUT:/teams/{team_id}/features/{feature_id}
     */
    setTeamFeature: (teamId: string, featureId: string, body: SetTeamFeatureRequest, params: RequestParams = {}) =>
      this.http.request<
        SetTeamFeatureResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/features/${featureId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the subscription details for a specified team (workspace), including the current plan and associated features.
     *
     * @tags Auth
     * @name GetSubscription
     * @summary Get current team's subscription
     * @request GET:/teams/{team_id}/subscription
     */
    getSubscription: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetSubscriptionResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/subscription`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a new billing session for a team (workspace). The session is used to manage billing information and subscriptions. The session is created with the specified plan (plan_id) and billing cycle.
     *
     * @tags Auth
     * @name CreateTeamBillingSession
     * @summary Create a new billing session
     * @request POST:/teams/{team_id}/billing_session
     */
    createTeamBillingSession: (teamId: string, body: CreateBillingSessionRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateBillingSessionResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/billing_session`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a session for managing billing information for a team (workspace). Users can update payment methods and other billing details.
     *
     * @tags Auth
     * @name CreateTeamBillingManagementSession
     * @summary Create a new billing management session
     * @request POST:/teams/{team_id}/billing_management
     */
    createTeamBillingManagementSession: (
      teamId: string,
      body: CreateBillingManagementSessionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        CreateBillingManagementSessionResponse,
        {
          error?: Error;
        }
      >({
        path: `/teams/${teamId}/billing_management`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a redirect URL for initiating OAuth-based login with the specified authentication provider (e.g., Google). Requires the auth_provider in the path and a relative redirect query parameter specifying where the user should be redirected post-login. Returns the constructed URL or an error for invalid inputs.
     *
     * @tags Auth
     * @name GetOAuthRedirect
     * @summary Get redirect url for oauth sign in
     * @request GET:/auth/idp/{auth_provider}
     */
    getOAuthRedirect: (
      authProvider: "google",
      query: {
        /** relative path to redirect user after successful sign in (e.g. /dashboard) */
        redirect: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetOAuthRedirectResponse,
        {
          error?: Error;
        }
      >({
        path: `/auth/idp/${authProvider}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalizes the OAuth authentication process. Accepts an authorization code obtained from the OAuth flow on the FE and validates it along with the provided redirect_uri. Upon successful validation, the user is authenticated, and cookies are set. Supports popular OAuth providers such as Google.
     *
     * @tags Auth
     * @name LoginOAuthCode
     * @summary Login with an OAuth code
     * @request POST:/auth/idp/{auth_provider}/code
     */
    loginOAuthCode: (authProvider: "google", body: LoginOAuthCodeRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/auth/idp/${authProvider}/code`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Authenticates a user using their email and a one-time code. Sets an authentication cookie upon successful verification. Designed for scenarios where users receive a login code via email for a seamless login experience. Incorrect codes or missing parameters result in an error.
     *
     * @tags Auth
     * @name LoginWithCode
     * @summary Log user in via email and email code
     * @request POST:/auth/code
     */
    loginWithCode: (body: LoginWithCodeRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/auth/code`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends a one-time login code to the specified email address. If the user associated with the email does not exist, a new user account is created. Designed to simplify the login process by allowing users to authenticate using codes instead of passwords.
     *
     * @tags Auth
     * @name SendLoginCodeEmail
     * @summary Send login code via email
     * @request POST:/auth/code/send
     */
    sendLoginCodeEmail: (body: SendLoginCodeEmailRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/auth/code/send`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handles user authentication through a team invite. If the invite is valid, the endpoint creates a new user if one does not exist and authenticates them by setting auth cookies. The user is joined to the team associated with the invite. Returns the team_id for redirection purposes. Invites that are expired or invalid result in an error.
     *
     * @tags Auth
     * @name LoginWithInvite
     * @summary Accept team invite and authenticate user
     * @request POST:/auth/invite
     */
    loginWithInvite: (body: LoginWithInviteRequest, params: RequestParams = {}) =>
      this.http.request<
        LoginWithInviteResponse,
        {
          error?: Error;
        }
      >({
        path: `/auth/invite`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows a user to resend a team invite email to the specified email address. Useful for scenarios where the original invite email was not received, lost, or expired. Ensures the invitee has access to join the team by providing an updated invite link.
     *
     * @tags Auth
     * @name ResendInviteLinkCodeEmailByUser
     * @summary Resend a team invite (invitee)
     * @request POST:/auth/invite/send
     */
    resendInviteLinkCodeEmailByUser: (body: ResendInviteLinkEmailRequestByUser, params: RequestParams = {}) =>
      this.http.request<
        ResendInviteLinkEmailRequestByUserResponse,
        {
          error?: Error;
        }
      >({
        path: `/auth/invite/send`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Refreshes the user's authentication token and updates the authentication cookie. This endpoint ensures continuous access to protected resources without requiring re-authentication. If the refresh process fails, an error is returned with relevant details.
     *
     * @tags Auth
     * @name RefreshToken
     * @summary Refresh user access token
     * @request POST:/auth/refresh
     */
    refreshToken: (params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/auth/refresh`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Logs out the authenticated user by clearing their session and associated cookies. Returns a logout_redirect_url indicating where the user should be redirected after logging out. Any issues during the logout process are returned as errors with detailed information.
     *
     * @tags Auth
     * @name Logout
     * @summary Log out the current user
     * @request POST:/auth/logout
     */
    logout: (params: RequestParams = {}) =>
      this.http.request<
        LogoutResponse,
        {
          error?: Error;
        }
      >({
        path: `/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  projects = {
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjects
     * @summary Get all projects
     * @request GET:/{team_id}/projects
     */
    getProjects: (
      teamId: string,
      query?: {
        /**
         * Flag whether to fetch projects in trash only
         * @default false
         */
        trash?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetProjectsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name CreateProject
     * @summary Create a new project
     * @request POST:/{team_id}/projects
     */
    createProject: (teamId: string, body: CreateProjectRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateProjectResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch comprehensive details about a specific project (referred to externally as a "Space") within a team (externally referred to as a "Workspace").
     *
     * @tags Projects
     * @name GetProject
     * @summary Get a project
     * @request GET:/{team_id}/projects/{project_id}
     */
    getProject: (teamId: string, projectId: string, params: RequestParams = {}) =>
      this.http.request<
        GetProjectResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update properties of a project (Space) such as its title, description, privacy settings, and position in the sidebar. You can also set or remove custom icons and adjust estimation systems. All unspecified fields remain unchanged.
     *
     * @tags Projects
     * @name UpdateProject
     * @summary Update a project
     * @request PATCH:/{team_id}/projects/{project_id}
     */
    updateProject: (teamId: string, projectId: string, body: UpdateProjectRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateProjectResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently delete a project (Space) from the specified team (Workspace). This action cannot be undone, and all associated data will be removed.
     *
     * @tags Projects
     * @name DeleteProject
     * @summary Delete a project
     * @request DELETE:/{team_id}/projects/{project_id}
     */
    deleteProject: (teamId: string, projectId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Send a project (Space) to the trash within the team (Workspace). This action preserves the project data temporarily for recovery or deletion.
     *
     * @tags Projects
     * @name TrashProject
     * @summary Send project to trash
     * @request POST:/{team_id}/projects/{project_id}/trash
     */
    trashProject: (teamId: string, projectId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}/trash`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Recover a previously trashed project (Space) within a team (Workspace), reinstating its access and functionality.
     *
     * @tags Projects
     * @name UntrashProject
     * @summary Restore project from trash
     * @request POST:/{team_id}/projects/{project_id}/untrash
     */
    untrashProject: (teamId: string, projectId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}/untrash`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Transfer ownership of the project (Space) to a specified user within the team (Workspace). The new owner is identified by their unique user ID and gains administrative privileges over the project.
     *
     * @tags Projects
     * @name SetProjectOwner
     * @summary Set project owner
     * @request PUT:/{team_id}/projects/{project_id}/owner
     */
    setProjectOwner: (teamId: string, projectId: string, body: SetProjectOwnerRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}/owner`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add one or more users to a project (Space) with specified roles, such as "admin" or "member." This allows the new members to participate in and manage the project's tasks and resources.
     *
     * @tags Projects
     * @name AddProjectMember
     * @summary Add a new project member
     * @request POST:/{team_id}/projects/{project_id}/members
     */
    addProjectMember: (teamId: string, projectId: string, body: AddMembersRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}/members`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Revoke a user's access to a specific project (Space) within the team (Workspace). The user is identified by their unique ID, and their role and permissions in the project are revoked.
     *
     * @tags Projects
     * @name DeleteProjectMember
     * @summary Remove a member from a project
     * @request DELETE:/{team_id}/projects/{project_id}/members/{user_id}
     */
    deleteProjectMember: (teamId: string, projectId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/projects/${projectId}/members/${userId}`,
        method: "DELETE",
        ...params,
      }),
  };
  pages = {
    /**
     * @description Returns a list of all available pages for the workspace (`team_id`). Pages are organized by spaces (projects) and can be filtered by `archived` or `updated_recently`.
     *
     * @tags Pages
     * @name GetPages
     * @summary Get all pages
     * @request GET:/{team_id}/pages
     */
    getPages: (
      teamId: string,
      query?: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id?: string;
        archived?: boolean;
        updated_recently?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetPagesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new page in the workspace (`team_id`) under a specified space (project). Pages can be associated with a template for efficient creation and can include a title, content, icon, and optional hierarchy settings.
     *
     * @tags Pages
     * @name CreatePage
     * @summary Create a new page
     * @request POST:/{team_id}/pages
     */
    createPage: (teamId: string, body: CreatePageRequest, params: RequestParams = {}) =>
      this.http.request<
        CreatePageResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all available page templates for the workspace (`team_id`). Templates provide pre-defined content for creating new pages with a specific structure efficiently and can be filtered by space (project) if specified.
     *
     * @tags Pages
     * @name GetPageTemplates
     * @summary Get page templates
     * @request GET:/{team_id}/pages/templates
     */
    getPageTemplates: (
      teamId: string,
      query?: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetPageTemplatesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/templates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new page template in the workspace (`team_id`). Templates provide pre-defined content for creating new pages with a specific structure efficiently.
     *
     * @tags Pages
     * @name CreatePageTemplate
     * @summary Create a new page template
     * @request POST:/{team_id}/pages/templates
     */
    createPageTemplate: (teamId: string, body: CreatePageTemplateRequest, params: RequestParams = {}) =>
      this.http.request<
        CreatePageTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/templates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches details of a specific page template identified by the `template_id`. Templates provide pre-defined content for creating new pages with a specific structure efficiently.
     *
     * @tags Pages
     * @name GetPageTemplate
     * @summary Get a page template
     * @request GET:/{team_id}/pages/templates/{template_id}
     */
    getPageTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPageTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/templates/${templateId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates properties of a specified page template, including title, content, associated projects (spaces), and icon details. Only provided fields will be modified; omitted fields will remain unchanged.
     *
     * @tags Pages
     * @name UpdatePageTemplate
     * @summary Update a page template
     * @request PATCH:/{team_id}/pages/templates/{template_id}
     */
    updatePageTemplate: (
      teamId: string,
      templateId: string,
      body: UpdatePageTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdatePageTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/templates/${templateId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specified page template from the workspace (`team_id`). This action is irreversible and will remove the template from all associated projects or spaces.
     *
     * @tags Pages
     * @name DeletePageTemplate
     * @summary Delete a page template
     * @request DELETE:/{team_id}/pages/templates/{template_id}
     */
    deletePageTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/templates/${templateId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Fetches detailed information about a specified page identified by the `page_id` within a workspace (`team_id`).
     *
     * @tags Pages
     * @name GetPage
     * @summary Get a page
     * @request GET:/{team_id}/pages/{page_id}
     */
    getPage: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPageResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies properties of a specified page, such as its title, position, and content. Only provided fields will be updated.
     *
     * @tags Pages
     * @name UpdatePage
     * @summary Update a page
     * @request PATCH:/{team_id}/pages/{page_id}
     */
    updatePage: (teamId: string, pageId: string, body: UpdatePageRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdatePageResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently removes a specified page from the workspace (`team_id`). This action is irreversible.
     *
     * @tags Pages
     * @name DeleteAPage
     * @summary Delete a page
     * @request DELETE:/{team_id}/pages/{page_id}
     */
    deleteAPage: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieves collaboration options for a specified page within a workspace (`team_id`).
     *
     * @tags Pages
     * @name GetPageCollaboration
     * @summary Get collaboration options for a page
     * @request GET:/{team_id}/pages/{page_id}/collaboration
     */
    getPageCollaboration: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        GetCollaborationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/collaboration`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches all versions of a specified page within a workspace (`team_id`). Versions represent snapshots of the page at different points in time and can be restored.
     *
     * @tags Pages
     * @name GetPageVersions
     * @summary Get page versions
     * @request GET:/{team_id}/pages/{page_id}/versions
     */
    getPageVersions: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPageVersionsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/versions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the icon associated with a specified page. Icons visually differentiate pages within the workspace.
     *
     * @tags Pages
     * @name DeletePageIcon
     * @summary Delete page icon
     * @request DELETE:/{team_id}/pages/{page_id}/icon
     */
    deletePageIcon: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/icon`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Deletes the cover image associated with a specified page. This action removes the visual branding or context provided by the image.
     *
     * @tags Pages
     * @name DeletePageCover
     * @summary Delete page cover image
     * @request DELETE:/{team_id}/pages/{page_id}/cover
     */
    deletePageCover: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/cover`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Archives a specified page within a workspace (`team_id`). Archiving moves the page to an archived state, making it inaccessible through regular navigation but preserving its data for potential future restoration.
     *
     * @tags Pages
     * @name ArchivePage
     * @summary Archive a page
     * @request PUT:/{team_id}/pages/{page_id}/archive
     */
    archivePage: (teamId: string, pageId: string, params: RequestParams = {}) =>
      this.http.request<
        GetPageResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/archive`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a copy of a specified page, allowing users to reuse its content or structure. The new page can be placed under a parent page or at the root of a space (project).
     *
     * @tags Pages
     * @name CopyPage
     * @summary Create copy of current page
     * @request POST:/{team_id}/pages/{page_id}/copy
     */
    copyPage: (teamId: string, pageId: string, body: CopyPageRequest, params: RequestParams = {}) =>
      this.http.request<
        CopyPageResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/copy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a new watcher to a specified page within a workspace (`team_id`). Watchers receive notifications about updates or changes to the page.
     *
     * @tags Pages
     * @name AddPageWatcher
     * @summary Add a new page watcher
     * @request POST:/{team_id}/pages/{page_id}/watchers
     */
    addPageWatcher: (teamId: string, pageId: string, body: AddWatcherRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/watchers`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes a specified user from the list of watchers for a page. Watchers receive notifications about updates or changes to the page.
     *
     * @tags Pages
     * @name DeletePageWatcher
     * @summary Remove a page watcher
     * @request DELETE:/{team_id}/pages/{page_id}/watchers/{user_id}
     */
    deletePageWatcher: (teamId: string, pageId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/pages/${pageId}/watchers/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieves all note templates within the specified workspace (team_id). This endpoint returns an array of note templates visible to the current user. Note templates are pre-configured structures used to create new notes with standardized formatting or content.
     *
     * @tags Pages
     * @name GetNoteTemplates
     * @summary Get note templates
     * @request GET:/{team_id}/notes/templates
     */
    getNoteTemplates: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNoteTemplatesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/templates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreateNoteTemplate
     * @summary Create a new note template
     * @request POST:/{team_id}/notes/templates
     */
    createNoteTemplate: (teamId: string, body: CreateNoteTemplateRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateNoteTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/templates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetNoteTemplate
     * @summary Get a note template
     * @request GET:/{team_id}/notes/templates/{template_id}
     */
    getNoteTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNoteTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/templates/${templateId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdateNoteTemplate
     * @summary Update a note template
     * @request PATCH:/{team_id}/notes/templates/{template_id}
     */
    updateNoteTemplate: (
      teamId: string,
      templateId: string,
      body: UpdateNoteTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateNoteTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/templates/${templateId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeleteNoteTemplate
     * @summary Delete a note template
     * @request DELETE:/{team_id}/notes/templates/{template_id}
     */
    deleteNoteTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/templates/${templateId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieves all notes within the specified workspace (team_id). This endpoint returns an array of notes visible to the current user, enabling a comprehensive view of all accessible notes in the workspace.
     *
     * @tags Pages
     * @name GetNotes
     * @summary Get all notes
     * @request GET:/{team_id}/notes
     */
    getNotes: (
      teamId: string,
      query?: {
        /** Cursor for pagination */
        cursor?: string;
        /** Max number of items to return, defaults to 50 if unset */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetNotesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new note within the specified workspace (team_id). The note object is provided in the request body, including the note title, content, and any other relevant details (optional fields include transcript and user notes). Upon successful creation, the new note is returned in the response.
     *
     * @tags Pages
     * @name CreateNote
     * @summary Create a new note
     * @request POST:/{team_id}/notes
     */
    createNote: (teamId: string, body: CreateNoteRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateNoteResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific note within the specified workspace (`team_id`). The note is identified by the provided note_id and returned in the response.
     *
     * @tags Pages
     * @name GetNote
     * @summary Get a note
     * @request GET:/{team_id}/notes/{note_id}
     */
    getNote: (teamId: string, noteId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNoteResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates specific fields of a note identified by `note_id`. The request body should include the fields to be updated, such as title, transcript, or user notes. All omitted fields are left unmodified.
     *
     * @tags Pages
     * @name UpdateNote
     * @summary Update a note
     * @request PATCH:/{team_id}/notes/{note_id}
     */
    updateNote: (teamId: string, noteId: string, body: UpdateNoteRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateNoteResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently deletes a note identified by `note_id` from the specified workspace (`team_id`). This operation cannot be undone and should be used with caution.
     *
     * @tags Pages
     * @name DeleteNote
     * @summary Delete a note
     * @request DELETE:/{team_id}/notes/{note_id}
     */
    deleteNote: (teamId: string, noteId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Adds a new attendee to a specified note within a workspace (`team_id`).
     *
     * @tags Pages
     * @name AddNoteAttendee
     * @summary Add a new note attendee
     * @request POST:/{team_id}/notes/{note_id}/attendees
     */
    addNoteAttendee: (teamId: string, noteId: string, body: AddAttendeeRequest, params: RequestParams = {}) =>
      this.http.request<
        AddAttendeeResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/attendees`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes an attendee from a specified note within a workspace (`team_id`).
     *
     * @tags Pages
     * @name RemoveNoteAttendee
     * @summary Remove an attendee from the Note
     * @request DELETE:/{team_id}/notes/{note_id}/attendees/{email}
     */
    removeNoteAttendee: (teamId: string, noteId: string, email: string, params: RequestParams = {}) =>
      this.http.request<
        RemoveAttendeeResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/attendees/${email}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Applies a pre-defined note template to a specific note identified by `note_id`. The template is selected based on the provided `note_template_id` within the request body. This operation is useful for standardizing note structures.
     *
     * @tags Pages
     * @name ApplyNoteTemplate
     * @summary Apply a note template
     * @request POST:/{team_id}/notes/{note_id}/template
     */
    applyNoteTemplate: (teamId: string, noteId: string, body: ApplyNoteTemplateRequest, params: RequestParams = {}) =>
      this.http.request<
        ApplyNoteTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/template`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates specific fields of an AI-enhanced note identified by `enhanced_note_id`. This note is linked to a base note (`note_id`). The request body should contain the fields to modify, such as content or title. All omitted fields are left unmodified.
     *
     * @tags Pages
     * @name UpdateEnhancedNote
     * @summary Update an AI enhanced note
     * @request PATCH:/{team_id}/notes/{note_id}/enhanced/{enhanced_note_id}
     */
    updateEnhancedNote: (
      teamId: string,
      noteId: string,
      enhancedNoteId: string,
      body: UpdateEnhancedNoteRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateEnhancedNoteResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/enhanced/${enhancedNoteId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently deletes an AI-enhanced note identified by `enhanced_note_id`. This note is linked to a base note (`note_id`). This operation cannot be undone and should be used with caution.
     *
     * @tags Pages
     * @name DeleteEnhancedNote
     * @summary Delete an enhanced note
     * @request DELETE:/{team_id}/notes/{note_id}/enhanced/{enhanced_note_id}
     */
    deleteEnhancedNote: (teamId: string, noteId: string, enhancedNoteId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/enhanced/${enhancedNoteId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Adds the resource as related to the AI-enhanced note identified by `enhanced_note_id`.
     *
     * @tags Pages
     * @name AddEnhancedNoteRelatedResource
     * @summary Add related resource to an enhanced note
     * @request PUT:/{team_id}/notes/{note_id}/enhanced/{enhanced_note_id}/related/{resource}
     */
    addEnhancedNoteRelatedResource: (
      teamId: string,
      noteId: string,
      enhancedNoteId: string,
      resource: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/enhanced/${enhancedNoteId}/related/${resource}`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Removes the link between an AI-enhanced note and a specified resource. The resource is identified by its full identifier (e.g. card:10).
     *
     * @tags Pages
     * @name RemoveEnhancedNoteRelatedResource
     * @summary Remove related resource from an enhanced note
     * @request DELETE:/{team_id}/notes/{note_id}/enhanced/{enhanced_note_id}/related/{resource}
     */
    removeEnhancedNoteRelatedResource: (
      teamId: string,
      noteId: string,
      enhancedNoteId: string,
      resource: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notes/${noteId}/enhanced/${enhancedNoteId}/related/${resource}`,
        method: "DELETE",
        ...params,
      }),
  };
  comments = {
    /**
     * @description Fetch all activities associated with a specific resource within a workspace (`team_id`). You can specify either a `page` or `card` as the resource, but one and only one must be specified. Optionally, filter the results by activity type (e.g., activity_entry or comment).
     *
     * @tags Comments
     * @name ActivityDetail
     * @summary Get all activity for a specific resource
     * @request GET:/{team_id}/activity
     */
    activityDetail: (
      teamId: string,
      query?: {
        /** Page ID is a numerical string that identifies a Page. */
        page_id?: string;
        /** Card ID is a numerical string that identifies a card. */
        card_id?: string;
        /** Optional filter on activity. Defaults to not filtering if not specified */
        filter?: "activity_entry" | "comment";
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetActivitiesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/activity`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information about a specific activity item identified by its `activity_id`.
     *
     * @tags Comments
     * @name ActivityDetail2
     * @summary Get an activity
     * @request GET:/{team_id}/activity/{activity_id}
     * @originalName activityDetail
     * @duplicate
     */
    activityDetail2: (teamId: string, activityId: string, params: RequestParams = {}) =>
      this.http.request<
        GetActivityResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/activity/${activityId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description The only activity that can be modified is a comment. Updates can include changing the content, the status (e.g., resolved, open, or orphaned), or the context (such as highlighted text). Any fields omitted in the update request remain unmodified.
     *
     * @tags Comments
     * @name ActivityPartialUpdate
     * @summary Update an activity. Only comments can be edited
     * @request PATCH:/{team_id}/activity/{activity_id}
     */
    activityPartialUpdate: (
      teamId: string,
      activityId: string,
      body: UpdateActivityRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetActivityResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/activity/${activityId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a specific activity from the workspace. This operation is limited to comments and cannot delete other activity types.
     *
     * @tags Comments
     * @name ActivityDelete
     * @summary Delete an activity. Only comments can be deleted
     * @request DELETE:/{team_id}/activity/{activity_id}
     */
    activityDelete: (teamId: string, activityId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/activity/${activityId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Fetches a list of comments associated with a specific team resource, e.g. card or page. Optional query parameters allow filtering by page_id, card_id, and one of it must be specified. The comments can further be filtered by the filter parameter, which supports the following values: resolved, open, orphaned.
     *
     * @tags Comments
     * @name GetComments
     * @summary Retrieve all comments for a team.
     * @request GET:/{team_id}/comments
     */
    getComments: (
      teamId: string,
      query?: {
        /** Page ID is a numerical string that identifies a Page. */
        page_id?: string;
        /** Card ID is a numerical string that identifies a card. */
        card_id?: string;
        /** Optional filter on comments. Defaults to not filtering if not specified */
        filter?: "resolved" | "open" | "orphaned";
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetCommentsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a new comment to a specified team resource. The request body must include the content field, with optional fields for context, page_id, or card_id.
     *
     * @tags Comments
     * @name CreateComment
     * @summary Create a new comment
     * @request POST:/{team_id}/comments
     */
    createComment: (teamId: string, body: CreateCommentRequest, params: RequestParams = {}) =>
      this.http.request<
        CommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches the details of a single comment identified by comment_id. Includes metadata like author, reactions, and timestamps.
     *
     * @tags Comments
     * @name GetComment
     * @summary Retrieve a specific comment by its ID.
     * @request GET:/{team_id}/comments/{comment_id}
     */
    getComment: (teamId: string, commentId: string, params: RequestParams = {}) =>
      this.http.request<
        CommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Modifies the fields of an existing comment. Only the original author can modify comments. The request body should specify the fields to update, such as content, status, or context. Omitted fields will remain unchanged. The status field accepts the following values: resolved, open, orphaned.
     *
     * @tags Comments
     * @name UpdateComment
     * @summary Update an existing comment.
     * @request PATCH:/{team_id}/comments/{comment_id}
     */
    updateComment: (teamId: string, commentId: string, body: UpdateCommentRequest, params: RequestParams = {}) =>
      this.http.request<
        CommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently removes the comment identified by comment_id. Only the original author can delete their own comment.
     *
     * @tags Comments
     * @name DeleteComment
     * @summary Delete a specific comment.
     * @request DELETE:/{team_id}/comments/{comment_id}
     */
    deleteComment: (teamId: string, commentId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Changes the status of a comment identified by comment_id. The request body must include the status field, which can be one of the following values: resolved, open, orphaned.
     *
     * @tags Comments
     * @name UpdateCommentStatus
     * @summary Update the status of a comment.
     * @request PUT:/{team_id}/comments/{comment_id}/status
     */
    updateCommentStatus: (
      teamId: string,
      commentId: string,
      body: UpdateCommentStatusRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/status`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a reaction to a specific comment (`comment_id`) within a workspace (`team_id`).
     *
     * @tags Comments
     * @name CreateCommentReaction
     * @summary React to a comment
     * @request PUT:/{team_id}/comments/{comment_id}/reactions/{reaction_id}
     */
    createCommentReaction: (
      teamId: string,
      commentId: string,
      reactionId: string,
      body: CreateCommentReactionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        CreateCommentReactionResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/reactions/${reactionId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a specific reaction (`reaction_id`) associated with a comment (`comment_id`) in a given workspace (`team_id`). Only the original author of the reaction can remove one.
     *
     * @tags Comments
     * @name DeleteCommentReaction
     * @summary Delete a reaction to a comment.
     * @request DELETE:/{team_id}/comments/{comment_id}/reactions/{reaction_id}
     */
    deleteCommentReaction: (teamId: string, commentId: string, reactionId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/reactions/${reactionId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieves a list of comments, also known as child comments or replies, associated to a parent comment identified by comment_id. The response includes nested metadata and pagination details.
     *
     * @tags Comments
     * @name GetChildComments
     * @summary Get all children of a comment
     * @request GET:/{team_id}/comments/{comment_id}/children
     */
    getChildComments: (teamId: string, commentId: string, params: RequestParams = {}) =>
      this.http.request<
        GetChildCommentsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/children`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new child comment under the parent comment specified by comment_id. The request body must include the content field and can optionally include additional metadata such as schema. The child comment can also be referred to as a reply or a thread.
     *
     * @tags Comments
     * @name CreateChildComment
     * @summary Add a child comment or in other words: reply to an existing comment.
     * @request POST:/{team_id}/comments/{comment_id}/children
     */
    createChildComment: (
      teamId: string,
      commentId: string,
      body: CreateChildCommentRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        ChildCommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/children`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the details of a specific child comment associated with a parent comment in a team. Required Parameters: - team_id (path): Unique identifier for the team. - comment_id (path): Unique identifier for the parent comment. - child_comment_id (path): Unique identifier for the child comment. The response includes details such as content, reactions, metadata (timestamps), and information about the user or system that created or updated the child comment.
     *
     * @tags Comments
     * @name GetChildComment
     * @summary Get child comment
     * @request GET:/{team_id}/comments/{comment_id}/children/{child_comment_id}
     */
    getChildComment: (teamId: string, commentId: string, childCommentId: string, params: RequestParams = {}) =>
      this.http.request<
        ChildCommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/children/${childCommentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the content or metadata of a specific child comment within a team. Only the original author of the child comment can modify it. Required Parameters: - team_id (path): Unique identifier for the team. - comment_id (path): Unique identifier for the parent comment. - child_comment_id (path): Unique identifier for the child comment. - body (body): Object containing: - content (string): Updated text of the comment (nullable, max length: 16,384 characters). - schema (integer): Optional schema version for the update (nullable). Returns a 200 status code with the updated comment details or an error object in case of failure.
     *
     * @tags Comments
     * @name UpdateChildComment
     * @summary Update a child comment
     * @request PATCH:/{team_id}/comments/{comment_id}/children/{child_comment_id}
     */
    updateChildComment: (
      teamId: string,
      commentId: string,
      childCommentId: string,
      body: UpdateChildCommentRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        ChildCommentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/children/${childCommentId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific child comment (`child_comment_id`) associated with a parent comment (`comment_id`) in a workspace (`team_id`). Only the original author of the child comment can delete it.
     *
     * @tags Comments
     * @name DeleteChildComment
     * @summary Delete a child comment
     * @request DELETE:/{team_id}/comments/{comment_id}/children/{child_comment_id}
     */
    deleteChildComment: (teamId: string, commentId: string, childCommentId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/comments/${commentId}/children/${childCommentId}`,
        method: "DELETE",
        ...params,
      }),
  };
  files = {
    /**
     * @description Retrieves a list of files attached to a specific resource, such as a `card` or `page` within the workspace (`team_id`). Note that only one resource type can be specified, and specifying a resource type is mandatory. Users can apply filters such as "attachment" or "inline" to narrow down the results of files based on where they appear in the resource. Cards can have both attachments or inline files. Pages can only have inline files. The default filter returns only files marked as attachments.
     *
     * @tags Files
     * @name GetFiles
     * @summary Get all files
     * @request GET:/{team_id}/files
     */
    getFiles: (
      teamId: string,
      query?: {
        /** Page ID is a numerical string that identifies a Page. */
        page_id?: string;
        /** Card ID is a numerical string that identifies a card. */
        card_id?: string;
        /**
         * filter files by attachment type
         * @default "attachments"
         */
        filter?: "inline" | "attachments" | "all";
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetFilesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/files`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Uploads multiple files to the workspace (`team_id`) and associates them with a specific resource. Users can associate files with a `card`, `page`, `user`, or `team`. If no resource is specified, the files are uploaded to the workspace.
     *
     * @tags Files
     * @name UploadFiles
     * @summary Upload files
     * @request POST:/{team_id}/files
     */
    uploadFiles: (
      teamId: string,
      data: {
        /**
         * files to upload
         * @format binary
         */
        files: File;
        /** card to associate files to */
        card_id?: string;
        /** page to associate files to */
        page_id?: string;
        /** user to associate files to */
        user_id?: string;
        /** team to associate files to */
        team_id?: string;
        /** associate this file with a resource, listing it as an attachment. Only relevant when uploading files to cards. Defaults to true */
        attachment?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        UploadFilesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/files`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches the metadata and details of a specific file (`file_id`) in the workspace (`team_id`). This endpoint allows users to view file attributes, such as its name, associated resources (card or page), and attachment status.
     *
     * @tags Files
     * @name GetFile
     * @summary Get a file
     * @request GET:/{team_id}/files/{file_id}
     */
    getFile: (teamId: string, fileId: string, params: RequestParams = {}) =>
      this.http.request<
        GetFileResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/files/${fileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the metadata or associations of a specific file. Users can modify the file's name or change its linked resources, such as associating it with a specific card or page. If no fields are specified, the file's current properties remain unchanged.
     *
     * @tags Files
     * @name UpdateFile
     * @summary Update a file
     * @request PATCH:/{team_id}/files/{file_id}
     */
    updateFile: (teamId: string, fileId: string, body: UpdateFileRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateFileResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/files/${fileId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified file from the workspace (`team_id`). This operation is irreversible and removes the file from all associated resources.
     *
     * @tags Files
     * @name DeleteFile
     * @summary Delete a file
     * @request DELETE:/{team_id}/files/{file_id}
     */
    deleteFile: (teamId: string, fileId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/files/${fileId}`,
        method: "DELETE",
        ...params,
      }),
  };
  boards = {
    /**
     * @description This endpoint retrieves a list of tags associated with a workspace (team) and optionally filters them by a specific project if the `project_id` query parameter is provided. It also supports fetching all tags in the workspace with the `all` parameter.
     *
     * @tags Boards, Tags
     * @name GetTags
     * @summary Retrieve tags for a workspace or project (optionally).
     * @request GET:/{team_id}/tags
     */
    getTags: (
      teamId: string,
      query?: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id?: string;
        /** Return all tags */
        all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetTagsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint creates a new tag for a Workspace or a specific Project (externally referenced as Space). The request body must include the name and color of the tag. The `project_id` can be optionally included to scope the tag within a specific project/space.
     *
     * @tags Boards, Tags
     * @name CreateTag
     * @summary Create a new tag
     * @request POST:/{team_id}/tags
     */
    createTag: (teamId: string, body: CreateTagRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateTagResponse,
        | CreateTagErrorResponse
        | {
            error?: Error;
          }
      >({
        path: `/${teamId}/tags`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows users to merge multiple project-level tags into a single workspace-level tag. The user must provide the new tag's name and colour properties in the request body. Upon successful merging, a new tag is created with the provided properties, and the response includes its details such as `id`, `team_id`, `total_cards`, and more.
     *
     * @tags Boards, Tags
     * @name MergeTags
     * @summary Merge tags
     * @request POST:/{team_id}/tags/merge
     */
    mergeTags: (teamId: string, body: MergeTagRequest, params: RequestParams = {}) =>
      this.http.request<
        MergeTagResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/tags/merge`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint updates the properties of a specific tag, identified by `tag_id`. The request body must include at least one of the properties (name or color). If omitted, other fields will remain unchanged.
     *
     * @tags Boards, Tags
     * @name UpdateTag
     * @summary Update an existing tag.
     * @request PATCH:/{team_id}/tags/{tag_id}
     */
    updateTag: (teamId: string, tagId: string, body: UpdateTagRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateTagResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/tags/${tagId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint deletes a tag identified by the `tag_id`. Once deleted, the tag and its associations are removed. The operation requires specifying both `team_id` and `tag_id` as part of the request path.
     *
     * @tags Boards, Tags
     * @name DeleteTag
     * @summary Delete a tag
     * @request DELETE:/{team_id}/tags/{tag_id}
     */
    deleteTag: (teamId: string, tagId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/tags/${tagId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Fetches a list of all boards within a specified workspace (`team_id`). Query parameters allow filtering based on bookmarked status or archived boards. Use the `project_id` parameter to specify the associated space.
     *
     * @tags Boards
     * @name GetBoards
     * @summary Get all boards
     * @request GET:/{team_id}/boards
     */
    getBoards: (
      teamId: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
        /** Flag whether to fetch only bookmarked boards */
        bookmarked?: boolean;
        /** Flag whether to fetch archived boards only */
        archived?: true | false;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetBoardsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows the creation of a new board within a workspace (`team_id`). The request body should contain the board's title, layout, lists, members, and other optional metadata. Specify the project ID to associate the board with a space.
     *
     * @tags Boards
     * @name CreateBoard
     * @summary Create a new board
     * @request POST:/{team_id}/boards
     */
    createBoard: (teamId: string, body: CreateBoardRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateBoardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns detailed information about a specific board identified by its unique ID within a workspace (`team_id`). This includes metadata and settings configured for the board.
     *
     * @tags Boards
     * @name GetBoard
     * @summary Get a board
     * @request GET:/{team_id}/boards/{board_id}
     */
    getBoard: (teamId: string, boardId: string, params: RequestParams = {}) =>
      this.http.request<
        GetBoardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the specified fields of a board. Fields omitted in the request will remain unchanged.
     *
     * @tags Boards
     * @name UpdateBoard
     * @summary Update a board
     * @request PATCH:/{team_id}/boards/{board_id}
     */
    updateBoard: (teamId: string, boardId: string, body: UpdateBoardRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateBoardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Boards
     * @name DeleteBoard
     * @summary Delete a board
     * @request DELETE:/{team_id}/boards/{board_id}
     */
    deleteBoard: (teamId: string, boardId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Duplicates an existing board into a specified space (project). The request body allows customization of the title and associated project ID.
     *
     * @tags Boards
     * @name CopyBoard
     * @summary Create a new board copy
     * @request POST:/{team_id}/boards/{board_id}/copy
     */
    copyBoard: (teamId: string, boardId: string, body: CopyBoardRequest, params: RequestParams = {}) =>
      this.http.request<
        CopyBoardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/copy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a user to the board with the specified role. The user will have access to the board's content and activities.
     *
     * @tags Boards
     * @name AddBoardMember
     * @summary Add a member to a board
     * @request PUT:/{team_id}/boards/{board_id}/members/{user_id}
     */
    addBoardMember: (teamId: string, boardId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/members/${userId}`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Removes a user from the board.
     *
     * @tags Boards
     * @name DeleteBoardMember
     * @summary Remove a member from a board
     * @request DELETE:/{team_id}/boards/{board_id}/members/{user_id}
     */
    deleteBoardMember: (teamId: string, boardId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/members/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Adds a user to the list of watchers for a board. Watchers receive notifications for all activities on the board.
     *
     * @tags Boards
     * @name AddBoardWatcher
     * @summary Add a watcher to a board
     * @request POST:/{team_id}/boards/{board_id}/watchers
     */
    addBoardWatcher: (teamId: string, boardId: string, body: AddWatcherRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/watchers`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Removes a user from the list of watchers for a board. The user will no longer receive notifications for activities on the board.
     *
     * @tags Boards
     * @name DeleteBoardWatcher
     * @summary Delete a watcher from a board
     * @request DELETE:/{team_id}/boards/{board_id}/watchers/{user_id}
     */
    deleteBoardWatcher: (teamId: string, boardId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/watchers/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Modifies the email address settings for a board. The request can regenerate the email or activate/deactivate it.
     *
     * @tags Boards
     * @name UpdateBoardEmail
     * @summary Update board email
     * @request PATCH:/{team_id}/boards/{board_id}/email
     */
    updateBoardEmail: (teamId: string, boardId: string, body: UpdateBoardEmailRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateBoardEmailResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/email`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Sets up a version control system (VCS) automation workflow for a specific branch on the board. The branch name must be provided in the request body.
     *
     * @tags Boards
     * @name CreateNewVcsBranchAutomation
     * @summary Create a new branch specific VCS automation
     * @request POST:/{team_id}/boards/{board_id}/vcs
     */
    createNewVcsBranchAutomation: (
      teamId: string,
      boardId: string,
      body: CreateBranchAutomationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/vcs`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Renames the branch in the VCS automation workflow associated with a board. Requires the new branch name in the request body.
     *
     * @tags Boards
     * @name UpdateBranchNameVcsBranchAutomation
     * @summary Update the branch name for a branch specific VCS automation
     * @request PATCH:/{team_id}/boards/{board_id}/vcs/{branch}
     */
    updateBranchNameVcsBranchAutomation: (
      teamId: string,
      boardId: string,
      branch: string,
      body: UpdateVCSBranchNameRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/vcs/${branch}`,
        method: "PATCH",
        body: body,
        ...params,
      }),

    /**
     * @description Deletes the version control system (VCS) automation workflow associated with the specified branch for the board.
     *
     * @tags Boards
     * @name DeleteBoardVcsBranchAutomation
     * @summary Delete a branch specific VCS automation
     * @request DELETE:/{team_id}/boards/{board_id}/vcs/{branch}
     */
    deleteBoardVcsBranchAutomation: (teamId: string, boardId: string, branch: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/vcs/${branch}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Creates a new webhook notification for the board. Specify the destination type (e.g., `slack_channel_webhook`) and integration ID in the request body.
     *
     * @tags Boards
     * @name CreateWebhookNotification
     * @summary Create a new webhook notification for a Board
     * @request POST:/{team_id}/boards/{board_id}/webhooks
     */
    createWebhookNotification: (
      teamId: string,
      boardId: string,
      body: CreateWebhookNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        CreateWebhookNotificationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/webhooks`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the webhook notification settings for the board. Configure notifications for each supported events. Omitted fields are left unmodified.
     *
     * @tags Boards
     * @name UpdateWebhookNotificationBoard
     * @summary Update a webhook notification for a Board
     * @request PATCH:/{team_id}/boards/{board_id}/webhooks/{webhook_type}
     */
    updateWebhookNotificationBoard: (
      teamId: string,
      boardId: string,
      webhookType: string,
      body: UpdateBoardWebhookNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateBoardWebhookNotificationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/webhooks/${webhookType}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a webhook notification for the board identified by its type (e.g., slack_channel_webhook).
     *
     * @tags Boards
     * @name DeleteWebhookNotification
     * @summary Delete a webhook notification
     * @request DELETE:/{team_id}/boards/{board_id}/webhooks/{webhook_type}
     */
    deleteWebhookNotification: (teamId: string, boardId: string, webhookType: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/${boardId}/webhooks/${webhookType}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Counts and returns total number of boards for specified workspace (`team_id`). This excludes boards that are archived or are a part of deleted space that will be deleted after TTL expires.
     *
     * @tags Boards
     * @name GetTeamBoardsCount
     * @summary Get total number of boards
     * @request GET:/{team_id}/boards/count
     */
    getTeamBoardsCount: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetTeamBoardsCountResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/boards/count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches the sprint settings for the specified project (externally referenced as Space, `project_id`) within a workspace (`team_id`). Includes configurations such as sprint length, layout, statuses, cooldown period, start day of the week, and VCS mappings for automation.
     *
     * @tags Boards, Sprints
     * @name GetSprintSettings
     * @summary Get sprint settings for project
     * @request GET:/{team_id}/sprints/settings
     */
    getSprintSettings: (
      teamId: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetSprintSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/settings`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the sprint settings for the specified project (externally referenced as Space, `project_id`) within a workspace (`team_id`).
     *
     * @tags Boards, Sprints
     * @name SetSprintSettings
     * @summary Set sprint settings
     * @request PUT:/{team_id}/sprints/settings
     */
    setSprintSettings: (
      teamId: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
      },
      body: SetSprintSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        SetSprintSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/settings`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches all sprints for the specified project (externally referenced as Space, `project_id`) within a workspace (`team_id`). status. The response can include active or archived sprints based on the archived query parameter.
     *
     * @tags Boards, Sprints
     * @name GetSprints
     * @summary Get all sprints for project
     * @request GET:/{team_id}/sprints
     */
    getSprints: (
      teamId: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
        /** Flag whether to fetch only archived sprints */
        archived?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetSprintsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new sprint for the specified project (`project_id`) in a workspace (`team_id`). A sprint can include a title, content, and must reference the `project_id` (externally referenced as Space).
     *
     * @tags Boards, Sprints
     * @name CreateSprint
     * @summary Create a new sprint
     * @request POST:/{team_id}/sprints
     */
    createSprint: (teamId: string, body: CreateSprintRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateSprintResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches detailed information for a specific sprint identified by `sprint_id` within the workspace (`team_id`). This includes sprint metadata such as its title, content, start and end dates, and current state.
     *
     * @tags Boards, Sprints
     * @name GetSprint
     * @summary Get a sprint
     * @request GET:/{team_id}/sprints/{sprint_id}
     */
    getSprint: (teamId: string, sprintId: string, params: RequestParams = {}) =>
      this.http.request<
        GetSprintResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/${sprintId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the fields of a specific sprint (`sprint_id`) within the workspace (`team_id`). Only the fields provided in the request body will be modified; omitted fields will remain unchanged.
     *
     * @tags Boards, Sprints
     * @name UpdateSprint
     * @summary Update a sprint
     * @request PATCH:/{team_id}/sprints/{sprint_id}
     */
    updateSprint: (teamId: string, sprintId: string, body: UpdateSprintRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateSprintResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/${sprintId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified sprint (`sprint_id`) within the workspace (`team_id`). This operation is irreversible and removes the sprint and its associated data.
     *
     * @tags Boards, Sprints
     * @name DeleteSprint
     * @summary Delete a sprint
     * @request DELETE:/{team_id}/sprints/{sprint_id}
     */
    deleteSprint: (teamId: string, sprintId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/${sprintId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Creates a branch-specific version control system (VCS) automation for sprint workflows within the specified project (`project_id`) and workspace (`team_id`). Requires the branch name, which must be 1-250 characters long and follow the pattern ^[a-zA-Z0-9._\/-]+$.
     *
     * @tags Boards, Sprints
     * @name CreateNewSprintVcsBranchAutomation
     * @summary Create a new branch specific VCS automation for sprints
     * @request POST:/{team_id}/sprints/vcs
     */
    createNewSprintVcsBranchAutomation: (
      teamId: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
      },
      body: CreateBranchAutomationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/vcs`,
        method: "POST",
        query: query,
        body: body,
        ...params,
      }),

    /**
     * @description Updates a branch-specific version control system (VCS) automation for sprint workflows within the specified project (`project_id`) and workspace (`team_id`). Requires the `branch` name, which must be 1-250 characters long and follow the pattern ^[a-zA-Z0-9._\/-]+$.
     *
     * @tags Boards, Sprints
     * @name UpdateBranchNameSprintVcsBranchAutomation
     * @summary Update the branch name for a branch specific VCS automation for sprints
     * @request PATCH:/{team_id}/sprints/vcs/{branch}
     */
    updateBranchNameSprintVcsBranchAutomation: (
      teamId: string,
      branch: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
      },
      body: UpdateVCSBranchNameRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/vcs/${branch}`,
        method: "PATCH",
        query: query,
        body: body,
        ...params,
      }),

    /**
     * @description Deletes a branch-specific VCS automation for sprints in the specified project (`project_id`) and workspace (`team_id`). The operation is irreversible and removes all associated configurations for the `branch`.
     *
     * @tags Boards
     * @name DeleteSprintVcsBranchAutomation
     * @summary Delete a branch specific VCS automation for sprints
     * @request DELETE:/{team_id}/sprints/vcs/{branch}
     */
    deleteSprintVcsBranchAutomation: (
      teamId: string,
      branch: string,
      query: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/sprints/vcs/${branch}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Fetches an array of `lists` (externally referenced as statuses) for the specified workspace (`team_id`). The endpoint supports filtering by the `archived` query parameter to return only archived lists.
     *
     * @tags Boards, Lists
     * @name GetLists
     * @summary Get lists
     * @request GET:/{team_id}/lists
     */
    getLists: (
      teamId: string,
      query: {
        /** whether to return archived lists only */
        archived: true;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetListsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new list within a workspace (`team_id`). The request body must include the `board_id` where the list should belong to.
     *
     * @tags Boards, Lists
     * @name CreateList
     * @summary Create a new list
     * @request POST:/{team_id}/lists
     */
    createList: (teamId: string, body: CreateListRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateListResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches detailed information about a list identified by `list_id` within a workspace specified by `team_id`. This includes list metadata, cards within the list, related users, and other associated data.
     *
     * @tags Boards, Lists
     * @name GetList
     * @summary Get a list
     * @request GET:/{team_id}/lists/{list_id}
     */
    getList: (teamId: string, listId: string, params: RequestParams = {}) =>
      this.http.request<
        GetListResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the specified list (`list_id`) in a workspace (`team_id`). The request body contains the fields to modify, while omitted fields remain unchanged.
     *
     * @tags Boards, Lists
     * @name UpdateList
     * @summary Update a list
     * @request PATCH:/{team_id}/lists/{list_id}
     */
    updateList: (teamId: string, listId: string, body: UpdateListRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateListResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified list (`list_id`) from a workspace (`team_id`). This operation is permanent and cannot be undone.
     *
     * @tags Boards, Lists
     * @name DeleteList
     * @summary Delete a list
     * @request DELETE:/{team_id}/lists/{list_id}
     */
    deleteList: (teamId: string, listId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Adds a new watcher to the specified list (`list_id`) within a workspace (`team_id`). The body parameter includes the `user_id` of the user to be added as a watcher (someone who will receive notifications based on the activities on the list).
     *
     * @tags Boards, Lists
     * @name AddListWatcher
     * @summary Add a watcher to a list
     * @request POST:/{team_id}/lists/{list_id}/watchers
     */
    addListWatcher: (teamId: string, listId: string, body: AddWatcherRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}/watchers`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Removes an existing watcher from the specified list (`list_id`) within a workspace (`team_id`).
     *
     * @tags Boards, Lists
     * @name DeleteListWatcher
     * @summary Delete a watcher from a list
     * @request DELETE:/{team_id}/lists/{list_id}/watchers/{user_id}
     */
    deleteListWatcher: (teamId: string, listId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}/watchers/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates the settings for a specific webhook notification type (`webhook_type`) for a list (`list_id`) in a workspace (`team_id`). Currently, the only supported webhook type is `slack_channel_webhook`. The request body must include the `board_id` (string) to indicate the board the list belongs to, and the webhook object, which defines the webhook configuration. The `card_created` (boolean) defines whether to send notifications when a card is added to the specified list.
     *
     * @tags Boards, Lists
     * @name UpdateWebhookNotificationList
     * @summary Toggle a webhook notification for a List in a Board
     * @request PATCH:/{team_id}/lists/{list_id}/webhooks/{webhook_type}
     */
    updateWebhookNotificationList: (
      teamId: string,
      listId: string,
      webhookType: string,
      body: ToggleListWebhookNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        ToggleListWebhookNotificationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/lists/${listId}/webhooks/${webhookType}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves cards within a team workspace. To return archived cards only, the `archived` query parameter must be set to `true`, otherwise it must be omitted.
     *
     * @tags Boards, Cards
     * @name GetCards
     * @summary Get cards
     * @request GET:/{team_id}/cards
     */
    getCards: (
      teamId: string,
      query: {
        /** Whether to return only archived cards */
        archived: true;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetCardsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows you to create a new card in a specified team workspace by providing a set of required and optional parameters. Key required fields include: - `title`: The name of the card - `list_id`: The ID of the list where the card will be placed - `board_id` or `sprint_id`: One of these fields must be provided to specify where the card belongs to The card's content has a character limit of 102400, and timestamps like `due_date` and `start_date` are specified as Unix timestamps in seconds. Enum fields include status (committed, started, completed, cancelled) and icon types (image, emoji, icon).
     *
     * @tags Boards, Cards
     * @name CreateCard
     * @summary Create a new card
     * @request POST:/{team_id}/cards
     */
    createCard: (teamId: string, body: CreateCardRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a list of available card templates within the specified workspace (`team_id`). The templates include metadata such as title, content, associated tags, members, checklists, and child card configurations. The optional query parameter `project_id` allows filtering templates by their associated project (also known as space). The response includes pagination details (cursor and count) for navigating large datasets.
     *
     * @tags Boards, Cards
     * @name GetCardTemplates
     * @summary Get card templates
     * @request GET:/{team_id}/cards/templates
     */
    getCardTemplates: (
      teamId: string,
      query?: {
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetCardTemplatesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/templates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new card template in the specified workspace (`team_id`). The request body includes mandatory fields like `title` and `card_title` and optional configurations for `content`, `priority`, `tags`, `checklists`, and child cards. Templates can be associated with specific projects (`project_ids`) for contextual availability. The response returns the created template's details, including its `id` and associated metadata.
     *
     * @tags Boards, Cards
     * @name CreateCardTemplate
     * @summary Create a new card template
     * @request POST:/{team_id}/cards/templates
     */
    createCardTemplate: (teamId: string, body: CreateCardTemplateRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateCardTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/templates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves details of a specific card template identified by `template_id`. The response includes template metadata like title, card_content, associated tags, members, checklists, child card configurations, and the projects (project_ids) where the template is available. Useful for viewing or editing specific templates within the team.
     *
     * @tags Boards, Cards
     * @name GetCardTemplate
     * @summary Get a card template
     * @request GET:/{team_id}/cards/templates/{template_id}
     */
    getCardTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        GetCardTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/templates/${templateId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the specified card template (`template_id`) within a workspace. Only fields provided in the request body are updated, leaving others unchanged. Editable fields include `title`, `content`, `priority`, `tags`, `members`, `checklists`, and associated `project_ids`. The response returns the updated template's details.
     *
     * @tags Boards, Cards
     * @name UpdateCardTemplate
     * @summary Update a card template
     * @request PATCH:/{team_id}/cards/templates/{template_id}
     */
    updateCardTemplate: (
      teamId: string,
      templateId: string,
      body: UpdateCardTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateCardTemplateResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/templates/${templateId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified card template (`template_id`) within the workspace (`team_id`). This action is irreversible and removes the template and all its associated metadata. A 204 response indicates successful deletion. Errors, such as insufficient permissions, return a detailed error response.
     *
     * @tags Boards
     * @name DeleteCardTemplate
     * @summary Delete a card template
     * @request DELETE:/{team_id}/cards/templates/{template_id}
     */
    deleteCardTemplate: (teamId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/templates/${templateId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a specific card, identified by its `card_id` within a workspace (`team_id`). The response includes metadata such as the card's title, content, status, owner, priority, associated tags, and links to related items. Child cards, linked cards, and any collaboration or external references are also included.
     *
     * @tags Boards, Cards
     * @name GetCard
     * @summary Get card details.
     * @request GET:/{team_id}/cards/{card_id}
     */
    getCard: (teamId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<
        GetCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a card's attributes or archive/unarchive it. **Archiving:** - If `archived=true`, the card is archived and other changes are ignored. - If `archived=false`, an archived card is unarchived and other changes are ignored. **Attribute Updates:** - Update fields like `title`, `priority`, `due_date`, `owner_id`, `estimate` without affecting unspecified fields. Fields not mentioned remain unchanged.
     *
     * @tags Boards, Cards
     * @name UpdateCard
     * @summary Update card attributes or archive/unarchive.
     * @request PATCH:/{team_id}/cards/{card_id}
     */
    updateCard: (teamId: string, cardId: string, body: UpdateCardRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific card, identified by its `card_id`, within the specified workspace (`team_id`). This action is irreversible and removes all associated data, including linked cards, child cards, tags, and external references. Use this operation cautiously, as it cannot be undone. A 204 response indicates successful deletion, while errors, such as insufficient permissions, return a detailed error response.
     *
     * @tags Boards, Cards
     * @name DeleteCard
     * @summary Delete a card
     * @request DELETE:/{team_id}/cards/{card_id}
     */
    deleteCard: (teamId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Moves a card (`card_id`) to a list in a new sprint, new board or new position within the same list. The request body specifies the target (sprint or board) where the card should be moved. A 200 response contains the details of the moved card.
     *
     * @tags Boards, Cards
     * @name MoveCard
     * @summary Move a card to a new sprint, board, or position within the same list
     * @request POST:/{team_id}/cards/{card_id}/move
     */
    moveCard: (teamId: string, cardId: string, body: MoveCardRequest, params: RequestParams = {}) =>
      this.http.request<
        MoveCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/move`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a duplicate of a specified card (`card_id`) within the same or another list/board. The copied card retains its content, child cards, and other attributes. The request body specifies the new card's details, such as the target list_id, board_id, and project_id. A 200 response contains the details of the copied card.
     *
     * @tags Boards, Cards
     * @name CreateCardCopy
     * @summary Create a new card copy
     * @request POST:/{team_id}/cards/{card_id}/copy
     */
    createCardCopy: (teamId: string, cardId: string, body: CreateCardCopyRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/copy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Converts a card (`card_id`) to an epic (externally referenced as a roadmap item or project) within the specified workspace (`team_id`). The request body includes the new epic's title, content, and other details. The operation is useful for promoting a card to a higher-level entity for better organization. A 200 response indicates the card was successfully converted to an epic.
     *
     * @tags Boards, Cards, Epics
     * @name ConvertCardToEpic
     * @summary Converts card to epic
     * @request POST:/{team_id}/cards/{card_id}/epic
     */
    convertCardToEpic: (teamId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<
        ConvertCardToEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/epic`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a watcher to the specified card (`card_id`) within a workspace (`team_id`). Watchers receive updates or notifications about the card's activities. The request body includes the `user_id` of the watcher. A 204 response indicates the watcher was successfully added.
     *
     * @tags Boards, Cards
     * @name AddCardWatcher
     * @summary Add a watcher to a card
     * @request POST:/{team_id}/cards/{card_id}/watchers
     */
    addCardWatcher: (teamId: string, cardId: string, body: AddWatcherRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/watchers`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Removes a watcher (`user_id`) from the specified card (`card_id`) within a workspace (`team_id`). This operation is useful for managing notification preferences. A 204 response indicates the watcher was successfully removed.
     *
     * @tags Boards
     * @name DeleteCardWatcher
     * @summary Delete a watcher from a card
     * @request DELETE:/{team_id}/cards/{card_id}/watchers/{user_id}
     */
    deleteCardWatcher: (teamId: string, cardId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/watchers/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Assigns a new member to the specified card (`card_id`) within a workspace (`team_id`). The request body includes the `user_id` of the member. This operation is essential for collaborative workflows where multiple users contribute to a card. A 204 response indicates the member was successfully added.
     *
     * @tags Boards, Cards
     * @name AddCardMember
     * @summary Add a member to a card
     * @request POST:/{team_id}/cards/{card_id}/members
     */
    addCardMember: (teamId: string, cardId: string, body: AddMemberRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/members`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes a specific member (`user_id`) from the specified card (`card_id`) within a workspace (`team_id`). This operation is used to un-assign a user from a card by updating the member list for a card. A 204 response indicates the member was successfully removed.
     *
     * @tags Boards, Cards
     * @name DeleteCardMember
     * @summary Remove a member from a card
     * @request DELETE:/{team_id}/cards/{card_id}/members/{user_id}
     */
    deleteCardMember: (teamId: string, cardId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/members/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Creates a new checklist for a specific card within a workspace. The checklist requires a `title` and `content`, provided in the request body. The `team_id` represents the workspace identifier, and `card_id` specifies the target card. The checklist will include fields such as the creation timestamp, the user ID of the creator, and optionally, a list of checklist items. A successful response returns the created checklist object, while errors return detailed messages, including an HTTP status code.
     *
     * @tags Boards, Cards, Checklists
     * @name CreateChecklist
     * @summary Create a new checklist
     * @request POST:/{team_id}/cards/{card_id}/checklists
     */
    createChecklist: (teamId: string, cardId: string, body: CreateChecklistRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateChecklistResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the details of a specific checklist identified by `checklist_id`. The `team_id` represents the workspace, and `card_id` specifies the card containing the checklist. The response includes metadata like the title, associated user ID, card ID, and a list of checklist items. Each item provides timestamps and status information. If the checklist does not exist or the user lacks permissions, an appropriate error is returned.
     *
     * @tags Boards, Cards, Checklists
     * @name GetChecklist
     * @summary Get a checklist
     * @request GET:/{team_id}/cards/{card_id}/checklists/{checklist_id}
     */
    getChecklist: (teamId: string, cardId: string, checklistId: string, params: RequestParams = {}) =>
      this.http.request<
        GetChecklistResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing checklist identified by `checklist_id`. The fields to update, such as title, content, or position, should be provided in the request body. Unmodified fields remain unchanged. The response includes the updated checklist object with metadata, such as timestamps for creation and updates. Errors may include invalid input or permission issues.
     *
     * @tags Boards, Cards, Checklists
     * @name UpdateChecklist
     * @summary Update a checklist
     * @request PATCH:/{team_id}/cards/{card_id}/checklists/{checklist_id}
     */
    updateChecklist: (
      teamId: string,
      cardId: string,
      checklistId: string,
      body: UpdateChecklistRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateChecklistResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specified checklist identified by `checklist_id`. The `team_id` and `card_id` parameters are used to locate the checklist. On success, the server returns a 204 No Content status. Errors, such as unauthorized access or invalid IDs, result in a detailed error message in the response.
     *
     * @tags Boards, Cards, Checklists
     * @name DeleteChecklist
     * @summary Delete a checklist
     * @request DELETE:/{team_id}/cards/{card_id}/checklists/{checklist_id}
     */
    deleteChecklist: (teamId: string, cardId: string, checklistId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Fetches all items for a specified checklist, using `checklist_id` to identify the target checklist. The response includes an array of checklist items, each containing details like title, content, checked status, associated user_id, and timestamps for creation and updates. Errors may occur if the checklist is not found or access is restricted.
     *
     * @tags Boards, Cards, Checklists
     * @name GetChecklistItems
     * @summary Get all checklist items
     * @request GET:/{team_id}/cards/{card_id}/checklists/{checklist_id}/items
     */
    getChecklistItems: (teamId: string, cardId: string, checklistId: string, params: RequestParams = {}) =>
      this.http.request<
        GetChecklistItemsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}/items`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new checklist item within a specified checklist (`checklist_id`) for a card (`card_id`). The request body must include the item's `title`, `content`, and optionally the `checked` status. The response includes the created checklist item's details, such as timestamps and associated user ID. Errors may occur if the checklist item is not created or the user lacks permissions.
     *
     * @tags Boards, Cards, Checklists
     * @name CreateChecklistItem
     * @summary Create a new checklist item
     * @request POST:/{team_id}/cards/{card_id}/checklists/{checklist_id}/items
     */
    createChecklistItem: (
      teamId: string,
      cardId: string,
      checklistId: string,
      body: CreateChecklistItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        CreateChecklistResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}/items`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing checklist item identified by `item_id`. The fields to update, such as title, content, or checked status, should be provided in the request body. Unmodified fields remain unchanged. The response includes the updated checklist item object with metadata. Errors may arise from invalid input or permission issues.
     *
     * @tags Boards, Cards, Checklists
     * @name UpdateChecklistItem
     * @summary Update a checklist item
     * @request PATCH:/{team_id}/cards/{card_id}/checklists/{checklist_id}/items/{item_id}
     */
    updateChecklistItem: (
      teamId: string,
      cardId: string,
      checklistId: string,
      itemId: string,
      body: ChecklistItem,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          checklist_item?: ChecklistItem;
        },
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}/items/${itemId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specified checklist item identified by `item_id`. The `team_id`, `card_id`, and `checklist_id` parameters are used to locate the item. On success, the server returns a 204 No Content status. Errors, such as unauthorized access or invalid IDs, result in a detailed error message in the response.
     *
     * @tags Boards, Cards, Checklists
     * @name DeleteChecklistItem
     * @summary Delete a checklist item
     * @request DELETE:/{team_id}/cards/{card_id}/checklists/{checklist_id}/items/{item_id}
     */
    deleteChecklistItem: (
      teamId: string,
      cardId: string,
      checklistId: string,
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/checklists/${checklistId}/items/${itemId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Creates a parent-child relationship between an existing card and a child card. The `card_id` represents the parent card, and the `child_card_id` is specified in the request body. The child card can belong to any project or board within the same workspace (`team_id`). The response includes the linked child card's details such as title, status, list association, and project or board information. Supported statuses for child cards include committed, started, completed, and cancelled.
     *
     * @tags Boards, Cards
     * @name AddChildCard
     * @summary Add a child card
     * @request POST:/{team_id}/cards/{card_id}/child_cards
     */
    addChildCard: (teamId: string, cardId: string, body: AddChildCardRequest, params: RequestParams = {}) =>
      this.http.request<
        AddChildCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/child_cards`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes the relationship between a parent card and a specified child card. The `card_id` represents the parent card, and the `child_card_id` identifies the nested card to be unlinked. Upon success, this operation returns a 204 status code. Errors ,such as permission issues or invalid card IDs, return a detailed error response.
     *
     * @tags Boards, Cards
     * @name RemoveChildCard
     * @summary Remove a child card
     * @request DELETE:/{team_id}/cards/{card_id}/child_cards/{child_card_id}
     */
    removeChildCard: (teamId: string, cardId: string, childCardId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/child_cards/${childCardId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Creates a relationship between a specified card (`card_id`) and another card using a defined link type (`blocks`, `blocked_by`, `related`, or `duplicates`). This relationship helps visualize dependencies or connections between cards. A 200 response includes details of the linked card.
     *
     * @tags Boards, Cards
     * @name AddLinkedCard
     * @summary Link a card with another
     * @request POST:/{team_id}/cards/{card_id}/linked_cards
     */
    addLinkedCard: (teamId: string, cardId: string, body: AddLinkedCardRequest, params: RequestParams = {}) =>
      this.http.request<
        AddLinkedCardResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/linked_cards`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes an existing link between the specified card (`card_id`) and a linked card (`linked_card_id`). This operation is used to remove relationships between cards. A 204 response indicates the link was successfully removed.
     *
     * @tags Boards, Cards
     * @name RemoveLinkedCard
     * @summary Remove linked card
     * @request DELETE:/{team_id}/cards/{card_id}/linked_cards/{linked_card_id}
     */
    removeLinkedCard: (teamId: string, cardId: string, linkedCardId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/linked_cards/${linkedCardId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Attaches one or more tags to a specified card (`card_id`) within a workspace (`team_id`). Tags are used to categorize or organize cards for easier filtering and tracking. The request body can include a single tag (id) or multiple tags (ids), but one of `id` or `ids` must be specified. A 204 response indicates that the tag(s) were successfully added.
     *
     * @tags Boards, Cards, Tags
     * @name AddCardTags
     * @summary Add tags to card
     * @request POST:/{team_id}/cards/{card_id}/tags
     */
    addCardTags: (teamId: string, cardId: string, body: AddTagRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/tags`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes a specific tag (`tag_id`) from the specified card (`card_id`) within a workspace (`team_id`). A 204 response indicates the tag was successfully removed.
     *
     * @tags Boards, Cards, Tags
     * @name RemoveCardTag
     * @summary Remove a tag from a card
     * @request DELETE:/{team_id}/cards/{card_id}/tags/{tag_id}
     */
    removeCardTag: (teamId: string, cardId: string, tagId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/tags/${tagId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates the hints or suggestions for a specific card (`card_id`) within a workspace (`team_id`). The request body includes a list of actions, such as ignoring specific related card suggestions or tags using `related_card_id` or `tag_slug`.
     *
     * @tags Boards, Cards
     * @name UpdateTagHints
     * @summary Update card hints
     * @request POST:/{team_id}/cards/{card_id}/hints
     */
    updateTagHints: (teamId: string, cardId: string, body: UpdateCardHintsRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/cards/${cardId}/hints`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetch a list of all epics (projects) within a workspace (`team_id`). Use this endpoint to retrieve the high-level projects, their status and if they are assigned to different individuals or teams.
     *
     * @tags Boards
     * @name GetEpics
     * @summary Get epics
     * @request GET:/{team_id}/epics
     */
    getEpics: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetEpicsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new epic (referred to externally as a "Project") in a workspace (`team_id`). Specify essential properties such as the title, list ID (status), and optional fields like icon, content, due date, priority, and owner. Customize the epic's icon and assign roles to team members. This endpoint enables breaking down projects into smaller tasks (cards) for more effective planning and progress tracking.
     *
     * @tags Boards
     * @name CreateEpic
     * @summary Create a new epic
     * @request POST:/{team_id}/epics
     */
    createEpic: (teamId: string, body: CreateEpicRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new epics list in a workspace (`team_id`). Specify essential properties such as the title, position, icon, behavior (e.g., backlog, started, completed),or color. This endpoint allows customization of how epics are categorized and displayed.
     *
     * @tags Boards
     * @name CreateEpicsList
     * @summary Create a new epics list
     * @request POST:/{team_id}/epics/lists
     */
    createEpicsList: (teamId: string, body: CreateEpicsListRequest, params: RequestParams = {}) =>
      this.http.request<CreateListResponse, any>({
        path: `/${teamId}/epics/lists`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Modify an epics list in a workspace (`team_id`). Update fields such as the title, position, icon, behavior (e.g., backlog, started, completed), or color. This endpoint allows customization of how epics are categorized and displayed.
     *
     * @tags Boards
     * @name UpdateEpicsList
     * @summary Update an epics list
     * @request PATCH:/{team_id}/epics/lists/{list_id}
     */
    updateEpicsList: (teamId: string, listId: string, body: UpdateListRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateListResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/lists/${listId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch all cards associated with an epic (project) in a workspace (`team_id`). Use this endpoint to retrieve tasks (cards) and their status assigned to different teams or individuals in various spaces.
     *
     * @tags Boards
     * @name GetAllCardsForEpic
     * @summary Get all cards for an epic
     * @request GET:/{team_id}/epics/{epic_id}/cards
     */
    getAllCardsForEpic: (teamId: string, epicId: string, params: RequestParams = {}) =>
      this.http.request<
        GetAllCardsForEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}/cards`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Associate an existing a card to an epic (project) in a workspace (`team_id`). Specify the card ID and the epic ID to link the card to the epic. This endpoint enables streamlined management of high-level project goals.
     *
     * @tags Boards
     * @name AddCardToEpic
     * @summary Add a card to an epic
     * @request POST:/{team_id}/epics/{epic_id}/cards/{card_id}
     */
    addCardToEpic: (teamId: string, epicId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<
        AddCardToEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}/cards/${cardId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Disassociate a card from an epic (project). This operation ensures that tasks are only linked to relevant epics for improved organization.
     *
     * @tags Boards
     * @name RemoveCardFromEpic
     * @summary Remove a card from an epic
     * @request DELETE:/{team_id}/epics/{epic_id}/cards/{card_id}
     */
    removeCardFromEpic: (teamId: string, epicId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}/cards/${cardId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve all details about an epic (project) in a workspace (`team_id`). Use this endpoint to see the description, progress, tasks and other metadata about a project.
     *
     * @tags Boards
     * @name GetEpicCard
     * @summary Get an epic card
     * @request GET:/{team_id}/epics/{epic_id}
     */
    getEpicCard: (teamId: string, epicId: string, params: RequestParams = {}) =>
      this.http.request<
        GetEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Modify an epic (project) in a workspace (`team_id`). Update fields such as the title, content, due date, priority, and members. Use this endpoint to keep epic details aligned with project updates or changes.
     *
     * @tags Boards
     * @name UpdateEpic
     * @summary Update an epic
     * @request PATCH:/{team_id}/epics/{epic_id}
     */
    updateEpic: (teamId: string, epicId: string, body: UpdateEpicRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateEpicResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an epic (project) in a workspace (`team_id`). This operation removes the project but cards associated with the epic remain intact.
     *
     * @tags Boards
     * @name DeleteEpic
     * @summary Delete an epic
     * @request DELETE:/{team_id}/epics/{epic_id}
     */
    deleteEpic: (teamId: string, epicId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/epics/${epicId}`,
        method: "DELETE",
        ...params,
      }),
  };
  search = {
    /**
     * @description Execute a search query across multiple workspace entities, including boards, cards, pages, and projects. Customize the search by specifying targeted fields like title or content, filtering by types of objects, or focusing on specific statuses. Additional options include filtering by project, controlling whether archived data is included, and choosing grouped or ungrouped results. This comprehensive search endpoint provides flexibility to locate relevant workspace data efficiently.
     *
     * @tags Search
     * @name GetSearch
     * @summary Get search results
     * @request GET:/{team_id}/search
     */
    getSearch: (
      teamId: string,
      query: {
        /** Search query */
        query: string;
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
        /** Types of object you would like to search against. includes all types if not specified */
        types?: "boards" | "cards" | "pages" | "projects";
        /** Fields you would like to target in the free text search */
        fields?: "title" | "content";
        /** Whether or not to include archived data. defaults to false */
        archived?: boolean;
        /** Card statuses to filter by */
        statuses?: "backlog" | "committed" | "started" | "completed" | "cancelled";
        /** Project ID is a numerical string that identifies a Project. This is externally referred to as a "Space". */
        project_id?: string;
        /** Whether the results will be grouped by type (as opposed to all under the 'results' prop). defaults to true */
        grouped?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        SearchResults,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch boards within a workspace that match a specified search query. The results can be filtered by archived status and paginated using a cursor. This endpoint is useful for locating boards based on specific attributes or names.
     *
     * @tags Search
     * @name GetSearchBoards
     * @summary Get boards
     * @request GET:/{team_id}/search/boards
     */
    getSearchBoards: (
      teamId: string,
      query?: {
        /** Search query. returns all results if not specified */
        query?: string;
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
        /** Whether or not to include archived data. defaults to false */
        archived?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetSearchBoardsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/search/boards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve lists within a workspace that match a specified search query. Use optional filters like `board_ids` to limit results to specific boards, set a pagination cursor, or control the maximum number of items returned. If no query is specified, all lists in the workspace are returned. This endpoint helps locate and filter workspace lists (statuses) across the entire workspace.
     *
     * @tags Search
     * @name GetSearchLists
     * @summary Get lists
     * @request GET:/{team_id}/search/lists
     */
    getSearchLists: (
      teamId: string,
      query?: {
        /** Search query. returns all results if not specified */
        query?: string;
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
        /** List of Board IDs (a Board ID is a numerical string that identifies a Board). */
        board_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetSearchListsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/search/lists`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve tags associated with a workspace that match a specified search query. Optional filters like board_ids allow narrowing results to tags used within specific boards. Supports pagination.
     *
     * @tags Search
     * @name GetSearchTags
     * @summary Get tags
     * @request GET:/{team_id}/search/tags
     */
    getSearchTags: (
      teamId: string,
      query?: {
        /** Search query. returns all results if not specified */
        query?: string;
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
        /** List of Board IDs (a Board ID is a numerical string that identifies a Board). */
        board_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetSearchTagsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/search/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  views = {
    /**
     * @description Fetches a list of views available to the user, including both private and shared workspace views. By default, only private views are retrieved, but shared views can be included using the shared query parameter.
     *
     * @tags Views
     * @name GetViews
     * @summary Get views
     * @request GET:/{team_id}/views
     */
    getViews: (
      teamId: string,
      query?: {
        /** Defaults to false to retrieve only private views */
        shared?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetViewsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows users to create a new view within their workspace by specifying filters and configurations for boards, cards, or pages. The request must include a name, type (board, card, or page), and optional filtering criteria such as projects, members, or time ranges. Shared views can be created by setting the shared parameter.
     *
     * @tags Views
     * @name ViewCreate
     * @summary Create a view
     * @request POST:/{team_id}/views
     */
    viewCreate: (teamId: string, body: CreateViewRequest, params: RequestParams = {}) =>
      this.http.request<
        View,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint provides a preview of results based on specified filters for boards, cards, or pages. The request includes a type parameter (board, card, or page) and supports advanced filtering criteria, such as time ranges, specific project or member associations, and sorting preferences. Pagination is supported via cursor and count parameters.
     *
     * @tags Views
     * @name ViewPreview
     * @summary Preview results
     * @request POST:/{team_id}/views/preview
     */
    viewPreview: (
      teamId: string,
      body: GetViewPreviewRequest,
      query?: {
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        ViewResults,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views/preview`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint fetches results for a saved view within a workspace. Users can retrieve data related to boards, cards, or pages, as defined by the view’s filters and configurations. Pagination is supported with cursor and count parameters.
     *
     * @tags Views
     * @name GetViewResults
     * @summary Get view results
     * @request GET:/{team_id}/views/{view_id}/results
     */
    getViewResults: (
      teamId: string,
      viewId: string,
      query?: {
        /** cursor for pagination */
        cursor?: string;
        /** max number of items to return. defaults to 25 */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        ViewResults,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views/${viewId}/results`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the details of a specific view by its ID. Users can examine the filters, type, and other configurations associated with the view.
     *
     * @tags Views
     * @name GetView
     * @summary Get view
     * @request GET:/{team_id}/views/{view_id}
     */
    getView: (teamId: string, viewId: string, params: RequestParams = {}) =>
      this.http.request<
        View,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views/${viewId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows users to update the configuration of an existing view by providing partial updates. Only the fields included in the request body will be modified; all other fields remain unchanged. Filters for boards, cards, or pages can be adjusted to reflect changes in projects, team members, or sorting preferences.
     *
     * @tags Views
     * @name ViewUpdate
     * @summary Update a view
     * @request PATCH:/{team_id}/views/{view_id}
     */
    viewUpdate: (teamId: string, viewId: string, body: UpdateViewRequest, params: RequestParams = {}) =>
      this.http.request<
        View,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views/${viewId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific view by its ID, removing it from the workspace. This action is irreversible and is intended for views that are no longer relevant or needed.
     *
     * @tags Views
     * @name ViewDelete
     * @summary Delete a view
     * @request DELETE:/{team_id}/views/{view_id}
     */
    viewDelete: (teamId: string, viewId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/views/${viewId}`,
        method: "DELETE",
        ...params,
      }),
  };
  activity = {
    /**
     * @description Fetch a list of notifications for a team member within a workspace (`team_id`). Notifications include activity updates, mentions, and other important events. Use query parameters to filter by `unread` or `unseen` notifications.
     *
     * @tags Activity
     * @name GetNotifications
     * @summary Get team member notifications
     * @request GET:/{team_id}/notifications
     */
    getNotifications: (
      teamId: string,
      query?: {
        /** Notification type to return, if unset will return all notifications regardless of 'read' or 'seen' status */
        filter?: "unseen" | "unread";
        /** cursor for pagination */
        cursor?: string;
        /** max number of notifications to return, defaults to 25 if unset */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        NotificationResults,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the status of multiple notifications for a team member within a workspace. Mark notifications as read or unseen to manage activity updates and mentions.
     *
     * @tags Activity
     * @name UpdateNotifications
     * @summary Batch update notifications for team member
     * @request PATCH:/{team_id}/notifications
     */
    updateNotifications: (teamId: string, body: UpdateNotificationsRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve the count of unseen or unread notifications for a team member within a workspace. Specify the filter parameter to focus on a specific type of notification status.
     *
     * @tags Activity
     * @name GetNotificationCount
     * @summary Get a team member's notification count
     * @request GET:/{team_id}/notifications/count
     */
    getNotificationCount: (
      teamId: string,
      query: {
        filter: "unseen" | "unread";
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetNotificationCountResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the status of a specific notification within a workspace (`team_id`). Mark notifications as read or interacted to keep track of viewed activity.
     *
     * @tags Activity
     * @name UpdateNotification
     * @summary Update a notification by ID
     * @request PATCH:/{team_id}/notifications/{id}
     */
    updateNotification: (teamId: string, id: string, body: UpdateNotificationRequest, params: RequestParams = {}) =>
      this.http.request<
        Notification,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/${id}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch the current notification digest for a workspace. Digests summarize recent activity across projects, cards, and other workspace entities, providing a consolidated view of notifications.
     *
     * @tags Activity
     * @name GetNotificationDigest
     * @summary Get a notification digest
     * @request GET:/{team_id}/notifications/digests
     */
    getNotificationDigest: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNotificationDigestResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/digests`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Customize the delivery of notification digests for a workspace. Specify the time of day for digest delivery, enable or disable the digest. This feature ensures notification delivery aligns with team members’ preferences and schedules.
     *
     * @tags Activity
     * @name UpdateNotificationDigest
     * @summary Update a notification digest
     * @request PATCH:/{team_id}/notifications/digests
     */
    updateNotificationDigest: (teamId: string, body: UpdateNotificationDigestRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateNotificationDigestResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/digests`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch the current notification digest settings for a workspace. These settings determine how and when notification digests are sent to team members. The response includes preferences for various notification triggers, such as activity on cards, pages, or projects, allowing team members to tailor their digest experience.
     *
     * @tags Activity
     * @name GetNotificationDigestSettings
     * @summary Get notification digest settings
     * @request GET:/{team_id}/notifications/digests/settings
     */
    getNotificationDigestSettings: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNotificationDigestSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/digests/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the notification digest settings for a workspace. These settings determine how and when notification digests are sent to team members. The request should include preferences for various notification triggers, such as activity on cards,pages, or projects, allowing team members to tailor their digest experience.
     *
     * @tags Activity
     * @name UpdateNotificationDigestSettings
     * @summary Update notification digest settings
     * @request PATCH:/{team_id}/notifications/digests/settings
     */
    updateNotificationDigestSettings: (
      teamId: string,
      body: UpdateNotificationDigestSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateNotificationDigestSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/digests/settings`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch the current email notifications settings for a workspace. The response indicates whether they are enabled and which notifications should be sent to the user by email.
     *
     * @tags Activity
     * @name GetEmailNotifications
     * @summary Get email notifications
     * @request GET:/{team_id}/notifications/emails
     */
    getEmailNotifications: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetNotificationEmailsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/emails`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the email notifications settings for a workspace. The request can enable or disable email notifications completely or choose specific notification types to receive. The response indicates whether they are enabled and which notifications should be sent to the user by email.
     *
     * @tags Activity
     * @name UpdateEmailNotifications
     * @summary Update email notifications
     * @request PATCH:/{team_id}/notifications/emails
     */
    updateEmailNotifications: (teamId: string, body: UpdateNotificationEmailsRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateNotificationEmailsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/notifications/emails`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  favourites = {
    /**
     * @description Fetch a list of the current user's favourite items within a workspace. Favourites may include various resource types such as boards, cards, pages, sprints, and folders. This endpoint provides quick access to the user's most frequently accessed resources for efficient navigation and management.
     *
     * @tags Favourites
     * @name GetFavourites
     * @summary get current user's favourites
     * @request GET:/{team_id}/favourites
     */
    getFavourites: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetFavouritesResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/favourites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Add a resource or folder to the current user's favourites list. Specify the resource_type (e.g., card, board, page, folder) and other optional parameters like parent_id for nesting under a specific folder and position for ordering.
     *
     * @tags Favourites
     * @name AddFavourite
     * @summary add a favourite
     * @request POST:/{team_id}/favourites
     */
    addFavourite: (teamId: string, body: AddFavouriteRequest, params: RequestParams = {}) =>
      this.http.request<
        AddFavouriteResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/favourites`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Modify the properties of an existing favourite. Update attributes such as the `parent_id` to nest the resource under a specific folder, position to reorder it within a folder, or title to rename it. Use this endpoint to maintain an organized and personalized favourites structure.
     *
     * @tags Favourites
     * @name UpdateFavourite
     * @summary update favourite
     * @request PATCH:/{team_id}/favourites/{resource}
     */
    updateFavourite: (teamId: string, resource: string, body: UpdateFavouriteRequest, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/favourites/${resource}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Remove a resource or folder from the current user's favourites list (Provide the full resource identifier to target the item). This action will remove the specified resource from the user's favourites list. Use this endpoint to declutter the favourites list and maintain an organized workspace.
     *
     * @tags Favourites
     * @name DeleteFavourite
     * @summary delete user's favourite
     * @request DELETE:/{team_id}/favourites/{resource}
     */
    deleteFavourite: (teamId: string, resource: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/favourites/${resource}`,
        method: "DELETE",
        ...params,
      }),
  };
  importer = {
    /**
     * @description Fetch a list of all past and current import operations for a specific workspace. The response includes metadata about each import, such as its source, progress status, and associated workspace or project details. Use this endpoint to monitor import history or confirm the presence of an existing import
     *
     * @tags Importer
     * @name GetImports
     * @summary Get a list of past or current import operations
     * @request GET:/{team_id}/imports
     */
    getImports: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetImportsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/imports`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Initiate a new import operation to bring data into the workspace from supported external platforms like Trello, Jira, or Shortcut. Provide authentication credentials and specify the source platform for the import. For example: - Trello: Supply an API key and token. - Jira: Provide credentials, including email and hostname. - Shortcut: Use an API token. The response returns the details of the newly created import operation, which can be further configured or queued for processing.
     *
     * @tags Importer
     * @name CreateImport
     * @summary Set up a new import
     * @request POST:/{team_id}/imports
     */
    createImport: (teamId: string, body: CreateImportRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateImportResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/imports`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Modify the settings for a specific import operation within a workspace (`team_id`). This endpoint allows updates such as enabling or disabling the import of card covers and attachments, mapping users from the source to the target workspace, and configuring board mappings. Changes apply to ongoing or incomplete imports For user mapping, specify source and target user details, and optionally assign roles. Board mapping enables associating source boards with target projects. Use this endpoint to refine import configurations before initiating the process.
     *
     * @tags Importer
     * @name UpdateImportSettings
     * @summary Update import settings
     * @request PATCH:/{team_id}/imports/{import_id}
     */
    updateImportSettings: (teamId: string, importId: string, body: UpdateImportRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateImportResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/imports/${importId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Start processing a configured import operation for a specific workspace. This endpoint moves the import into the processing queue, beginning the transfer of data from the source platform to the workspace. Ensure all configurations, such as user and board mappings, are correctly set before invoking this endpoint
     *
     * @tags Importer
     * @name EnqueueImport
     * @summary Start the import process
     * @request POST:/{team_id}/imports/{import_id}/queue
     */
    enqueueImport: (teamId: string, importId: string, params: RequestParams = {}) =>
      this.http.request<
        QueueImportResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/imports/${importId}/queue`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * @description Fetches a report based on the provided criteria. Specify the report type (e.g., "cfd"), the associated board, and the date range for the report. The response contains data relevant to the selected report type, offering insights into team or project metrics.
     *
     * @tags Reports
     * @name ReportsDetail
     * @summary Get a report
     * @request GET:/{team_id}/reports
     */
    reportsDetail: (
      teamId: string,
      query: {
        /** Report type */
        type: "cfd";
        /** Board ID */
        board_id: string;
        /**
         * Start date of report
         * @format 1676643335
         */
        from: string;
        /**
         * End date of report
         * @format 1676643335
         */
        to: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetTimeReportResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/reports`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  ai = {
    /**
     * @description This endpoint returns a LLM generated response for a given request. It additionally supports streaming returning [CreateLLMTaskStreamChunk](#definitions/CreateLLMTaskStreamChunk) as the json schema.
     *
     * @tags AI
     * @name CreateLlmTask
     * @summary Request an LLM task
     * @request POST:/{team_id}/ai/llm
     */
    createLlmTask: (teamId: string, body: CreateLLMTaskRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateLLMTaskResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/llm`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint returns a LLM generated response for a given question. It additionally supports streaming returning [AskAIStreamChunk](#definitions/AskAIStreamChunk) as the json schema.
     *
     * @tags AI
     * @name AskAi
     * @summary Ask a question
     * @request POST:/{team_id}/ai/ask
     */
    askAi: (teamId: string, body: AskAIRequest, params: RequestParams = {}) =>
      this.http.request<
        AskAIResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/ask`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint creates a new AI agent in the workspace (`team_id`).
     *
     * @tags AI
     * @name CreateAiAgent
     * @summary Create a new AI agent
     * @request POST:/{team_id}/ai/agents
     */
    createAiAgent: (teamId: string, body: CreateAIAgentRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateAIAgentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Return all AI agents that are created for the workspace (`team_id`).
     *
     * @tags AI
     * @name GetAiAgents
     * @summary Get all AI agents in the workspace
     * @request GET:/{team_id}/ai/agents
     */
    getAiAgents: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetAIAgentsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a specific AI Agent for a team by ID.
     *
     * @tags AI
     * @name GetAiAgent
     * @summary Get an AI Agent
     * @request GET:/{team_id}/ai/agents/{agent_id}
     */
    getAiAgent: (teamId: string, agentId: string, params: RequestParams = {}) =>
      this.http.request<
        GetAIAgentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an AI Agent with the provided fields. All omitted fields are left unmodified.
     *
     * @tags AI
     * @name UpdateAiAgent
     * @summary Update an AI Agent
     * @request PATCH:/{team_id}/ai/agents/{agent_id}
     */
    updateAiAgent: (teamId: string, agentId: string, body: UpdateAIAgentRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateAIAgentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes an AI Agent.
     *
     * @tags AI
     * @name DeleteAiAgent
     * @summary Delete an AI Agent
     * @request DELETE:/{team_id}/ai/agents/{agent_id}
     */
    deleteAiAgent: (teamId: string, agentId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Attach the AI Agent (`agent_id`) to the resource specified in the request body.
     *
     * @tags AI
     * @name AttachAiAgentToResource
     * @summary Attach the AI Agent to the specified resource.
     * @request POST:/{team_id}/ai/agents/{agent_id}/attachments
     */
    attachAiAgentToResource: (
      teamId: string,
      agentId: string,
      body: AttachAIAgentRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        AttachAIAgentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/attachments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Detach the AI Agent (`agent_attachment_id`) from the resource specified in the request body.
     *
     * @tags AI
     * @name DetachAiAgentFromResource
     * @summary Detach an AI Agent from a resource
     * @request DELETE:/{team_id}/ai/agents/{agent_id}/attachments/{agent_attachment_id}
     */
    detachAiAgentFromResource: (
      teamId: string,
      agentId: string,
      agentAttachmentId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        DetachAIAgentResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/attachments/${agentAttachmentId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all Runs for the specific AI Agent.
     *
     * @tags AI
     * @name GetAiAgentRuns
     * @summary Get all AI Agent Runs
     * @request GET:/{team_id}/ai/agents/{agent_id}/runs
     */
    getAiAgentRuns: (
      teamId: string,
      agentId: string,
      query?: {
        /** Cursor for pagination */
        cursor?: string;
        /** Max number of items to return, defaults to 20 if unset */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetAIAgentRunsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/runs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetch the conversational prompt iterations with the AI Assistant for the specified AI Agent (`agent_id`). This endpoint returns the history of messages and the ongoing conversation, enabling users to create and refine the AI Agent prompt by interacting with the AI Assistant.
     *
     * @tags AI
     * @name GetAiAgentPromptIterations
     * @summary Retrieve the AI Agent's Conversational Prompt Iterations
     * @request GET:/{team_id}/ai/agents/{agent_id}/prompts
     */
    getAiAgentPromptIterations: (teamId: string, agentId: string, params: RequestParams = {}) =>
      this.http.request<
        GetAIAgentPromptIterationsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/prompts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new iteration with the AI Assistant for the specified AI Agent (`agent_id`). This action adds a new message to the ongoing conversation, enabling users to refine the AI Agent's prompt.
     *
     * @tags AI
     * @name AddAiAgentPromptIteration
     * @summary Create a new iteration with the AI Agent's Conversational Assistant
     * @request POST:/{team_id}/ai/agents/{agent_id}/prompts
     */
    addAiAgentPromptIteration: (
      teamId: string,
      agentId: string,
      body: AddAIAgentPromptIterationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        AddAIAgentPromptIterationResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/prompts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently delete the conversation with the AI Assistant for the specified AI Agent (`agent_id`).
     *
     * @tags AI
     * @name DeleteAiAgentPromptHistory
     * @summary Delete (reset) the conversation history with the AI Agent's Assistant
     * @request DELETE:/{team_id}/ai/agents/{agent_id}/prompts
     */
    deleteAiAgentPromptHistory: (teamId: string, agentId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/agents/${agentId}/prompts`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Search for similar items using vector search. The provided string will be converted to a vector. The search will return relevant chunks of the most similar items to the provided vector (RAG search).
     *
     * @tags AI
     * @name VectorSearch
     * @summary Search for similar items using vector search (RAG search)
     * @request POST:/{team_id}/ai/vector_search
     */
    vectorSearch: (teamId: string, body: VectorSearchRequest, params: RequestParams = {}) =>
      this.http.request<
        VectorSearchResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/vector_search`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a list of suggested actions given a resource type and ID.
     *
     * @tags AI
     * @name GetActions
     * @summary Get suggested actions for a resource
     * @request GET:/{team_id}/ai/actions
     */
    getActions: (
      teamId: string,
      query?: {
        /** Note ID to fetch actions for */
        note_id?: string;
        /** AI Note ID to fetch actions for */
        ai_note_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        GetAIActionsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/actions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates AI actions based on the provided parameters.
     *
     * @tags AI
     * @name CreateAiActions
     * @summary Generate AI actions
     * @request POST:/{team_id}/ai/actions
     */
    createAiActions: (teamId: string, body: CreateAIActionsRequest, params: RequestParams = {}) =>
      this.http.request<CreateAIActionsResponse, Error>({
        path: `/${teamId}/ai/actions`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates specific fields of an AI-generated action identified by `action_id`. Currently supports updating the status and card_id properties. All omitted fields are left unmodified.
     *
     * @tags AI
     * @name UpdateAiAction
     * @summary Update AI action
     * @request PATCH:/{team_id}/ai/actions/{action_id}
     */
    updateAiAction: (teamId: string, actionId: string, body: UpdateAIActionRequest, params: RequestParams = {}) =>
      this.http.request<
        UpdateAIActionResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/actions/${actionId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all the configured settings for the team reports within a workspace.
     *
     * @tags AI
     * @name GetAllTeamReportsSettings
     * @summary Get Team Reports Settings
     * @request GET:/{team_id}/ai/team-reports/settings
     */
    getAllTeamReportsSettings: (teamId: string, params: RequestParams = {}) =>
      this.http.request<
        GetAllReportsSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create the reports settings for a workspace. This endpoint allows you to configure the team reports, including scheduling, frequency, and participants.
     *
     * @tags AI
     * @name CreateTeamReportsSettings
     * @summary Create Team Reports Settings
     * @request POST:/{team_id}/ai/team-reports/settings
     */
    createTeamReportsSettings: (teamId: string, body: CreateReportsSettingsRequest, params: RequestParams = {}) =>
      this.http.request<
        CreateReportsSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/settings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the specified report settings for the team reports within a workspace.
     *
     * @tags AI
     * @name GetTeamReportsSettings
     * @summary Get Team Reports Settings
     * @request GET:/{team_id}/ai/team-reports/settings/{settings_id}
     */
    getTeamReportsSettings: (teamId: string, settingsId: string, params: RequestParams = {}) =>
      this.http.request<
        GetReportsSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/settings/${settingsId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the specified reports' settings within the workspace. This endpoint allows you to modify the configuration settings for the team reports, including scheduling, frequency, and participants. All omitted fields are left unmodified.
     *
     * @tags AI
     * @name UpdateTeamReportsSettings
     * @summary Update Team Reports Settings
     * @request PATCH:/{team_id}/ai/team-reports/settings/{settings_id}
     */
    updateTeamReportsSettings: (
      teamId: string,
      settingsId: string,
      body: UpdateReportsSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateReportsSettingsResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/settings/${settingsId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified report settings for the team reports within a workspace.
     *
     * @tags AI
     * @name DeleteTeamReportsSettings
     * @summary Delete Team Reports Settings
     * @request DELETE:/{team_id}/ai/team-reports/settings/{settings_id}
     */
    deleteTeamReportsSettings: (teamId: string, settingsId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/settings/${settingsId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the user's daily report for the current day.
     *
     * @tags AI
     * @name GetUserDailyReport
     * @summary Retrieve a user's daily report
     * @request GET:/{team_id}/ai/team-reports/users/{user_id}/daily-report
     */
    getUserDailyReport: (teamId: string, userId: string, params: RequestParams = {}) =>
      this.http.request<
        GetDailyReportResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/users/${userId}/daily-report`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the user's daily report. The available fields are the answers to the questions or the user's note/clarification/addition to the AI generated summary.
     *
     * @tags AI
     * @name UpdateUserDailyReport
     * @summary Update a user's daily report
     * @request PATCH:/{team_id}/ai/team-reports/users/{user_id}/daily-report
     */
    updateUserDailyReport: (
      teamId: string,
      userId: string,
      body: UpdateDailyReportByIDRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        UpdateDailyReportByIDResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/users/${userId}/daily-report`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the user's daily report for the specified day (ID).
     *
     * @tags AI
     * @name GetUserDailyReportById
     * @summary Retrieve a user's specified daily report
     * @request GET:/{team_id}/ai/team-reports/users/{user_id}/daily-report/{report_id}
     */
    getUserDailyReportById: (teamId: string, userId: string, reportId: string, params: RequestParams = {}) =>
      this.http.request<
        GetDailyReportByIDResponse,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/users/${userId}/daily-report/${reportId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the user's daily report for the specified day (ID).
     *
     * @tags AI
     * @name DeleteUserDailyReportById
     * @summary Delete a user's specified daily report
     * @request DELETE:/{team_id}/ai/team-reports/users/{user_id}/daily-report/{report_id}
     */
    deleteUserDailyReportById: (teamId: string, userId: string, reportId: string, params: RequestParams = {}) =>
      this.http.request<
        void,
        {
          error?: Error;
        }
      >({
        path: `/${teamId}/ai/team-reports/users/${userId}/daily-report/${reportId}`,
        method: "DELETE",
        ...params,
      }),
  };
}
